"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ailogo/analyser/analyser.proto
 * 标准化登记与调用，包括标准值，标准口径，更新追踪
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateRespState = exports.SpaceTagObjectType = exports.SpaceSpaceKind = exports.SpaceSort = exports.SpacePrivilegeType = exports.SpaceOrderBy = exports.ShortlinkMappingType = exports.SampleOpCode = exports.ResearchreportWatermarkType = exports.ResearchreportTeamRole = exports.ResearchreportPrivilegeType = exports.ResearchreportFieldType = exports.ResearchreportAuditType = exports.ReportTeamRole = exports.ReportSort = exports.ReportOrderBy = exports.ReportElementKind = exports.QueryRequestsort = exports.ProtobufNullValue = exports.PermissionaclSortBy = exports.PermissionaclCheckType = exports.OrganizationRole = exports.OrganizationMemberUnitType = exports.OrganizationChangeMemberRoleRequestRole = exports.OcrCovidResultType = exports.OaavatarOaavatarType = exports.NoticeActionType = exports.IpcityEventKind = exports.GroupGroupStatus = exports.GroupGroupRewardType = exports.GroupGroupDeliverSource = exports.DashboardConditionType = exports.ComplainComplainStatus = exports.ComplainComplainOptionType = exports.ComplainComplainOperationResultCode = exports.CommonUserType = exports.CommonEntityType = exports.CommonApplicationType = exports.CommentShowType = exports.CertificationStatus = exports.BindingUserStatus = exports.BindingKind = exports.AuditBriefStatus = exports.AssetsApprovalOpinion = exports.ArticleTeamRole = exports.ArticleSort = exports.ArticlePrivilegeType = exports.ArticleOrderBy = exports.ArticleAuditType = exports.ArticleArticleType = void 0;
exports.CtmsApi = exports.CtmsApiFactory = exports.CtmsApiFp = exports.CtmsApiAxiosParamCreator = exports.ComplainApi = exports.ComplainApiFactory = exports.ComplainApiFp = exports.ComplainApiAxiosParamCreator = exports.CommentApi = exports.CommentApiFactory = exports.CommentApiFp = exports.CommentApiAxiosParamCreator = exports.CodeverifyApi = exports.CodeverifyApiFactory = exports.CodeverifyApiFp = exports.CodeverifyApiAxiosParamCreator = exports.ChatOpsApi = exports.ChatOpsApiFactory = exports.ChatOpsApiFp = exports.ChatOpsApiAxiosParamCreator = exports.CertificationApi = exports.CertificationApiFactory = exports.CertificationApiFp = exports.CertificationApiAxiosParamCreator = exports.BindingApi = exports.BindingApiFactory = exports.BindingApiFp = exports.BindingApiAxiosParamCreator = exports.ArticleApi = exports.ArticleApiFactory = exports.ArticleApiFp = exports.ArticleApiAxiosParamCreator = exports.ApplicationApi = exports.ApplicationApiFactory = exports.ApplicationApiFp = exports.ApplicationApiAxiosParamCreator = exports.WeixinWeixinMenuButtonType = exports.WJProxyReqHTTPMethod = exports.VariableKind = exports.UseractionShareChannel = exports.UseractionActionType = exports.UserUserInfoType = exports.UserKind = exports.UnbindProviderReqProvider = exports.TtqSortType = exports.TidalbiMetricStatus = exports.TidalbiMetricInternalType = exports.TidalbiDimension = exports.TextsearchUpdateDataType = exports.TeamUserRoleRolePermission = void 0;
exports.OcrApiFp = exports.OcrApiAxiosParamCreator = exports.OaavatarApi = exports.OaavatarApiFactory = exports.OaavatarApiFp = exports.OaavatarApiAxiosParamCreator = exports.NpsApi = exports.NpsApiFactory = exports.NpsApiFp = exports.NpsApiAxiosParamCreator = exports.NoticeApi = exports.NoticeApiFactory = exports.NoticeApiFp = exports.NoticeApiAxiosParamCreator = exports.MicroproxyApi = exports.MicroproxyApiFactory = exports.MicroproxyApiFp = exports.MicroproxyApiAxiosParamCreator = exports.MessageApi = exports.MessageApiFactory = exports.MessageApiFp = exports.MessageApiAxiosParamCreator = exports.LikeApi = exports.LikeApiFactory = exports.LikeApiFp = exports.LikeApiAxiosParamCreator = exports.IpcityApi = exports.IpcityApiFactory = exports.IpcityApiFp = exports.IpcityApiAxiosParamCreator = exports.HttpProxyApi = exports.HttpProxyApiFactory = exports.HttpProxyApiFp = exports.HttpProxyApiAxiosParamCreator = exports.HelloApi = exports.HelloApiFactory = exports.HelloApiFp = exports.HelloApiAxiosParamCreator = exports.FeedApi = exports.FeedApiFactory = exports.FeedApiFp = exports.FeedApiAxiosParamCreator = exports.DocumentApi = exports.DocumentApiFactory = exports.DocumentApiFp = exports.DocumentApiAxiosParamCreator = exports.DashboardApi = exports.DashboardApiFactory = exports.DashboardApiFp = exports.DashboardApiAxiosParamCreator = void 0;
exports.TextSearchApi = exports.TextSearchApiFactory = exports.TextSearchApiFp = exports.TextSearchApiAxiosParamCreator = exports.StandardApi = exports.StandardApiFactory = exports.StandardApiFp = exports.StandardApiAxiosParamCreator = exports.SpaceApi = exports.SpaceApiFactory = exports.SpaceApiFp = exports.SpaceApiAxiosParamCreator = exports.ShortLinkApi = exports.ShortLinkApiFactory = exports.ShortLinkApiFp = exports.ShortLinkApiAxiosParamCreator = exports.SearchApi = exports.SearchApiFactory = exports.SearchApiFp = exports.SearchApiAxiosParamCreator = exports.SampleServiceApi = exports.SampleServiceApiFactory = exports.SampleServiceApiFp = exports.SampleServiceApiAxiosParamCreator = exports.ResearchReportApi = exports.ResearchReportApiFactory = exports.ResearchReportApiFp = exports.ResearchReportApiAxiosParamCreator = exports.ReportApi = exports.ReportApiFactory = exports.ReportApiFp = exports.ReportApiAxiosParamCreator = exports.RbacApi = exports.RbacApiFactory = exports.RbacApiFp = exports.RbacApiAxiosParamCreator = exports.PermissionaclApi = exports.PermissionaclApiFactory = exports.PermissionaclApiFp = exports.PermissionaclApiAxiosParamCreator = exports.PermissionApi = exports.PermissionApiFactory = exports.PermissionApiFp = exports.PermissionApiAxiosParamCreator = exports.OrganizationApi = exports.OrganizationApiFactory = exports.OrganizationApiFp = exports.OrganizationApiAxiosParamCreator = exports.OcrApi = exports.OcrApiFactory = void 0;
exports.ZhishuproxyApi = exports.ZhishuproxyApiFactory = exports.ZhishuproxyApiFp = exports.ZhishuproxyApiAxiosParamCreator = exports.WJApi = exports.WJApiFactory = exports.WJApiFp = exports.WJApiAxiosParamCreator = exports.UseractionApi = exports.UseractionApiFactory = exports.UseractionApiFp = exports.UseractionApiAxiosParamCreator = exports.UserApi = exports.UserApiFactory = exports.UserApiFp = exports.UserApiAxiosParamCreator = exports.UrdesignerApi = exports.UrdesignerApiFactory = exports.UrdesignerApiFp = exports.UrdesignerApiAxiosParamCreator = exports.UploadApi = exports.UploadApiFactory = exports.UploadApiFp = exports.UploadApiAxiosParamCreator = exports.TtqApi = exports.TtqApiFactory = exports.TtqApiFp = exports.TtqApiAxiosParamCreator = exports.TidalBaseApi = exports.TidalBaseApiFactory = exports.TidalBaseApiFp = exports.TidalBaseApiAxiosParamCreator = exports.TidalBIApi = exports.TidalBIApiFactory = exports.TidalBIApiFp = exports.TidalBIApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.ArticleArticleType = {
    Empty: 'empty',
    RichText: 'rich_text',
    Markdown: 'markdown',
    Plain: 'plain'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ArticleAuditType = {
    Invalid: 'Invalid',
    Accept: 'Accept',
    Reject: 'Reject'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ArticleOrderBy = {
    Default: 'default',
    CreatedAt: 'created_at',
    UpdatedAt: 'updated_at',
    Views: 'views',
    Comment: 'comment',
    Collect: 'collect',
    Like: 'like',
    Hot: 'hot'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ArticlePrivilegeType = {
    Public: 'Public',
    Limited: 'Limited',
    OnlyForTeam: 'OnlyForTeam'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ArticleSort = {
    Desc: 'desc',
    Asc: 'asc'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ArticleTeamRole = {
    Nopermission: 'NOPERMISSION',
    Member: 'MEMBER',
    Admin: 'ADMIN'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AssetsApprovalOpinion = {
    Approve: 'approve',
    Reject: 'reject'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AuditBriefStatus = {
    Reject: 'reject',
    Accept: 'accept'
};
/**
 * - WJ: 问卷
 * @export
 * @enum {string}
 */
exports.BindingKind = {
    Wj: 'WJ'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.BindingUserStatus = {
    Unknown: 'unknown',
    Normal: 'normal',
    Expired: 'expired'
};
/**
 * - uncertified: 未认证  - certifying: 认证中  - certified: 已认证  - failed: 认证失败
 * @export
 * @enum {string}
 */
exports.CertificationStatus = {
    Uncertified: 'uncertified',
    Certifying: 'certifying',
    Certified: 'certified',
    Failed: 'failed'
};
/**
 * - normal: 公开  - forbidden: 封禁
 * @export
 * @enum {string}
 */
exports.CommentShowType = {
    EmptyStatus: 'emptyStatus',
    Normal: 'normal',
    Forbidden: 'forbidden'
};
/**
 * - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
 * @export
 * @enum {string}
 */
exports.CommonApplicationType = {
    ApplicationInvalid: 'APPLICATION_INVALID',
    Research: 'RESEARCH',
    Txc: 'TXC',
    Ailogo: 'AILOGO',
    Wj: 'WJ',
    Techforgood: 'TECHFORGOOD',
    TechforgoodPortal: 'TECHFORGOOD_PORTAL',
    TechforgoodAdmin: 'TECHFORGOOD_ADMIN',
    Techforgoodportal: 'TECHFORGOODPORTAL',
    Techforgoodadmin: 'TECHFORGOODADMIN',
    Techforgoodportaltest: 'TECHFORGOODPORTALTEST',
    Techforgoodadmintest: 'TECHFORGOODADMINTEST',
    Techforgoodpx: 'TECHFORGOODPX',
    Techforgoodpxtest: 'TECHFORGOODPXTEST',
    Tidal: 'TIDAL'
};
/**
 * - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
 * @export
 * @enum {string}
 */
exports.CommonEntityType = {
    Undefined: 'UNDEFINED',
    ResearchReport: 'ResearchReport',
    Comment: 'Comment',
    Article: 'Article',
    RegisteredNps: 'RegisteredNPS',
    Research: 'Research',
    TxcTopic: 'TXCTopic'
};
/**
 * - INVALID: 非法用户  - WECHAT: 微信用户  - QQ: QQ用户  - WECHATWORK: 企业微信  - OA: OA用户  - PHONE: 手机用户  - UNKNOWN: 其余未识别用户  - DESIGNCLOUD: 设计云用户  - MiniProgram: 小程序
 * @export
 * @enum {string}
 */
exports.CommonUserType = {
    Invalid: 'INVALID',
    Wechat: 'WECHAT',
    Qq: 'QQ',
    Wechatwork: 'WECHATWORK',
    Oa: 'OA',
    Phone: 'PHONE',
    Unknown: 'UNKNOWN',
    Designcloud: 'DESIGNCLOUD',
    MiniProgram: 'MiniProgram'
};
/**
 * - InvalidD: 占位  - Agree: 赞同  - Disagree: 反对
 * @export
 * @enum {string}
 */
exports.ComplainComplainOperationResultCode = {
    InvalidD: 'InvalidD',
    Agree: 'Agree',
    Disagree: 'Disagree'
};
/**
 * - InvalidA: 占位  - Text: 文本  - ShortText: 短文本  - File: 文件
 * @export
 * @enum {string}
 */
exports.ComplainComplainOptionType = {
    InvalidA: 'InvalidA',
    Text: 'Text',
    ShortText: 'ShortText',
    File: 'File'
};
/**
 * - InvalidB: 占位  - Init: 初始状态  - Done: 已处理
 * @export
 * @enum {string}
 */
exports.ComplainComplainStatus = {
    InvalidB: 'InvalidB',
    Init: 'Init',
    Done: 'Done'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DashboardConditionType = {
    NotIn: 'NOT_IN',
    Eq: 'EQ',
    Ne: 'NE',
    Lt: 'LT',
    Le: 'LE',
    Gt: 'GT',
    Ge: 'GE',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    StartsWith: 'STARTS_WITH',
    NotStartsWith: 'NOT_STARTS_WITH',
    EndsWith: 'ENDS_WITH',
    NotEndsWith: 'NOT_ENDS_WITH',
    In: 'IN'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.GroupGroupDeliverSource = {
    All: 'All',
    Older: 'Older'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.GroupGroupRewardType = {
    Unknown: 'Unknown',
    Luckymoney: 'Luckymoney',
    Score: 'Score',
    QcloudLuckymoney: 'QcloudLuckymoney'
};
/**
 * - Draft: 草稿态  - Paid: 已支付  - Sending: 投放中  - Finished: 完成投放  - Illegal: 违规被暂停  - ToBeStopped: 发起手动终止，等待终止  - Stopped: 被终止  - Reviewed: 已审核  - Settling: 结算中  - Settled: 已结算
 * @export
 * @enum {string}
 */
exports.GroupGroupStatus = {
    Draft: 'Draft',
    Paid: 'Paid',
    Sending: 'Sending',
    Finished: 'Finished',
    Illegal: 'Illegal',
    ToBeStopped: 'ToBeStopped',
    Stopped: 'Stopped',
    Reviewed: 'Reviewed',
    Settling: 'Settling',
    Settled: 'Settled'
};
/**
 * - INVALID: 默认非法  - UserLogin: 用户登录  - Comment: 评论  - ReportPublished: 报告发布  - ArticlePublished: 文章发布
 * @export
 * @enum {string}
 */
exports.IpcityEventKind = {
    Invalid: 'INVALID',
    UserLogin: 'UserLogin',
    Comment: 'Comment',
    ReportPublished: 'ReportPublished',
    ArticlePublished: 'ArticlePublished'
};
/**
 * - INVALID_ACTION: 占位  - Comment: 评论  - Like: 赞  - Collect: 收藏  - Nps: 评分  - SystemAudit: 系统审核  - SystemUnpublish: 系统下架
 * @export
 * @enum {string}
 */
exports.NoticeActionType = {
    InvalidAction: 'INVALID_ACTION',
    Comment: 'Comment',
    Like: 'Like',
    Collect: 'Collect',
    Nps: 'Nps',
    SystemAudit: 'SystemAudit',
    SystemUnpublish: 'SystemUnpublish'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.OaavatarOaavatarType = {
    Thumb: 'thumb',
    Normal: 'normal',
    Original: 'original'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.OcrCovidResultType = {
    Unknown: 'COVID_RESULT_TYPE_UNKNOWN',
    Positive: 'COVID_RESULT_TYPE_POSITIVE',
    Negative: 'COVID_RESULT_TYPE_NEGATIVE'
};
/**
 * - NORMAL: 普通成员  - ADMIN: 管理员
 * @export
 * @enum {string}
 */
exports.OrganizationChangeMemberRoleRequestRole = {
    Normal: 'NORMAL',
    Admin: 'ADMIN'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.OrganizationMemberUnitType = {
    User: 'USER'
};
/**
 * - NORMAL: 普通成员  - ADMIN: 管理员  - CREATOR: 创建者  - NOT_MEMBER: 非成员
 * @export
 * @enum {string}
 */
exports.OrganizationRole = {
    Normal: 'NORMAL',
    Admin: 'ADMIN',
    Creator: 'CREATOR',
    NotMember: 'NOT_MEMBER'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PermissionaclCheckType = {
    Or: 'OR',
    And: 'AND'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PermissionaclSortBy = {
    Default: 'Default',
    CreatedAt: 'CreatedAt',
    ObjectCreatedAt: 'ObjectCreatedAt',
    ResearchedAt: 'ResearchedAt'
};
/**
 * `NullValue` is a singleton enumeration to represent the null value for the `Value` type union.   The JSON representation for `NullValue` is JSON `null`.   - NULL_VALUE: Null value.
 * @export
 * @enum {string}
 */
exports.ProtobufNullValue = {
    NullValue: 'NULL_VALUE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.QueryRequestsort = {
    Ascending: 'ASCENDING',
    Descending: 'DESCENDING'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ReportElementKind = {
    MainTitle: 'MAIN_TITLE',
    SubTitle: 'SUB_TITLE',
    H1: 'H1',
    H2: 'H2',
    H3: 'H3',
    H4: 'H4',
    Normal: 'NORMAL',
    Graph: 'GRAPH',
    Image: 'IMAGE',
    Complex: 'COMPLEX'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ReportOrderBy = {
    Default: 'default',
    CreatedAt: 'created_at',
    UpdatedAt: 'updated_at'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ReportSort = {
    Desc: 'desc',
    Asc: 'asc'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ReportTeamRole = {
    Nopermission: 'NOPERMISSION',
    Member: 'MEMBER',
    Admin: 'ADMIN'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ResearchreportAuditType = {
    Invalid: 'Invalid',
    Accept: 'Accept',
    Reject: 'Reject'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ResearchreportFieldType = {
    Unknown: 'UNKNOWN',
    Name: 'NAME',
    Email: 'EMAIL',
    Phone: 'PHONE',
    Wechat: 'WECHAT',
    Company: 'COMPANY',
    Department: 'DEPARTMENT',
    Position: 'POSITION',
    Location: 'LOCATION'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ResearchreportPrivilegeType = {
    Public: 'Public',
    Limited: 'Limited',
    OnlyForTeam: 'OnlyForTeam'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ResearchreportTeamRole = {
    Nopermission: 'NOPERMISSION',
    Member: 'MEMBER',
    Admin: 'ADMIN'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ResearchreportWatermarkType = {
    Off: 'Off',
    PlatformName: 'PlatformName',
    TeamName: 'TeamName',
    UserName: 'UserName'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SampleOpCode = {
    Eq: 'EQ',
    Neq: 'NEQ',
    Gt: 'GT',
    Lt: 'LT',
    Gte: 'GTE',
    Lte: 'LTE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ShortlinkMappingType = {
    ToOne: 'ToOne',
    ToMany: 'ToMany'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SpaceOrderBy = {
    Invalid: 'Invalid',
    Overall: 'Overall',
    Works: 'Works',
    Popularity: 'Popularity',
    Latest: 'Latest',
    PopularityIncrease: 'PopularityIncrease',
    ReadIncrease: 'ReadIncrease'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SpacePrivilegeType = {
    Public: 'Public',
    Limited: 'Limited',
    OnlyForTeam: 'OnlyForTeam'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SpaceSort = {
    Desc: 'desc',
    Asc: 'asc'
};
/**
 * - USER: 个人空间  - TEAM: 团队空间
 * @export
 * @enum {string}
 */
exports.SpaceSpaceKind = {
    User: 'USER',
    Team: 'TEAM'
};
/**
 * - ResearchReport: 报告  - Article: 文章
 * @export
 * @enum {string}
 */
exports.SpaceTagObjectType = {
    Unknow: 'UNKNOW',
    ResearchReport: 'ResearchReport',
    Article: 'Article'
};
/**
 * - INVALID: 非法或者已过期  - AUTHORING: 授权中  - LOCKING: 授权锁定  - AUTHORIZED: 已授权
 * @export
 * @enum {string}
 */
exports.StateRespState = {
    Invalid: 'INVALID',
    Authoring: 'AUTHORING',
    Locking: 'LOCKING',
    Authorized: 'AUTHORIZED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TeamUserRoleRolePermission = {
    Nopermission: 'NOPERMISSION',
    Member: 'MEMBER',
    Admin: 'ADMIN'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TextsearchUpdateDataType = {
    Empty: 'empty',
    Create: 'create',
    Update: 'update',
    Delete: 'delete'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TidalbiDimension = {
    H: 'h',
    D: 'd',
    W: 'w',
    M: 'm',
    Y: 'y',
    All: 'all'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TidalbiMetricInternalType = {
    Atomic: 'Atomic',
    Derived: 'Derived',
    Complex: 'Complex'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TidalbiMetricStatus = {
    Draft: 'Draft',
    Developing: 'Developing',
    TobeConfirmed: 'TobeConfirmed',
    Online: 'Online',
    Offline: 'Offline'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TtqSortType = {
    Asc: 'ASC',
    Desc: 'DESC'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.UnbindProviderReqProvider = {
    TencentMeeting: 'TENCENT_MEETING',
    Wechat: 'WECHAT',
    Qq: 'QQ',
    Rtx: 'RTX'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.UserKind = {
    Unkown: 'Unkown',
    Wechat: 'Wechat',
    Qq: 'QQ',
    Oa: 'OA',
    Phone: 'PHONE',
    WechatWork: 'WechatWork',
    DesignCloud: 'DesignCloud',
    ProductUser: 'ProductUser',
    Mp: 'MP'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.UserUserInfoType = {
    Invalid: 'INVALID',
    Wechat: 'WECHAT',
    Qq: 'QQ',
    Wechatwork: 'WECHATWORK',
    Oa: 'OA'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.UseractionActionType = {
    Undefined: 'UNDEFINED',
    Like: 'Like',
    Collect: 'Collect',
    Share: 'Share'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.UseractionShareChannel = {
    Invalid: 'INVALID',
    InsideForward: 'InsideForward',
    Qq: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    CopyLink: 'CopyLink',
    QrCode: 'QRCode',
    Poster: 'POSTER'
};
/**
 * - WJQuestion: 问卷问题  - Component: 研究组件  - Dimenson: 研究维度
 * @export
 * @enum {string}
 */
exports.VariableKind = {
    WjQuestion: 'WJQuestion',
    Component: 'Component',
    Dimenson: 'Dimenson'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.WJProxyReqHTTPMethod = {
    Post: 'POST',
    Get: 'GET'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.WeixinWeixinMenuButtonType = {
    View: 'view',
    Click: 'click',
    Miniprogram: 'miniprogram'
};
/**
 * ApplicationApi - axios parameter creator
 * @export
 */
var ApplicationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 管理员设置公开配置内容,如何使用该接口见wiki https://iwiki.woa.com/pages/viewpage.action?pageId=4007601919
         * @param {string} key
         * @param {ApplicationAdminSetPublicConfigReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationAdminSetPublicConfig: function (key, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'key' is not null or undefined
                    (0, common_1.assertParamExists)('applicationAdminSetPublicConfig', 'key', key);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('applicationAdminSetPublicConfig', 'body', body);
                    localVarPath = "/admin/api/application/{key}"
                        .replace("{".concat("key", "}"), encodeURIComponent(String(key)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取广告
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationGetAd: function (appid, name, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('applicationGetAd', 'appid', appid);
                    localVarPath = "/api/application/{appid}/ad"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationGetConfig: function (appid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('applicationGetConfig', 'appid', appid);
                    localVarPath = "/api/application/{appid}/config"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取公开配置内容,如何使用该接口见wiki https://iwiki.woa.com/pages/viewpage.action?pageId=4007601919
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationGetPublicConfig: function (key, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'key' is not null or undefined
                    (0, common_1.assertParamExists)('applicationGetPublicConfig', 'key', key);
                    localVarPath = "/api/application/{key}"
                        .replace("{".concat("key", "}"), encodeURIComponent(String(key)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 设置广告
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid
         * @param {ApplicationSetAdReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationSetAd: function (appid, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('applicationSetAd', 'appid', appid);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('applicationSetAd', 'body', body);
                    localVarPath = "/admin/api/application/{appid}/ad"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 修改广告
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid
         * @param {ApplicationUpdateAdReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationUpdateAd: function (appid, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('applicationUpdateAd', 'appid', appid);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('applicationUpdateAd', 'body', body);
                    localVarPath = "/admin/api/application/{appid}/ad/modification"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ApplicationApiAxiosParamCreator = ApplicationApiAxiosParamCreator;
/**
 * ApplicationApi - functional programming interface
 * @export
 */
var ApplicationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ApplicationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 管理员设置公开配置内容,如何使用该接口见wiki https://iwiki.woa.com/pages/viewpage.action?pageId=4007601919
         * @param {string} key
         * @param {ApplicationAdminSetPublicConfigReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationAdminSetPublicConfig: function (key, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.applicationAdminSetPublicConfig(key, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取广告
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationGetAd: function (appid, name, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.applicationGetAd(appid, name, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationGetConfig: function (appid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.applicationGetConfig(appid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取公开配置内容,如何使用该接口见wiki https://iwiki.woa.com/pages/viewpage.action?pageId=4007601919
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationGetPublicConfig: function (key, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.applicationGetPublicConfig(key, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 设置广告
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid
         * @param {ApplicationSetAdReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationSetAd: function (appid, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.applicationSetAd(appid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 修改广告
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid
         * @param {ApplicationUpdateAdReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationUpdateAd: function (appid, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.applicationUpdateAd(appid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ApplicationApiFp = ApplicationApiFp;
/**
 * ApplicationApi - factory interface
 * @export
 */
var ApplicationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ApplicationApiFp)(configuration);
    return {
        /**
         *
         * @summary 管理员设置公开配置内容,如何使用该接口见wiki https://iwiki.woa.com/pages/viewpage.action?pageId=4007601919
         * @param {string} key
         * @param {ApplicationAdminSetPublicConfigReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationAdminSetPublicConfig: function (key, body, options) {
            return localVarFp.applicationAdminSetPublicConfig(key, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取广告
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationGetAd: function (appid, name, options) {
            return localVarFp.applicationGetAd(appid, name, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationGetConfig: function (appid, options) {
            return localVarFp.applicationGetConfig(appid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取公开配置内容,如何使用该接口见wiki https://iwiki.woa.com/pages/viewpage.action?pageId=4007601919
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationGetPublicConfig: function (key, options) {
            return localVarFp.applicationGetPublicConfig(key, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 设置广告
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid
         * @param {ApplicationSetAdReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationSetAd: function (appid, body, options) {
            return localVarFp.applicationSetAd(appid, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 修改广告
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid
         * @param {ApplicationUpdateAdReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationUpdateAd: function (appid, body, options) {
            return localVarFp.applicationUpdateAd(appid, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ApplicationApiFactory = ApplicationApiFactory;
/**
 * ApplicationApi - object-oriented interface
 * @export
 * @class ApplicationApi
 * @extends {BaseAPI}
 */
var ApplicationApi = /** @class */ (function (_super) {
    __extends(ApplicationApi, _super);
    function ApplicationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 管理员设置公开配置内容,如何使用该接口见wiki https://iwiki.woa.com/pages/viewpage.action?pageId=4007601919
     * @param {string} key
     * @param {ApplicationAdminSetPublicConfigReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    ApplicationApi.prototype.applicationAdminSetPublicConfig = function (key, body, options) {
        var _this = this;
        return (0, exports.ApplicationApiFp)(this.configuration).applicationAdminSetPublicConfig(key, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取广告
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid
     * @param {string} [name]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    ApplicationApi.prototype.applicationGetAd = function (appid, name, options) {
        var _this = this;
        return (0, exports.ApplicationApiFp)(this.configuration).applicationGetAd(appid, name, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    ApplicationApi.prototype.applicationGetConfig = function (appid, options) {
        var _this = this;
        return (0, exports.ApplicationApiFp)(this.configuration).applicationGetConfig(appid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取公开配置内容,如何使用该接口见wiki https://iwiki.woa.com/pages/viewpage.action?pageId=4007601919
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    ApplicationApi.prototype.applicationGetPublicConfig = function (key, options) {
        var _this = this;
        return (0, exports.ApplicationApiFp)(this.configuration).applicationGetPublicConfig(key, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 设置广告
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid
     * @param {ApplicationSetAdReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    ApplicationApi.prototype.applicationSetAd = function (appid, body, options) {
        var _this = this;
        return (0, exports.ApplicationApiFp)(this.configuration).applicationSetAd(appid, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 修改广告
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid
     * @param {ApplicationUpdateAdReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    ApplicationApi.prototype.applicationUpdateAd = function (appid, body, options) {
        var _this = this;
        return (0, exports.ApplicationApiFp)(this.configuration).applicationUpdateAd(appid, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ApplicationApi;
}(base_1.BaseAPI));
exports.ApplicationApi = ApplicationApi;
/**
 * ArticleApi - axios parameter creator
 * @export
 */
var ArticleApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 审核文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {ArticleAdminAuditArticleRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleAdminAuditArticle: function (app, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('articleAdminAuditArticle', 'app', app);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('articleAdminAuditArticle', 'body', body);
                    localVarPath = "/admin/api/article/{app}/audit"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 下架文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {ArticleAdminDisabledArticleRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleAdminDisabledArticle: function (app, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('articleAdminDisabledArticle', 'app', app);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('articleAdminDisabledArticle', 'body', body);
                    localVarPath = "/admin/api/article/{app}/disabled"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 创建文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {ArticleCreateArticleRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleCreate: function (appType, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('articleCreate', 'appType', appType);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('articleCreate', 'body', body);
                    localVarPath = "/api/article/{appType}"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 删除文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleDelete: function (appType, id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('articleDelete', 'appType', appType);
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('articleDelete', 'id', id);
                    localVarPath = "/api/article/{appType}/{id}"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)))
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGet: function (appType, id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('articleGet', 'appType', appType);
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('articleGet', 'id', id);
                    localVarPath = "/api/article/{appType}/{id}"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)))
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取团队对我开放的文章列表
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [time] 时间标签 filter_id.
         * @param {Array<string>} [type] 类型标签 filter_id.
         * @param {number} [teamId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetArticleTeamForMe: function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, teamId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('articleGetArticleTeamForMe', 'appType', appType);
                    localVarPath = "/api/article/{appType}/team/teamforme"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    if (time) {
                        localVarQueryParameter['time'] = time;
                    }
                    if (type) {
                        localVarQueryParameter['type'] = type;
                    }
                    if (teamId !== undefined) {
                        localVarQueryParameter['teamId'] = teamId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 发现中的文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [time] 时间标签 filter_id.
         * @param {Array<string>} [type] 类型标签 filter_id.
         * @param {number} [isHot] 是否获取.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetArticles: function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, isHot, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('articleGetArticles', 'appType', appType);
                    localVarPath = "/api/article/{appType}/explore"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    if (time) {
                        localVarQueryParameter['time'] = time;
                    }
                    if (type) {
                        localVarQueryParameter['type'] = type;
                    }
                    if (isHot !== undefined) {
                        localVarQueryParameter['isHot'] = isHot;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 根据id获取文章列表 !返回的是列表，不够友好
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {ArticleGetByIDsReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetByIDs: function (appType, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('articleGetByIDs', 'appType', appType);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('articleGetByIDs', 'body', body);
                    localVarPath = "/api/article/{appType}/get-by-ids"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取筛选器
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetFilter: function (appType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('articleGetFilter', 'appType', appType);
                    localVarPath = "/api/article/{appType}/filter"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 个人工作台获取文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [time] 时间标签 filter_id.
         * @param {Array<string>} [type] 类型标签 filter_id.
         * @param {number} [isHot] 是否获取.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetMyArticles: function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, isHot, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('articleGetMyArticles', 'appType', appType);
                    localVarPath = "/api/article/{appType}/mine"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    if (time) {
                        localVarQueryParameter['time'] = time;
                    }
                    if (type) {
                        localVarQueryParameter['type'] = type;
                    }
                    if (isHot !== undefined) {
                        localVarQueryParameter['isHot'] = isHot;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 团队工作台获取文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} teamId 团队id
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [time] 时间标签 filter_id.
         * @param {Array<string>} [type] 类型标签 filter_id.
         * @param {number} [mine] 是否获取个人文章 1&#x3D;是，其他&#x3D;否.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetMyTeamArticles: function (appType, teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, mine, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('articleGetMyTeamArticles', 'appType', appType);
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('articleGetMyTeamArticles', 'teamId', teamId);
                    localVarPath = "/api/article/{appType}/myteam/{teamId}"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)))
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    if (time) {
                        localVarQueryParameter['time'] = time;
                    }
                    if (type) {
                        localVarQueryParameter['type'] = type;
                    }
                    if (mine !== undefined) {
                        localVarQueryParameter['mine'] = mine;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 导入第三方文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {ArticleImportThirdPartyArticleReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleImportThirdPartyArticle: function (app, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('articleImportThirdPartyArticle', 'app', app);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('articleImportThirdPartyArticle', 'body', body);
                    localVarPath = "/api/article/{app}/import"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 用户主动中断审核
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleInterruptReviwing: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('articleInterruptReviwing', 'id', id);
                    localVarPath = "/api/article/{id}/interrupt_reviewing"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary IsValid 文章id是否是合法的
         * @param {string} articleHashId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleIsValid: function (articleHashId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'articleHashId' is not null or undefined
                    (0, common_1.assertParamExists)('articleIsValid', 'articleHashId', articleHashId);
                    localVarPath = "/admin/api/article/isvalid/{articleHashId}"
                        .replace("{".concat("articleHashId", "}"), encodeURIComponent(String(articleHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 推荐研究报告
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {string} [keyword]
         * @param {string} [scene] 场景 all/user/team，默认all.
         * @param {string} [userGuid] scene &#x3D; user 时必填.
         * @param {string} [teamId] scene &#x3D; team 时必填.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleRecommendArticles: function (appType, keyword, scene, userGuid, teamId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('articleRecommendArticles', 'appType', appType);
                    localVarPath = "/api/article/{appType}/recommend"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (keyword !== undefined) {
                        localVarQueryParameter['keyword'] = keyword;
                    }
                    if (scene !== undefined) {
                        localVarQueryParameter['scene'] = scene;
                    }
                    if (userGuid !== undefined) {
                        localVarQueryParameter['userGuid'] = userGuid;
                    }
                    if (teamId !== undefined) {
                        localVarQueryParameter['teamId'] = teamId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 搜索文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {string} [time] 时间标签 filter_id.
         * @param {string} [keyword] 类型标签 filter_id repeated string type &#x3D; 6; 搜索关键词.
         * @param {string} [scene] all/user/team，.
         * @param {string} [userGuid] scene &#x3D; user 时必填.
         * @param {string} [teamId] scene &#x3D; team 时必填.
         * @param {boolean} [notRecordKeyword] 不记录搜索词.
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleSearchArticles: function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, keyword, scene, userGuid, teamId, notRecordKeyword, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('articleSearchArticles', 'appType', appType);
                    localVarPath = "/api/article/{appType}/search"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    if (time !== undefined) {
                        localVarQueryParameter['time'] = time;
                    }
                    if (keyword !== undefined) {
                        localVarQueryParameter['keyword'] = keyword;
                    }
                    if (scene !== undefined) {
                        localVarQueryParameter['scene'] = scene;
                    }
                    if (userGuid !== undefined) {
                        localVarQueryParameter['userGuid'] = userGuid;
                    }
                    if (teamId !== undefined) {
                        localVarQueryParameter['teamId'] = teamId;
                    }
                    if (notRecordKeyword !== undefined) {
                        localVarQueryParameter['notRecordKeyword'] = notRecordKeyword;
                    }
                    if (type !== undefined) {
                        localVarQueryParameter['type'] = type;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 团队空间的文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} teamId 团队id
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [time] 时间标签 filter_id.
         * @param {Array<string>} [type] 类型标签 filter_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleTeamArticles: function (appType, teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('articleTeamArticles', 'appType', appType);
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('articleTeamArticles', 'teamId', teamId);
                    localVarPath = "/api/article/{appType}/team/{teamId}"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)))
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    if (time) {
                        localVarQueryParameter['time'] = time;
                    }
                    if (type) {
                        localVarQueryParameter['type'] = type;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 更新文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {string} id
         * @param {ArticleUpdateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUpdate: function (appType, id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('articleUpdate', 'appType', appType);
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('articleUpdate', 'id', id);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('articleUpdate', 'body', body);
                    localVarPath = "/api/article/{appType}/{id}"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)))
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 个人空间的文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {string} guid 用户 guid
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [timeIds] 时间标签 filter_id.
         * @param {Array<string>} [typeIds] 类型标签 filter_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUserArticles: function (appType, guid, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, timeIds, typeIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('articleUserArticles', 'appType', appType);
                    // verify required parameter 'guid' is not null or undefined
                    (0, common_1.assertParamExists)('articleUserArticles', 'guid', guid);
                    localVarPath = "/api/article/{appType}/user/{guid}"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)))
                        .replace("{".concat("guid", "}"), encodeURIComponent(String(guid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    if (timeIds) {
                        localVarQueryParameter['timeIds'] = timeIds;
                    }
                    if (typeIds) {
                        localVarQueryParameter['typeIds'] = typeIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ArticleApiAxiosParamCreator = ArticleApiAxiosParamCreator;
/**
 * ArticleApi - functional programming interface
 * @export
 */
var ArticleApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ArticleApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 审核文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {ArticleAdminAuditArticleRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleAdminAuditArticle: function (app, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleAdminAuditArticle(app, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 下架文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {ArticleAdminDisabledArticleRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleAdminDisabledArticle: function (app, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleAdminDisabledArticle(app, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 创建文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {ArticleCreateArticleRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleCreate: function (appType, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleCreate(appType, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 删除文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleDelete: function (appType, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleDelete(appType, id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGet: function (appType, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleGet(appType, id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取团队对我开放的文章列表
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [time] 时间标签 filter_id.
         * @param {Array<string>} [type] 类型标签 filter_id.
         * @param {number} [teamId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetArticleTeamForMe: function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, teamId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleGetArticleTeamForMe(appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, teamId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 发现中的文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [time] 时间标签 filter_id.
         * @param {Array<string>} [type] 类型标签 filter_id.
         * @param {number} [isHot] 是否获取.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetArticles: function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, isHot, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleGetArticles(appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, isHot, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 根据id获取文章列表 !返回的是列表，不够友好
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {ArticleGetByIDsReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetByIDs: function (appType, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleGetByIDs(appType, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取筛选器
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetFilter: function (appType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleGetFilter(appType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 个人工作台获取文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [time] 时间标签 filter_id.
         * @param {Array<string>} [type] 类型标签 filter_id.
         * @param {number} [isHot] 是否获取.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetMyArticles: function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, isHot, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleGetMyArticles(appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, isHot, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 团队工作台获取文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} teamId 团队id
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [time] 时间标签 filter_id.
         * @param {Array<string>} [type] 类型标签 filter_id.
         * @param {number} [mine] 是否获取个人文章 1&#x3D;是，其他&#x3D;否.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetMyTeamArticles: function (appType, teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, mine, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleGetMyTeamArticles(appType, teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, mine, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 导入第三方文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {ArticleImportThirdPartyArticleReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleImportThirdPartyArticle: function (app, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleImportThirdPartyArticle(app, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 用户主动中断审核
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleInterruptReviwing: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleInterruptReviwing(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary IsValid 文章id是否是合法的
         * @param {string} articleHashId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleIsValid: function (articleHashId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleIsValid(articleHashId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 推荐研究报告
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {string} [keyword]
         * @param {string} [scene] 场景 all/user/team，默认all.
         * @param {string} [userGuid] scene &#x3D; user 时必填.
         * @param {string} [teamId] scene &#x3D; team 时必填.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleRecommendArticles: function (appType, keyword, scene, userGuid, teamId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleRecommendArticles(appType, keyword, scene, userGuid, teamId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 搜索文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {string} [time] 时间标签 filter_id.
         * @param {string} [keyword] 类型标签 filter_id repeated string type &#x3D; 6; 搜索关键词.
         * @param {string} [scene] all/user/team，.
         * @param {string} [userGuid] scene &#x3D; user 时必填.
         * @param {string} [teamId] scene &#x3D; team 时必填.
         * @param {boolean} [notRecordKeyword] 不记录搜索词.
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleSearchArticles: function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, keyword, scene, userGuid, teamId, notRecordKeyword, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleSearchArticles(appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, keyword, scene, userGuid, teamId, notRecordKeyword, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 团队空间的文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} teamId 团队id
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [time] 时间标签 filter_id.
         * @param {Array<string>} [type] 类型标签 filter_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleTeamArticles: function (appType, teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleTeamArticles(appType, teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 更新文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {string} id
         * @param {ArticleUpdateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUpdate: function (appType, id, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleUpdate(appType, id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 个人空间的文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {string} guid 用户 guid
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [timeIds] 时间标签 filter_id.
         * @param {Array<string>} [typeIds] 类型标签 filter_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUserArticles: function (appType, guid, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, timeIds, typeIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.articleUserArticles(appType, guid, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, timeIds, typeIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ArticleApiFp = ArticleApiFp;
/**
 * ArticleApi - factory interface
 * @export
 */
var ArticleApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ArticleApiFp)(configuration);
    return {
        /**
         *
         * @summary 审核文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {ArticleAdminAuditArticleRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleAdminAuditArticle: function (app, body, options) {
            return localVarFp.articleAdminAuditArticle(app, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 下架文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {ArticleAdminDisabledArticleRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleAdminDisabledArticle: function (app, body, options) {
            return localVarFp.articleAdminDisabledArticle(app, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 创建文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {ArticleCreateArticleRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleCreate: function (appType, body, options) {
            return localVarFp.articleCreate(appType, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 删除文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleDelete: function (appType, id, options) {
            return localVarFp.articleDelete(appType, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGet: function (appType, id, options) {
            return localVarFp.articleGet(appType, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取团队对我开放的文章列表
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [time] 时间标签 filter_id.
         * @param {Array<string>} [type] 类型标签 filter_id.
         * @param {number} [teamId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetArticleTeamForMe: function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, teamId, options) {
            return localVarFp.articleGetArticleTeamForMe(appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, teamId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 发现中的文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [time] 时间标签 filter_id.
         * @param {Array<string>} [type] 类型标签 filter_id.
         * @param {number} [isHot] 是否获取.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetArticles: function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, isHot, options) {
            return localVarFp.articleGetArticles(appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, isHot, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 根据id获取文章列表 !返回的是列表，不够友好
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {ArticleGetByIDsReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetByIDs: function (appType, body, options) {
            return localVarFp.articleGetByIDs(appType, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取筛选器
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetFilter: function (appType, options) {
            return localVarFp.articleGetFilter(appType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 个人工作台获取文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [time] 时间标签 filter_id.
         * @param {Array<string>} [type] 类型标签 filter_id.
         * @param {number} [isHot] 是否获取.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetMyArticles: function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, isHot, options) {
            return localVarFp.articleGetMyArticles(appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, isHot, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 团队工作台获取文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} teamId 团队id
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [time] 时间标签 filter_id.
         * @param {Array<string>} [type] 类型标签 filter_id.
         * @param {number} [mine] 是否获取个人文章 1&#x3D;是，其他&#x3D;否.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleGetMyTeamArticles: function (appType, teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, mine, options) {
            return localVarFp.articleGetMyTeamArticles(appType, teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, mine, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 导入第三方文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {ArticleImportThirdPartyArticleReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleImportThirdPartyArticle: function (app, body, options) {
            return localVarFp.articleImportThirdPartyArticle(app, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 用户主动中断审核
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleInterruptReviwing: function (id, options) {
            return localVarFp.articleInterruptReviwing(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary IsValid 文章id是否是合法的
         * @param {string} articleHashId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleIsValid: function (articleHashId, options) {
            return localVarFp.articleIsValid(articleHashId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 推荐研究报告
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {string} [keyword]
         * @param {string} [scene] 场景 all/user/team，默认all.
         * @param {string} [userGuid] scene &#x3D; user 时必填.
         * @param {string} [teamId] scene &#x3D; team 时必填.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleRecommendArticles: function (appType, keyword, scene, userGuid, teamId, options) {
            return localVarFp.articleRecommendArticles(appType, keyword, scene, userGuid, teamId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 搜索文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {string} [time] 时间标签 filter_id.
         * @param {string} [keyword] 类型标签 filter_id repeated string type &#x3D; 6; 搜索关键词.
         * @param {string} [scene] all/user/team，.
         * @param {string} [userGuid] scene &#x3D; user 时必填.
         * @param {string} [teamId] scene &#x3D; team 时必填.
         * @param {boolean} [notRecordKeyword] 不记录搜索词.
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleSearchArticles: function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, keyword, scene, userGuid, teamId, notRecordKeyword, type, options) {
            return localVarFp.articleSearchArticles(appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, keyword, scene, userGuid, teamId, notRecordKeyword, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 团队空间的文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {number} teamId 团队id
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [time] 时间标签 filter_id.
         * @param {Array<string>} [type] 类型标签 filter_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleTeamArticles: function (appType, teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, options) {
            return localVarFp.articleTeamArticles(appType, teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 更新文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {string} id
         * @param {ArticleUpdateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUpdate: function (appType, id, body, options) {
            return localVarFp.articleUpdate(appType, id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 个人空间的文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
         * @param {string} guid 用户 guid
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {Array<string>} [timeIds] 时间标签 filter_id.
         * @param {Array<string>} [typeIds] 类型标签 filter_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUserArticles: function (appType, guid, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, timeIds, typeIds, options) {
            return localVarFp.articleUserArticles(appType, guid, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, timeIds, typeIds, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ArticleApiFactory = ArticleApiFactory;
/**
 * ArticleApi - object-oriented interface
 * @export
 * @class ArticleApi
 * @extends {BaseAPI}
 */
var ArticleApi = /** @class */ (function (_super) {
    __extends(ArticleApi, _super);
    function ArticleApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 审核文章
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {ArticleAdminAuditArticleRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleAdminAuditArticle = function (app, body, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleAdminAuditArticle(app, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 下架文章
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {ArticleAdminDisabledArticleRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleAdminDisabledArticle = function (app, body, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleAdminDisabledArticle(app, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 创建文章
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
     * @param {ArticleCreateArticleRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleCreate = function (appType, body, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleCreate(appType, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 删除文章
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleDelete = function (appType, id, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleDelete(appType, id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取文章
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleGet = function (appType, id, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleGet(appType, id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取团队对我开放的文章列表
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
     * @param {'desc' | 'asc'} [sort] 正/倒序.
     * @param {Array<string>} [time] 时间标签 filter_id.
     * @param {Array<string>} [type] 类型标签 filter_id.
     * @param {number} [teamId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleGetArticleTeamForMe = function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, teamId, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleGetArticleTeamForMe(appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, teamId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 发现中的文章
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
     * @param {'desc' | 'asc'} [sort] 正/倒序.
     * @param {Array<string>} [time] 时间标签 filter_id.
     * @param {Array<string>} [type] 类型标签 filter_id.
     * @param {number} [isHot] 是否获取.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleGetArticles = function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, isHot, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleGetArticles(appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, isHot, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 根据id获取文章列表 !返回的是列表，不够友好
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
     * @param {ArticleGetByIDsReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleGetByIDs = function (appType, body, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleGetByIDs(appType, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取筛选器
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleGetFilter = function (appType, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleGetFilter(appType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 个人工作台获取文章
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
     * @param {'desc' | 'asc'} [sort] 正/倒序.
     * @param {Array<string>} [time] 时间标签 filter_id.
     * @param {Array<string>} [type] 类型标签 filter_id.
     * @param {number} [isHot] 是否获取.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleGetMyArticles = function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, isHot, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleGetMyArticles(appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, isHot, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 团队工作台获取文章
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
     * @param {number} teamId 团队id
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
     * @param {'desc' | 'asc'} [sort] 正/倒序.
     * @param {Array<string>} [time] 时间标签 filter_id.
     * @param {Array<string>} [type] 类型标签 filter_id.
     * @param {number} [mine] 是否获取个人文章 1&#x3D;是，其他&#x3D;否.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleGetMyTeamArticles = function (appType, teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, mine, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleGetMyTeamArticles(appType, teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, mine, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 导入第三方文章
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {ArticleImportThirdPartyArticleReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleImportThirdPartyArticle = function (app, body, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleImportThirdPartyArticle(app, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 用户主动中断审核
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleInterruptReviwing = function (id, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleInterruptReviwing(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary IsValid 文章id是否是合法的
     * @param {string} articleHashId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleIsValid = function (articleHashId, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleIsValid(articleHashId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 推荐研究报告
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
     * @param {string} [keyword]
     * @param {string} [scene] 场景 all/user/team，默认all.
     * @param {string} [userGuid] scene &#x3D; user 时必填.
     * @param {string} [teamId] scene &#x3D; team 时必填.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleRecommendArticles = function (appType, keyword, scene, userGuid, teamId, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleRecommendArticles(appType, keyword, scene, userGuid, teamId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 搜索文章
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
     * @param {'desc' | 'asc'} [sort] 正/倒序.
     * @param {string} [time] 时间标签 filter_id.
     * @param {string} [keyword] 类型标签 filter_id repeated string type &#x3D; 6; 搜索关键词.
     * @param {string} [scene] all/user/team，.
     * @param {string} [userGuid] scene &#x3D; user 时必填.
     * @param {string} [teamId] scene &#x3D; team 时必填.
     * @param {boolean} [notRecordKeyword] 不记录搜索词.
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleSearchArticles = function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, keyword, scene, userGuid, teamId, notRecordKeyword, type, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleSearchArticles(appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, keyword, scene, userGuid, teamId, notRecordKeyword, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 团队空间的文章
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
     * @param {number} teamId 团队id
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
     * @param {'desc' | 'asc'} [sort] 正/倒序.
     * @param {Array<string>} [time] 时间标签 filter_id.
     * @param {Array<string>} [type] 类型标签 filter_id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleTeamArticles = function (appType, teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleTeamArticles(appType, teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, time, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 更新文章
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
     * @param {string} id
     * @param {ArticleUpdateRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleUpdate = function (appType, id, body, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleUpdate(appType, id, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 个人空间的文章
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型
     * @param {string} guid 用户 guid
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {'default' | 'created_at' | 'updated_at' | 'views' | 'comment' | 'collect' | 'like' | 'hot'} [orderBy] 排序类型.
     * @param {'desc' | 'asc'} [sort] 正/倒序.
     * @param {Array<string>} [timeIds] 时间标签 filter_id.
     * @param {Array<string>} [typeIds] 类型标签 filter_id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    ArticleApi.prototype.articleUserArticles = function (appType, guid, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, timeIds, typeIds, options) {
        var _this = this;
        return (0, exports.ArticleApiFp)(this.configuration).articleUserArticles(appType, guid, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, timeIds, typeIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ArticleApi;
}(base_1.BaseAPI));
exports.ArticleApi = ArticleApi;
/**
 * BindingApi - axios parameter creator
 * @export
 */
var BindingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 获取access token
         * @param {'WJ'} appKind
         * @param {string} [openid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingAccessToken: function (appKind, openid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appKind' is not null or undefined
                    (0, common_1.assertParamExists)('bindingAccessToken', 'appKind', appKind);
                    localVarPath = "/disable/{appKind}/accesstoken"
                        .replace("{".concat("appKind", "}"), encodeURIComponent(String(appKind)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (openid !== undefined) {
                        localVarQueryParameter['openid'] = openid;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 绑定
         * @param {string} [code]
         * @param {string} [state]
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingBind: function (code, state, redirectUrl, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/binding/bind";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (code !== undefined) {
                        localVarQueryParameter['code'] = code;
                    }
                    if (state !== undefined) {
                        localVarQueryParameter['state'] = state;
                    }
                    if (redirectUrl !== undefined) {
                        localVarQueryParameter['redirectUrl'] = redirectUrl;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 回调
         * @param {'WJ'} appKind
         * @param {string} [code]
         * @param {string} [state]
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingCallback: function (appKind, code, state, redirectUrl, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appKind' is not null or undefined
                    (0, common_1.assertParamExists)('bindingCallback', 'appKind', appKind);
                    localVarPath = "/api/binding/{appKind}/callback"
                        .replace("{".concat("appKind", "}"), encodeURIComponent(String(appKind)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (code !== undefined) {
                        localVarQueryParameter['code'] = code;
                    }
                    if (state !== undefined) {
                        localVarQueryParameter['state'] = state;
                    }
                    if (redirectUrl !== undefined) {
                        localVarQueryParameter['redirectUrl'] = redirectUrl;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 绑定的账号列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingGetList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/binding/accounts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 跳转至授权绑定地址
         * @param {'WJ'} appKind
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingRedirect: function (appKind, redirectUrl, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appKind' is not null or undefined
                    (0, common_1.assertParamExists)('bindingRedirect', 'appKind', appKind);
                    localVarPath = "/api/binding/{appKind}/redirect"
                        .replace("{".concat("appKind", "}"), encodeURIComponent(String(appKind)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (redirectUrl !== undefined) {
                        localVarQueryParameter['redirectUrl'] = redirectUrl;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 解绑
         * @param {'WJ'} appKind
         * @param {string} openid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingUnBind: function (appKind, openid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appKind' is not null or undefined
                    (0, common_1.assertParamExists)('bindingUnBind', 'appKind', appKind);
                    // verify required parameter 'openid' is not null or undefined
                    (0, common_1.assertParamExists)('bindingUnBind', 'openid', openid);
                    localVarPath = "/api/binding/{appKind}/{openid}"
                        .replace("{".concat("appKind", "}"), encodeURIComponent(String(appKind)))
                        .replace("{".concat("openid", "}"), encodeURIComponent(String(openid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.BindingApiAxiosParamCreator = BindingApiAxiosParamCreator;
/**
 * BindingApi - functional programming interface
 * @export
 */
var BindingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.BindingApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 获取access token
         * @param {'WJ'} appKind
         * @param {string} [openid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingAccessToken: function (appKind, openid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bindingAccessToken(appKind, openid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 绑定
         * @param {string} [code]
         * @param {string} [state]
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingBind: function (code, state, redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bindingBind(code, state, redirectUrl, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 回调
         * @param {'WJ'} appKind
         * @param {string} [code]
         * @param {string} [state]
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingCallback: function (appKind, code, state, redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bindingCallback(appKind, code, state, redirectUrl, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 绑定的账号列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingGetList: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bindingGetList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 跳转至授权绑定地址
         * @param {'WJ'} appKind
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingRedirect: function (appKind, redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bindingRedirect(appKind, redirectUrl, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 解绑
         * @param {'WJ'} appKind
         * @param {string} openid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingUnBind: function (appKind, openid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bindingUnBind(appKind, openid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.BindingApiFp = BindingApiFp;
/**
 * BindingApi - factory interface
 * @export
 */
var BindingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.BindingApiFp)(configuration);
    return {
        /**
         *
         * @summary 获取access token
         * @param {'WJ'} appKind
         * @param {string} [openid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingAccessToken: function (appKind, openid, options) {
            return localVarFp.bindingAccessToken(appKind, openid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 绑定
         * @param {string} [code]
         * @param {string} [state]
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingBind: function (code, state, redirectUrl, options) {
            return localVarFp.bindingBind(code, state, redirectUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 回调
         * @param {'WJ'} appKind
         * @param {string} [code]
         * @param {string} [state]
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingCallback: function (appKind, code, state, redirectUrl, options) {
            return localVarFp.bindingCallback(appKind, code, state, redirectUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 绑定的账号列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingGetList: function (options) {
            return localVarFp.bindingGetList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 跳转至授权绑定地址
         * @param {'WJ'} appKind
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingRedirect: function (appKind, redirectUrl, options) {
            return localVarFp.bindingRedirect(appKind, redirectUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 解绑
         * @param {'WJ'} appKind
         * @param {string} openid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindingUnBind: function (appKind, openid, options) {
            return localVarFp.bindingUnBind(appKind, openid, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.BindingApiFactory = BindingApiFactory;
/**
 * BindingApi - object-oriented interface
 * @export
 * @class BindingApi
 * @extends {BaseAPI}
 */
var BindingApi = /** @class */ (function (_super) {
    __extends(BindingApi, _super);
    function BindingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 获取access token
     * @param {'WJ'} appKind
     * @param {string} [openid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BindingApi
     */
    BindingApi.prototype.bindingAccessToken = function (appKind, openid, options) {
        var _this = this;
        return (0, exports.BindingApiFp)(this.configuration).bindingAccessToken(appKind, openid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 绑定
     * @param {string} [code]
     * @param {string} [state]
     * @param {string} [redirectUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BindingApi
     */
    BindingApi.prototype.bindingBind = function (code, state, redirectUrl, options) {
        var _this = this;
        return (0, exports.BindingApiFp)(this.configuration).bindingBind(code, state, redirectUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 回调
     * @param {'WJ'} appKind
     * @param {string} [code]
     * @param {string} [state]
     * @param {string} [redirectUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BindingApi
     */
    BindingApi.prototype.bindingCallback = function (appKind, code, state, redirectUrl, options) {
        var _this = this;
        return (0, exports.BindingApiFp)(this.configuration).bindingCallback(appKind, code, state, redirectUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 绑定的账号列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BindingApi
     */
    BindingApi.prototype.bindingGetList = function (options) {
        var _this = this;
        return (0, exports.BindingApiFp)(this.configuration).bindingGetList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 跳转至授权绑定地址
     * @param {'WJ'} appKind
     * @param {string} [redirectUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BindingApi
     */
    BindingApi.prototype.bindingRedirect = function (appKind, redirectUrl, options) {
        var _this = this;
        return (0, exports.BindingApiFp)(this.configuration).bindingRedirect(appKind, redirectUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 解绑
     * @param {'WJ'} appKind
     * @param {string} openid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BindingApi
     */
    BindingApi.prototype.bindingUnBind = function (appKind, openid, options) {
        var _this = this;
        return (0, exports.BindingApiFp)(this.configuration).bindingUnBind(appKind, openid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BindingApi;
}(base_1.BaseAPI));
exports.BindingApi = BindingApi;
/**
 * CertificationApi - axios parameter creator
 * @export
 */
var CertificationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 管理后台：审核团队
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationAdminAuditTeamCertificationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationAdminAuditTeamCertification: function (app, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('certificationAdminAuditTeamCertification', 'app', app);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('certificationAdminAuditTeamCertification', 'body', body);
                    localVarPath = "/admin/api/certification/{app}/team/audit"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 管理后台：审核个人
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationAdminAuditUserCertificationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationAdminAuditUserCertification: function (app, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('certificationAdminAuditUserCertification', 'app', app);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('certificationAdminAuditUserCertification', 'body', body);
                    localVarPath = "/admin/api/certification/{app}/user/audit"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 管理后台：下载文件
         * @param {string} fileUuid 文件 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationAdminDownloadFile: function (fileUuid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'fileUuid' is not null or undefined
                    (0, common_1.assertParamExists)('certificationAdminDownloadFile', 'fileUuid', fileUuid);
                    localVarPath = "/admin/api/certification/files/{fileUuid}/download"
                        .replace("{".concat("fileUuid", "}"), encodeURIComponent(String(fileUuid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 管理后台：获取团队认证申请的列表
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationAdminTeamCertificationList: function (app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('certificationAdminTeamCertificationList', 'app', app);
                    localVarPath = "/admin/api/certification/{app}/team/list"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 管理后台：获取个人认证申请的列表
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationAdminUserCertificationList: function (app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('certificationAdminUserCertificationList', 'app', app);
                    localVarPath = "/admin/api/certification/{app}/user/list"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 团队认证申请
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationApplyForTeamCertificationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationApplyForTeamCertification: function (app, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('certificationApplyForTeamCertification', 'app', app);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('certificationApplyForTeamCertification', 'body', body);
                    localVarPath = "/api/certification/{app}/team"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 个人认证申请
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationApplyForUserCertificationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationApplyForUserCertification: function (app, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('certificationApplyForUserCertification', 'app', app);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('certificationApplyForUserCertification', 'body', body);
                    localVarPath = "/api/certification/{app}/user"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 批量查询团队认证信息
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationBatchTeamCertificationsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationBatchTeamCertifications: function (app, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('certificationBatchTeamCertifications', 'app', app);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('certificationBatchTeamCertifications', 'body', body);
                    localVarPath = "/api/certification/{app}/batch/team"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 批量查询个人认证信息
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationBatchUserCertificationsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationBatchUserCertifications: function (app, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('certificationBatchUserCertifications', 'app', app);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('certificationBatchUserCertifications', 'body', body);
                    localVarPath = "/api/certification/{app}/batch/user"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 下载文件
         * @param {string} fileUuid 文件 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationDownloadFile: function (fileUuid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'fileUuid' is not null or undefined
                    (0, common_1.assertParamExists)('certificationDownloadFile', 'fileUuid', fileUuid);
                    localVarPath = "/api/certification/files/{fileUuid}/download"
                        .replace("{".concat("fileUuid", "}"), encodeURIComponent(String(fileUuid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 查询团队认证信息
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {number} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationGetTeamCertification: function (app, teamId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('certificationGetTeamCertification', 'app', app);
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('certificationGetTeamCertification', 'teamId', teamId);
                    localVarPath = "/api/certification/{app}/team/{teamId}"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)))
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 查询团队认证信息详情
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {number} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationGetTeamCertificationDetail: function (app, teamId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('certificationGetTeamCertificationDetail', 'app', app);
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('certificationGetTeamCertificationDetail', 'teamId', teamId);
                    localVarPath = "/api/certification/{app}/team/{teamId}/detail"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)))
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 查询个人认证信息
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {string} userGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationGetUserCertification: function (app, userGuid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('certificationGetUserCertification', 'app', app);
                    // verify required parameter 'userGuid' is not null or undefined
                    (0, common_1.assertParamExists)('certificationGetUserCertification', 'userGuid', userGuid);
                    localVarPath = "/api/certification/{app}/user/{userGuid}"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)))
                        .replace("{".concat("userGuid", "}"), encodeURIComponent(String(userGuid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 查询个人认证信息详情
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {string} userGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationGetUserCertificationDetail: function (app, userGuid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('certificationGetUserCertificationDetail', 'app', app);
                    // verify required parameter 'userGuid' is not null or undefined
                    (0, common_1.assertParamExists)('certificationGetUserCertificationDetail', 'userGuid', userGuid);
                    localVarPath = "/api/certification/{app}/user/{userGuid}/detail"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)))
                        .replace("{".concat("userGuid", "}"), encodeURIComponent(String(userGuid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 团队名称申请重复验证
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {string} [teamName]
         * @param {number} [currentTeamId] 当前团队ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationIsTeamNameRepeated: function (app, teamName, currentTeamId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('certificationIsTeamNameRepeated', 'app', app);
                    localVarPath = "/api/certification/{app}/check-repeated/team"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (teamName !== undefined) {
                        localVarQueryParameter['teamName'] = teamName;
                    }
                    if (currentTeamId !== undefined) {
                        localVarQueryParameter['currentTeamId'] = currentTeamId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 团队名称申请重复验证
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {string} [userName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationIsUserNameRepeated: function (app, userName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('certificationIsUserNameRepeated', 'app', app);
                    localVarPath = "/api/certification/{app}/check-repeated/user"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (userName !== undefined) {
                        localVarQueryParameter['userName'] = userName;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 上传文件
         * @param {CertificationUploadFileRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationUploadFile: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('certificationUploadFile', 'body', body);
                    localVarPath = "/api/certification/files";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CertificationApiAxiosParamCreator = CertificationApiAxiosParamCreator;
/**
 * CertificationApi - functional programming interface
 * @export
 */
var CertificationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CertificationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 管理后台：审核团队
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationAdminAuditTeamCertificationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationAdminAuditTeamCertification: function (app, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationAdminAuditTeamCertification(app, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 管理后台：审核个人
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationAdminAuditUserCertificationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationAdminAuditUserCertification: function (app, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationAdminAuditUserCertification(app, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 管理后台：下载文件
         * @param {string} fileUuid 文件 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationAdminDownloadFile: function (fileUuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationAdminDownloadFile(fileUuid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 管理后台：获取团队认证申请的列表
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationAdminTeamCertificationList: function (app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationAdminTeamCertificationList(app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 管理后台：获取个人认证申请的列表
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationAdminUserCertificationList: function (app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationAdminUserCertificationList(app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 团队认证申请
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationApplyForTeamCertificationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationApplyForTeamCertification: function (app, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationApplyForTeamCertification(app, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 个人认证申请
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationApplyForUserCertificationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationApplyForUserCertification: function (app, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationApplyForUserCertification(app, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 批量查询团队认证信息
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationBatchTeamCertificationsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationBatchTeamCertifications: function (app, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationBatchTeamCertifications(app, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 批量查询个人认证信息
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationBatchUserCertificationsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationBatchUserCertifications: function (app, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationBatchUserCertifications(app, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 下载文件
         * @param {string} fileUuid 文件 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationDownloadFile: function (fileUuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationDownloadFile(fileUuid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 查询团队认证信息
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {number} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationGetTeamCertification: function (app, teamId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationGetTeamCertification(app, teamId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 查询团队认证信息详情
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {number} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationGetTeamCertificationDetail: function (app, teamId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationGetTeamCertificationDetail(app, teamId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 查询个人认证信息
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {string} userGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationGetUserCertification: function (app, userGuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationGetUserCertification(app, userGuid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 查询个人认证信息详情
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {string} userGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationGetUserCertificationDetail: function (app, userGuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationGetUserCertificationDetail(app, userGuid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 团队名称申请重复验证
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {string} [teamName]
         * @param {number} [currentTeamId] 当前团队ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationIsTeamNameRepeated: function (app, teamName, currentTeamId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationIsTeamNameRepeated(app, teamName, currentTeamId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 团队名称申请重复验证
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {string} [userName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationIsUserNameRepeated: function (app, userName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationIsUserNameRepeated(app, userName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 上传文件
         * @param {CertificationUploadFileRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationUploadFile: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.certificationUploadFile(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CertificationApiFp = CertificationApiFp;
/**
 * CertificationApi - factory interface
 * @export
 */
var CertificationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CertificationApiFp)(configuration);
    return {
        /**
         *
         * @summary 管理后台：审核团队
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationAdminAuditTeamCertificationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationAdminAuditTeamCertification: function (app, body, options) {
            return localVarFp.certificationAdminAuditTeamCertification(app, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 管理后台：审核个人
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationAdminAuditUserCertificationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationAdminAuditUserCertification: function (app, body, options) {
            return localVarFp.certificationAdminAuditUserCertification(app, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 管理后台：下载文件
         * @param {string} fileUuid 文件 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationAdminDownloadFile: function (fileUuid, options) {
            return localVarFp.certificationAdminDownloadFile(fileUuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 管理后台：获取团队认证申请的列表
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationAdminTeamCertificationList: function (app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return localVarFp.certificationAdminTeamCertificationList(app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 管理后台：获取个人认证申请的列表
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationAdminUserCertificationList: function (app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return localVarFp.certificationAdminUserCertificationList(app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 团队认证申请
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationApplyForTeamCertificationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationApplyForTeamCertification: function (app, body, options) {
            return localVarFp.certificationApplyForTeamCertification(app, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 个人认证申请
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationApplyForUserCertificationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationApplyForUserCertification: function (app, body, options) {
            return localVarFp.certificationApplyForUserCertification(app, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 批量查询团队认证信息
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationBatchTeamCertificationsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationBatchTeamCertifications: function (app, body, options) {
            return localVarFp.certificationBatchTeamCertifications(app, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 批量查询个人认证信息
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {CertificationBatchUserCertificationsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationBatchUserCertifications: function (app, body, options) {
            return localVarFp.certificationBatchUserCertifications(app, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 下载文件
         * @param {string} fileUuid 文件 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationDownloadFile: function (fileUuid, options) {
            return localVarFp.certificationDownloadFile(fileUuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 查询团队认证信息
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {number} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationGetTeamCertification: function (app, teamId, options) {
            return localVarFp.certificationGetTeamCertification(app, teamId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 查询团队认证信息详情
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {number} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationGetTeamCertificationDetail: function (app, teamId, options) {
            return localVarFp.certificationGetTeamCertificationDetail(app, teamId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 查询个人认证信息
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {string} userGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationGetUserCertification: function (app, userGuid, options) {
            return localVarFp.certificationGetUserCertification(app, userGuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 查询个人认证信息详情
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {string} userGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationGetUserCertificationDetail: function (app, userGuid, options) {
            return localVarFp.certificationGetUserCertificationDetail(app, userGuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 团队名称申请重复验证
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {string} [teamName]
         * @param {number} [currentTeamId] 当前团队ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationIsTeamNameRepeated: function (app, teamName, currentTeamId, options) {
            return localVarFp.certificationIsTeamNameRepeated(app, teamName, currentTeamId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 团队名称申请重复验证
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {string} [userName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationIsUserNameRepeated: function (app, userName, options) {
            return localVarFp.certificationIsUserNameRepeated(app, userName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 上传文件
         * @param {CertificationUploadFileRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificationUploadFile: function (body, options) {
            return localVarFp.certificationUploadFile(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CertificationApiFactory = CertificationApiFactory;
/**
 * CertificationApi - object-oriented interface
 * @export
 * @class CertificationApi
 * @extends {BaseAPI}
 */
var CertificationApi = /** @class */ (function (_super) {
    __extends(CertificationApi, _super);
    function CertificationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 管理后台：审核团队
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {CertificationAdminAuditTeamCertificationRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationAdminAuditTeamCertification = function (app, body, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationAdminAuditTeamCertification(app, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 管理后台：审核个人
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {CertificationAdminAuditUserCertificationRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationAdminAuditUserCertification = function (app, body, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationAdminAuditUserCertification(app, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 管理后台：下载文件
     * @param {string} fileUuid 文件 uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationAdminDownloadFile = function (fileUuid, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationAdminDownloadFile(fileUuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 管理后台：获取团队认证申请的列表
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationAdminTeamCertificationList = function (app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationAdminTeamCertificationList(app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 管理后台：获取个人认证申请的列表
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationAdminUserCertificationList = function (app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationAdminUserCertificationList(app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 团队认证申请
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {CertificationApplyForTeamCertificationRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationApplyForTeamCertification = function (app, body, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationApplyForTeamCertification(app, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 个人认证申请
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {CertificationApplyForUserCertificationRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationApplyForUserCertification = function (app, body, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationApplyForUserCertification(app, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 批量查询团队认证信息
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {CertificationBatchTeamCertificationsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationBatchTeamCertifications = function (app, body, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationBatchTeamCertifications(app, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 批量查询个人认证信息
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {CertificationBatchUserCertificationsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationBatchUserCertifications = function (app, body, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationBatchUserCertifications(app, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 下载文件
     * @param {string} fileUuid 文件 uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationDownloadFile = function (fileUuid, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationDownloadFile(fileUuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 查询团队认证信息
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {number} teamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationGetTeamCertification = function (app, teamId, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationGetTeamCertification(app, teamId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 查询团队认证信息详情
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {number} teamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationGetTeamCertificationDetail = function (app, teamId, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationGetTeamCertificationDetail(app, teamId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 查询个人认证信息
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {string} userGuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationGetUserCertification = function (app, userGuid, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationGetUserCertification(app, userGuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 查询个人认证信息详情
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {string} userGuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationGetUserCertificationDetail = function (app, userGuid, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationGetUserCertificationDetail(app, userGuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 团队名称申请重复验证
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {string} [teamName]
     * @param {number} [currentTeamId] 当前团队ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationIsTeamNameRepeated = function (app, teamName, currentTeamId, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationIsTeamNameRepeated(app, teamName, currentTeamId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 团队名称申请重复验证
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {string} [userName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationIsUserNameRepeated = function (app, userName, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationIsUserNameRepeated(app, userName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 上传文件
     * @param {CertificationUploadFileRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationApi
     */
    CertificationApi.prototype.certificationUploadFile = function (body, options) {
        var _this = this;
        return (0, exports.CertificationApiFp)(this.configuration).certificationUploadFile(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CertificationApi;
}(base_1.BaseAPI));
exports.CertificationApi = CertificationApi;
/**
 * ChatOpsApi - axios parameter creator
 * @export
 */
var ChatOpsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 企业微信机器人回调
         * @param {string} appid
         * @param {ChatopsWechatWorkRobotCallbackRequestBody} body
         * @param {string} [msgSignature]
         * @param {string} [timestamp]
         * @param {string} [nonce]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatOpsWechatWorkRobotCallback: function (appid, body, msgSignature, timestamp, nonce, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('chatOpsWechatWorkRobotCallback', 'appid', appid);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('chatOpsWechatWorkRobotCallback', 'body', body);
                    localVarPath = "/api/chatops/{appid}/wechat_robot_callback"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (msgSignature !== undefined) {
                        localVarQueryParameter['msgSignature'] = msgSignature;
                    }
                    if (timestamp !== undefined) {
                        localVarQueryParameter['timestamp'] = timestamp;
                    }
                    if (nonce !== undefined) {
                        localVarQueryParameter['nonce'] = nonce;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 企业微信机器人回调
         * @param {string} appid
         * @param {string} [msgSignature]
         * @param {string} [timestamp]
         * @param {string} [nonce]
         * @param {string} [echostr]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatOpsWechatWorkRobotCallbackVerify: function (appid, msgSignature, timestamp, nonce, echostr, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('chatOpsWechatWorkRobotCallbackVerify', 'appid', appid);
                    localVarPath = "/api/chatops/{appid}/wechat_robot_callback"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (msgSignature !== undefined) {
                        localVarQueryParameter['msgSignature'] = msgSignature;
                    }
                    if (timestamp !== undefined) {
                        localVarQueryParameter['timestamp'] = timestamp;
                    }
                    if (nonce !== undefined) {
                        localVarQueryParameter['nonce'] = nonce;
                    }
                    if (echostr !== undefined) {
                        localVarQueryParameter['echostr'] = echostr;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ChatOpsApiAxiosParamCreator = ChatOpsApiAxiosParamCreator;
/**
 * ChatOpsApi - functional programming interface
 * @export
 */
var ChatOpsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ChatOpsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 企业微信机器人回调
         * @param {string} appid
         * @param {ChatopsWechatWorkRobotCallbackRequestBody} body
         * @param {string} [msgSignature]
         * @param {string} [timestamp]
         * @param {string} [nonce]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatOpsWechatWorkRobotCallback: function (appid, body, msgSignature, timestamp, nonce, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.chatOpsWechatWorkRobotCallback(appid, body, msgSignature, timestamp, nonce, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 企业微信机器人回调
         * @param {string} appid
         * @param {string} [msgSignature]
         * @param {string} [timestamp]
         * @param {string} [nonce]
         * @param {string} [echostr]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatOpsWechatWorkRobotCallbackVerify: function (appid, msgSignature, timestamp, nonce, echostr, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.chatOpsWechatWorkRobotCallbackVerify(appid, msgSignature, timestamp, nonce, echostr, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ChatOpsApiFp = ChatOpsApiFp;
/**
 * ChatOpsApi - factory interface
 * @export
 */
var ChatOpsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ChatOpsApiFp)(configuration);
    return {
        /**
         *
         * @summary 企业微信机器人回调
         * @param {string} appid
         * @param {ChatopsWechatWorkRobotCallbackRequestBody} body
         * @param {string} [msgSignature]
         * @param {string} [timestamp]
         * @param {string} [nonce]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatOpsWechatWorkRobotCallback: function (appid, body, msgSignature, timestamp, nonce, options) {
            return localVarFp.chatOpsWechatWorkRobotCallback(appid, body, msgSignature, timestamp, nonce, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 企业微信机器人回调
         * @param {string} appid
         * @param {string} [msgSignature]
         * @param {string} [timestamp]
         * @param {string} [nonce]
         * @param {string} [echostr]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatOpsWechatWorkRobotCallbackVerify: function (appid, msgSignature, timestamp, nonce, echostr, options) {
            return localVarFp.chatOpsWechatWorkRobotCallbackVerify(appid, msgSignature, timestamp, nonce, echostr, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ChatOpsApiFactory = ChatOpsApiFactory;
/**
 * ChatOpsApi - object-oriented interface
 * @export
 * @class ChatOpsApi
 * @extends {BaseAPI}
 */
var ChatOpsApi = /** @class */ (function (_super) {
    __extends(ChatOpsApi, _super);
    function ChatOpsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 企业微信机器人回调
     * @param {string} appid
     * @param {ChatopsWechatWorkRobotCallbackRequestBody} body
     * @param {string} [msgSignature]
     * @param {string} [timestamp]
     * @param {string} [nonce]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatOpsApi
     */
    ChatOpsApi.prototype.chatOpsWechatWorkRobotCallback = function (appid, body, msgSignature, timestamp, nonce, options) {
        var _this = this;
        return (0, exports.ChatOpsApiFp)(this.configuration).chatOpsWechatWorkRobotCallback(appid, body, msgSignature, timestamp, nonce, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 企业微信机器人回调
     * @param {string} appid
     * @param {string} [msgSignature]
     * @param {string} [timestamp]
     * @param {string} [nonce]
     * @param {string} [echostr]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatOpsApi
     */
    ChatOpsApi.prototype.chatOpsWechatWorkRobotCallbackVerify = function (appid, msgSignature, timestamp, nonce, echostr, options) {
        var _this = this;
        return (0, exports.ChatOpsApiFp)(this.configuration).chatOpsWechatWorkRobotCallbackVerify(appid, msgSignature, timestamp, nonce, echostr, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ChatOpsApi;
}(base_1.BaseAPI));
exports.ChatOpsApi = ChatOpsApi;
/**
 * CodeverifyApi - axios parameter creator
 * @export
 */
var CodeverifyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary web或者app侧发送验证码，有图形验证，见：https://cloud.tencent.com/document/product/1110/36841
         * @param {CodeverifyAppSendReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeverifyAppSend: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('codeverifyAppSend', 'body', body);
                    localVarPath = "/api/codeverify/app/send";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取验证码
         * @param {string} [business] 业务.
         * @param {string} [phoneNumber] 手机号.
         * @param {string} [phoneCode] 国际区号.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeverifyGetCode: function (business, phoneNumber, phoneCode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/disable/api/codeverify/getcode";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (business !== undefined) {
                        localVarQueryParameter['business'] = business;
                    }
                    if (phoneNumber !== undefined) {
                        localVarQueryParameter['phone.number'] = phoneNumber;
                    }
                    if (phoneCode !== undefined) {
                        localVarQueryParameter['phone.code'] = phoneCode;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 小程序端发送验证码，有图形验证，见：https://cloud.tencent.com/document/product/1110/36841
         * @param {CodeverifyMiniprogramSendReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeverifyMiniprogramSend: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('codeverifyMiniprogramSend', 'body', body);
                    localVarPath = "/api/codeverify/mp/send";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {CodeverifySendRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeverifySend: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('codeverifySend', 'body', body);
                    localVarPath = "/disable/send";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {CodeverifyVerifyRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeverifyVerify: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('codeverifyVerify', 'body', body);
                    localVarPath = "/disable/api/verify";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CodeverifyApiAxiosParamCreator = CodeverifyApiAxiosParamCreator;
/**
 * CodeverifyApi - functional programming interface
 * @export
 */
var CodeverifyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CodeverifyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary web或者app侧发送验证码，有图形验证，见：https://cloud.tencent.com/document/product/1110/36841
         * @param {CodeverifyAppSendReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeverifyAppSend: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.codeverifyAppSend(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取验证码
         * @param {string} [business] 业务.
         * @param {string} [phoneNumber] 手机号.
         * @param {string} [phoneCode] 国际区号.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeverifyGetCode: function (business, phoneNumber, phoneCode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.codeverifyGetCode(business, phoneNumber, phoneCode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 小程序端发送验证码，有图形验证，见：https://cloud.tencent.com/document/product/1110/36841
         * @param {CodeverifyMiniprogramSendReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeverifyMiniprogramSend: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.codeverifyMiniprogramSend(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CodeverifySendRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeverifySend: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.codeverifySend(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CodeverifyVerifyRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeverifyVerify: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.codeverifyVerify(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CodeverifyApiFp = CodeverifyApiFp;
/**
 * CodeverifyApi - factory interface
 * @export
 */
var CodeverifyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CodeverifyApiFp)(configuration);
    return {
        /**
         *
         * @summary web或者app侧发送验证码，有图形验证，见：https://cloud.tencent.com/document/product/1110/36841
         * @param {CodeverifyAppSendReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeverifyAppSend: function (body, options) {
            return localVarFp.codeverifyAppSend(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取验证码
         * @param {string} [business] 业务.
         * @param {string} [phoneNumber] 手机号.
         * @param {string} [phoneCode] 国际区号.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeverifyGetCode: function (business, phoneNumber, phoneCode, options) {
            return localVarFp.codeverifyGetCode(business, phoneNumber, phoneCode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 小程序端发送验证码，有图形验证，见：https://cloud.tencent.com/document/product/1110/36841
         * @param {CodeverifyMiniprogramSendReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeverifyMiniprogramSend: function (body, options) {
            return localVarFp.codeverifyMiniprogramSend(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CodeverifySendRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeverifySend: function (body, options) {
            return localVarFp.codeverifySend(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CodeverifyVerifyRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeverifyVerify: function (body, options) {
            return localVarFp.codeverifyVerify(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CodeverifyApiFactory = CodeverifyApiFactory;
/**
 * CodeverifyApi - object-oriented interface
 * @export
 * @class CodeverifyApi
 * @extends {BaseAPI}
 */
var CodeverifyApi = /** @class */ (function (_super) {
    __extends(CodeverifyApi, _super);
    function CodeverifyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary web或者app侧发送验证码，有图形验证，见：https://cloud.tencent.com/document/product/1110/36841
     * @param {CodeverifyAppSendReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeverifyApi
     */
    CodeverifyApi.prototype.codeverifyAppSend = function (body, options) {
        var _this = this;
        return (0, exports.CodeverifyApiFp)(this.configuration).codeverifyAppSend(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取验证码
     * @param {string} [business] 业务.
     * @param {string} [phoneNumber] 手机号.
     * @param {string} [phoneCode] 国际区号.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeverifyApi
     */
    CodeverifyApi.prototype.codeverifyGetCode = function (business, phoneNumber, phoneCode, options) {
        var _this = this;
        return (0, exports.CodeverifyApiFp)(this.configuration).codeverifyGetCode(business, phoneNumber, phoneCode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 小程序端发送验证码，有图形验证，见：https://cloud.tencent.com/document/product/1110/36841
     * @param {CodeverifyMiniprogramSendReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeverifyApi
     */
    CodeverifyApi.prototype.codeverifyMiniprogramSend = function (body, options) {
        var _this = this;
        return (0, exports.CodeverifyApiFp)(this.configuration).codeverifyMiniprogramSend(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CodeverifySendRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeverifyApi
     */
    CodeverifyApi.prototype.codeverifySend = function (body, options) {
        var _this = this;
        return (0, exports.CodeverifyApiFp)(this.configuration).codeverifySend(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CodeverifyVerifyRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeverifyApi
     */
    CodeverifyApi.prototype.codeverifyVerify = function (body, options) {
        var _this = this;
        return (0, exports.CodeverifyApiFp)(this.configuration).codeverifyVerify(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CodeverifyApi;
}(base_1.BaseAPI));
exports.CodeverifyApi = CodeverifyApi;
/**
 * CommentApi - axios parameter creator
 * @export
 */
var CommentApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 创建 评论/回复
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {CommentCreateReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentCreate: function (entityType, entityId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('commentCreate', 'entityType', entityType);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('commentCreate', 'entityId', entityId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('commentCreate', 'body', body);
                    localVarPath = "/api/comment/{entity.type}/{entity.id}"
                        .replace("{".concat("entity.type", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("entity.id", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 删除 评论/回复
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} commentID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentDelete: function (entityType, commentID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('commentDelete', 'entityType', entityType);
                    // verify required parameter 'commentID' is not null or undefined
                    (0, common_1.assertParamExists)('commentDelete', 'commentID', commentID);
                    localVarPath = "/api/comment/{entityType}/{commentID}"
                        .replace("{".concat("entityType", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("commentID", "}"), encodeURIComponent(String(commentID)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取评论
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {string} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentGet: function (entityType, entityId, paginationId, paginationSize, paginationHasMore, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('commentGet', 'entityType', entityType);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('commentGet', 'entityId', entityId);
                    localVarPath = "/api/comment/comments/{entity.type}/{entity.id}"
                        .replace("{".concat("entity.type", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("entity.id", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationId !== undefined) {
                        localVarQueryParameter['pagination.id'] = paginationId;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取热评
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentGetHotComments: function (entityType, entityId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('commentGetHotComments', 'entityType', entityType);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('commentGetHotComments', 'entityId', entityId);
                    localVarPath = "/api/comment/hot-comments/{entity.type}/{entity.id}"
                        .replace("{".concat("entity.type", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("entity.id", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取回复 展开回复
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType 被评论主体
         * @param {string} commentID 评论id
         * @param {string} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentGetReplies: function (entityType, commentID, paginationId, paginationSize, paginationHasMore, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('commentGetReplies', 'entityType', entityType);
                    // verify required parameter 'commentID' is not null or undefined
                    (0, common_1.assertParamExists)('commentGetReplies', 'commentID', commentID);
                    localVarPath = "/api/comment/replies/{entityType}/{commentID}"
                        .replace("{".concat("entityType", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("commentID", "}"), encodeURIComponent(String(commentID)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationId !== undefined) {
                        localVarQueryParameter['pagination.id'] = paginationId;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取回复链 查看回复详情
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType 被评论主体
         * @param {string} commentID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentGetReplyChain: function (entityType, commentID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('commentGetReplyChain', 'entityType', entityType);
                    // verify required parameter 'commentID' is not null or undefined
                    (0, common_1.assertParamExists)('commentGetReplyChain', 'commentID', commentID);
                    localVarPath = "/api/comment/reply-chain/{entityType}/{commentID}"
                        .replace("{".concat("entityType", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("commentID", "}"), encodeURIComponent(String(commentID)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary IsValid 评论id是否是合法的
         * @param {string} commentHashId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentIsValid: function (commentHashId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'commentHashId' is not null or undefined
                    (0, common_1.assertParamExists)('commentIsValid', 'commentHashId', commentHashId);
                    localVarPath = "/admin/api/comment/isvalid/{commentHashId}"
                        .replace("{".concat("commentHashId", "}"), encodeURIComponent(String(commentHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 更新 评论/回复
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} commentID
         * @param {CommentUpdateReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentUpdate: function (entityType, commentID, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('commentUpdate', 'entityType', entityType);
                    // verify required parameter 'commentID' is not null or undefined
                    (0, common_1.assertParamExists)('commentUpdate', 'commentID', commentID);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('commentUpdate', 'body', body);
                    localVarPath = "/api/comment/{entityType}/{commentID}"
                        .replace("{".concat("entityType", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("commentID", "}"), encodeURIComponent(String(commentID)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CommentApiAxiosParamCreator = CommentApiAxiosParamCreator;
/**
 * CommentApi - functional programming interface
 * @export
 */
var CommentApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CommentApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 创建 评论/回复
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {CommentCreateReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentCreate: function (entityType, entityId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.commentCreate(entityType, entityId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 删除 评论/回复
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} commentID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentDelete: function (entityType, commentID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.commentDelete(entityType, commentID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取评论
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {string} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentGet: function (entityType, entityId, paginationId, paginationSize, paginationHasMore, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.commentGet(entityType, entityId, paginationId, paginationSize, paginationHasMore, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取热评
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentGetHotComments: function (entityType, entityId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.commentGetHotComments(entityType, entityId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取回复 展开回复
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType 被评论主体
         * @param {string} commentID 评论id
         * @param {string} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentGetReplies: function (entityType, commentID, paginationId, paginationSize, paginationHasMore, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.commentGetReplies(entityType, commentID, paginationId, paginationSize, paginationHasMore, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取回复链 查看回复详情
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType 被评论主体
         * @param {string} commentID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentGetReplyChain: function (entityType, commentID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.commentGetReplyChain(entityType, commentID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary IsValid 评论id是否是合法的
         * @param {string} commentHashId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentIsValid: function (commentHashId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.commentIsValid(commentHashId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 更新 评论/回复
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} commentID
         * @param {CommentUpdateReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentUpdate: function (entityType, commentID, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.commentUpdate(entityType, commentID, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CommentApiFp = CommentApiFp;
/**
 * CommentApi - factory interface
 * @export
 */
var CommentApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CommentApiFp)(configuration);
    return {
        /**
         *
         * @summary 创建 评论/回复
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {CommentCreateReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentCreate: function (entityType, entityId, body, options) {
            return localVarFp.commentCreate(entityType, entityId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 删除 评论/回复
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} commentID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentDelete: function (entityType, commentID, options) {
            return localVarFp.commentDelete(entityType, commentID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取评论
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {string} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentGet: function (entityType, entityId, paginationId, paginationSize, paginationHasMore, options) {
            return localVarFp.commentGet(entityType, entityId, paginationId, paginationSize, paginationHasMore, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取热评
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentGetHotComments: function (entityType, entityId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return localVarFp.commentGetHotComments(entityType, entityId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取回复 展开回复
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType 被评论主体
         * @param {string} commentID 评论id
         * @param {string} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentGetReplies: function (entityType, commentID, paginationId, paginationSize, paginationHasMore, options) {
            return localVarFp.commentGetReplies(entityType, commentID, paginationId, paginationSize, paginationHasMore, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取回复链 查看回复详情
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType 被评论主体
         * @param {string} commentID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentGetReplyChain: function (entityType, commentID, options) {
            return localVarFp.commentGetReplyChain(entityType, commentID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary IsValid 评论id是否是合法的
         * @param {string} commentHashId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentIsValid: function (commentHashId, options) {
            return localVarFp.commentIsValid(commentHashId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 更新 评论/回复
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} commentID
         * @param {CommentUpdateReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentUpdate: function (entityType, commentID, body, options) {
            return localVarFp.commentUpdate(entityType, commentID, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CommentApiFactory = CommentApiFactory;
/**
 * CommentApi - object-oriented interface
 * @export
 * @class CommentApi
 * @extends {BaseAPI}
 */
var CommentApi = /** @class */ (function (_super) {
    __extends(CommentApi, _super);
    function CommentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 创建 评论/回复
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} entityId
     * @param {CommentCreateReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentApi
     */
    CommentApi.prototype.commentCreate = function (entityType, entityId, body, options) {
        var _this = this;
        return (0, exports.CommentApiFp)(this.configuration).commentCreate(entityType, entityId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 删除 评论/回复
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} commentID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentApi
     */
    CommentApi.prototype.commentDelete = function (entityType, commentID, options) {
        var _this = this;
        return (0, exports.CommentApiFp)(this.configuration).commentDelete(entityType, commentID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取评论
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} entityId
     * @param {string} [paginationId] id 标识符.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentApi
     */
    CommentApi.prototype.commentGet = function (entityType, entityId, paginationId, paginationSize, paginationHasMore, options) {
        var _this = this;
        return (0, exports.CommentApiFp)(this.configuration).commentGet(entityType, entityId, paginationId, paginationSize, paginationHasMore, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取热评
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} entityId
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentApi
     */
    CommentApi.prototype.commentGetHotComments = function (entityType, entityId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
        var _this = this;
        return (0, exports.CommentApiFp)(this.configuration).commentGetHotComments(entityType, entityId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取回复 展开回复
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType 被评论主体
     * @param {string} commentID 评论id
     * @param {string} [paginationId] id 标识符.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentApi
     */
    CommentApi.prototype.commentGetReplies = function (entityType, commentID, paginationId, paginationSize, paginationHasMore, options) {
        var _this = this;
        return (0, exports.CommentApiFp)(this.configuration).commentGetReplies(entityType, commentID, paginationId, paginationSize, paginationHasMore, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取回复链 查看回复详情
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType 被评论主体
     * @param {string} commentID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentApi
     */
    CommentApi.prototype.commentGetReplyChain = function (entityType, commentID, options) {
        var _this = this;
        return (0, exports.CommentApiFp)(this.configuration).commentGetReplyChain(entityType, commentID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary IsValid 评论id是否是合法的
     * @param {string} commentHashId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentApi
     */
    CommentApi.prototype.commentIsValid = function (commentHashId, options) {
        var _this = this;
        return (0, exports.CommentApiFp)(this.configuration).commentIsValid(commentHashId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 更新 评论/回复
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} commentID
     * @param {CommentUpdateReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentApi
     */
    CommentApi.prototype.commentUpdate = function (entityType, commentID, body, options) {
        var _this = this;
        return (0, exports.CommentApiFp)(this.configuration).commentUpdate(entityType, commentID, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CommentApi;
}(base_1.BaseAPI));
exports.CommentApi = CommentApi;
/**
 * ComplainApi - axios parameter creator
 * @export
 */
var ComplainApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 投诉项列表
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complainComplainItems: function (entityName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityName' is not null or undefined
                    (0, common_1.assertParamExists)('complainComplainItems', 'entityName', entityName);
                    localVarPath = "/api/complain/items/{entity_name}"
                        .replace("{".concat("entity_name", "}"), encodeURIComponent(String(entityName)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 投诉列表 - 后台用
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [entityId]
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} [entityType]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {number} [itemId] 投诉项的id.
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complainComplainList: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, entityId, entityType, itemId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/api/complain/list";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (entityId !== undefined) {
                        localVarQueryParameter['entity.id'] = entityId;
                    }
                    if (entityType !== undefined) {
                        localVarQueryParameter['entity.type'] = entityType;
                    }
                    if (itemId !== undefined) {
                        localVarQueryParameter['item_id'] = itemId;
                    }
                    if (userId !== undefined) {
                        localVarQueryParameter['user_id'] = userId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 投诉
         * @param {ComplainCreateReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complainCreateComplain: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('complainCreateComplain', 'body', body);
                    localVarPath = "/api/complain";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ComplainApiAxiosParamCreator = ComplainApiAxiosParamCreator;
/**
 * ComplainApi - functional programming interface
 * @export
 */
var ComplainApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ComplainApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 投诉项列表
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complainComplainItems: function (entityName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.complainComplainItems(entityName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 投诉列表 - 后台用
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [entityId]
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} [entityType]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {number} [itemId] 投诉项的id.
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complainComplainList: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, entityId, entityType, itemId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.complainComplainList(paginationPage, paginationSize, paginationHasMore, paginationTotal, entityId, entityType, itemId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 投诉
         * @param {ComplainCreateReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complainCreateComplain: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.complainCreateComplain(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ComplainApiFp = ComplainApiFp;
/**
 * ComplainApi - factory interface
 * @export
 */
var ComplainApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ComplainApiFp)(configuration);
    return {
        /**
         *
         * @summary 投诉项列表
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complainComplainItems: function (entityName, options) {
            return localVarFp.complainComplainItems(entityName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 投诉列表 - 后台用
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [entityId]
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} [entityType]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {number} [itemId] 投诉项的id.
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complainComplainList: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, entityId, entityType, itemId, userId, options) {
            return localVarFp.complainComplainList(paginationPage, paginationSize, paginationHasMore, paginationTotal, entityId, entityType, itemId, userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 投诉
         * @param {ComplainCreateReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complainCreateComplain: function (body, options) {
            return localVarFp.complainCreateComplain(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ComplainApiFactory = ComplainApiFactory;
/**
 * ComplainApi - object-oriented interface
 * @export
 * @class ComplainApi
 * @extends {BaseAPI}
 */
var ComplainApi = /** @class */ (function (_super) {
    __extends(ComplainApi, _super);
    function ComplainApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 投诉项列表
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplainApi
     */
    ComplainApi.prototype.complainComplainItems = function (entityName, options) {
        var _this = this;
        return (0, exports.ComplainApiFp)(this.configuration).complainComplainItems(entityName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 投诉列表 - 后台用
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {string} [entityId]
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} [entityType]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
     * @param {number} [itemId] 投诉项的id.
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplainApi
     */
    ComplainApi.prototype.complainComplainList = function (paginationPage, paginationSize, paginationHasMore, paginationTotal, entityId, entityType, itemId, userId, options) {
        var _this = this;
        return (0, exports.ComplainApiFp)(this.configuration).complainComplainList(paginationPage, paginationSize, paginationHasMore, paginationTotal, entityId, entityType, itemId, userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 投诉
     * @param {ComplainCreateReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplainApi
     */
    ComplainApi.prototype.complainCreateComplain = function (body, options) {
        var _this = this;
        return (0, exports.ComplainApiFp)(this.configuration).complainCreateComplain(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ComplainApi;
}(base_1.BaseAPI));
exports.ComplainApi = ComplainApi;
/**
 * CtmsApi - axios parameter creator
 * @export
 */
var CtmsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 是否存在敏感词
         * @param {CtmsHasReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ctmsHas: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ctmsHas', 'body', body);
                    localVarPath = "/disable/ctms/has";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CtmsApiAxiosParamCreator = CtmsApiAxiosParamCreator;
/**
 * CtmsApi - functional programming interface
 * @export
 */
var CtmsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CtmsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 是否存在敏感词
         * @param {CtmsHasReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ctmsHas: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ctmsHas(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CtmsApiFp = CtmsApiFp;
/**
 * CtmsApi - factory interface
 * @export
 */
var CtmsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CtmsApiFp)(configuration);
    return {
        /**
         *
         * @summary 是否存在敏感词
         * @param {CtmsHasReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ctmsHas: function (body, options) {
            return localVarFp.ctmsHas(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CtmsApiFactory = CtmsApiFactory;
/**
 * CtmsApi - object-oriented interface
 * @export
 * @class CtmsApi
 * @extends {BaseAPI}
 */
var CtmsApi = /** @class */ (function (_super) {
    __extends(CtmsApi, _super);
    function CtmsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 是否存在敏感词
     * @param {CtmsHasReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CtmsApi
     */
    CtmsApi.prototype.ctmsHas = function (body, options) {
        var _this = this;
        return (0, exports.CtmsApiFp)(this.configuration).ctmsHas(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CtmsApi;
}(base_1.BaseAPI));
exports.CtmsApi = CtmsApi;
/**
 * DashboardApi - axios parameter creator
 * @export
 */
var DashboardApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {DashboardHashIDReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardHashID: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('dashboardHashID', 'body', body);
                    localVarPath = "/admin/api/dashboard/hashid";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 查询列表数据
         * @param {DashboardQueryRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardQuery: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('dashboardQuery', 'body', body);
                    localVarPath = "/admin/api/dashboard/query";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 搜索联合发布者
         * @param {DashboardSearchResearchCreatorsReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardSearchResearchCreators: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('dashboardSearchResearchCreators', 'body', body);
                    localVarPath = "/api/dashboard/research/creators";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DashboardApiAxiosParamCreator = DashboardApiAxiosParamCreator;
/**
 * DashboardApi - functional programming interface
 * @export
 */
var DashboardApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DashboardApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {DashboardHashIDReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardHashID: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dashboardHashID(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 查询列表数据
         * @param {DashboardQueryRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardQuery: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dashboardQuery(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 搜索联合发布者
         * @param {DashboardSearchResearchCreatorsReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardSearchResearchCreators: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dashboardSearchResearchCreators(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DashboardApiFp = DashboardApiFp;
/**
 * DashboardApi - factory interface
 * @export
 */
var DashboardApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DashboardApiFp)(configuration);
    return {
        /**
         *
         * @param {DashboardHashIDReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardHashID: function (body, options) {
            return localVarFp.dashboardHashID(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 查询列表数据
         * @param {DashboardQueryRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardQuery: function (body, options) {
            return localVarFp.dashboardQuery(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 搜索联合发布者
         * @param {DashboardSearchResearchCreatorsReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardSearchResearchCreators: function (body, options) {
            return localVarFp.dashboardSearchResearchCreators(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DashboardApiFactory = DashboardApiFactory;
/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
var DashboardApi = /** @class */ (function (_super) {
    __extends(DashboardApi, _super);
    function DashboardApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {DashboardHashIDReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    DashboardApi.prototype.dashboardHashID = function (body, options) {
        var _this = this;
        return (0, exports.DashboardApiFp)(this.configuration).dashboardHashID(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 查询列表数据
     * @param {DashboardQueryRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    DashboardApi.prototype.dashboardQuery = function (body, options) {
        var _this = this;
        return (0, exports.DashboardApiFp)(this.configuration).dashboardQuery(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 搜索联合发布者
     * @param {DashboardSearchResearchCreatorsReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    DashboardApi.prototype.dashboardSearchResearchCreators = function (body, options) {
        var _this = this;
        return (0, exports.DashboardApiFp)(this.configuration).dashboardSearchResearchCreators(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DashboardApi;
}(base_1.BaseAPI));
exports.DashboardApi = DashboardApi;
/**
 * DocumentApi - axios parameter creator
 * @export
 */
var DocumentApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 创建文档
         * @param {DocumentCreateDocumentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentCreateDocument: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('documentCreateDocument', 'body', body);
                    localVarPath = "/api/document/documents";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 创建任务
         * @param {DocumentCreateTaskRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentCreateTask: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('documentCreateTask', 'body', body);
                    localVarPath = "/api/document/tasks";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取文档基础信息
         * @param {string} [entityId]
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} [entityType]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {string} [customType] 用户自定义类型.
         * @param {string} [documentHashId] 文档 hash id（entity,custom_type和document_hash_id二选一）.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetDocument: function (entityId, entityType, customType, documentHashId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/document/documents";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (entityId !== undefined) {
                        localVarQueryParameter['entity.id'] = entityId;
                    }
                    if (entityType !== undefined) {
                        localVarQueryParameter['entity.type'] = entityType;
                    }
                    if (customType !== undefined) {
                        localVarQueryParameter['customType'] = customType;
                    }
                    if (documentHashId !== undefined) {
                        localVarQueryParameter['documentHashId'] = documentHashId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取文档详细信息，包括已经处理的任务信息和任务id
         * @param {string} [entityId]
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} [entityType]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {string} [customType] 用户自定义类型.
         * @param {string} [documentHashId] 文档 hash id（entity,custom_type和document_hash_id二选一）.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetDocumentDetail: function (entityId, entityType, customType, documentHashId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/document/documents/detail";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (entityId !== undefined) {
                        localVarQueryParameter['entity.id'] = entityId;
                    }
                    if (entityType !== undefined) {
                        localVarQueryParameter['entity.type'] = entityType;
                    }
                    if (customType !== undefined) {
                        localVarQueryParameter['customType'] = customType;
                    }
                    if (documentHashId !== undefined) {
                        localVarQueryParameter['documentHashId'] = documentHashId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 下载 File 里的值
         * @param {string} fileUuid 文件 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetFile: function (fileUuid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'fileUuid' is not null or undefined
                    (0, common_1.assertParamExists)('documentGetFile', 'fileUuid', fileUuid);
                    localVarPath = "/api/document/files/{fileUuid}"
                        .replace("{".concat("fileUuid", "}"), encodeURIComponent(String(fileUuid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取处理详细信息
         * @param {number} processId 任务 process_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetProcess: function (processId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'processId' is not null or undefined
                    (0, common_1.assertParamExists)('documentGetProcess', 'processId', processId);
                    localVarPath = "/api/document/processes/{processId}"
                        .replace("{".concat("processId", "}"), encodeURIComponent(String(processId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取任务信息,包括基础信息状态和结果
         * @param {string} taskHashId 任务 hash id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetTask: function (taskHashId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'taskHashId' is not null or undefined
                    (0, common_1.assertParamExists)('documentGetTask', 'taskHashId', taskHashId);
                    localVarPath = "/api/document/tasks/{taskHashId}"
                        .replace("{".concat("taskHashId", "}"), encodeURIComponent(String(taskHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DocumentApiAxiosParamCreator = DocumentApiAxiosParamCreator;
/**
 * DocumentApi - functional programming interface
 * @export
 */
var DocumentApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DocumentApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 创建文档
         * @param {DocumentCreateDocumentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentCreateDocument: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.documentCreateDocument(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 创建任务
         * @param {DocumentCreateTaskRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentCreateTask: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.documentCreateTask(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取文档基础信息
         * @param {string} [entityId]
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} [entityType]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {string} [customType] 用户自定义类型.
         * @param {string} [documentHashId] 文档 hash id（entity,custom_type和document_hash_id二选一）.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetDocument: function (entityId, entityType, customType, documentHashId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.documentGetDocument(entityId, entityType, customType, documentHashId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取文档详细信息，包括已经处理的任务信息和任务id
         * @param {string} [entityId]
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} [entityType]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {string} [customType] 用户自定义类型.
         * @param {string} [documentHashId] 文档 hash id（entity,custom_type和document_hash_id二选一）.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetDocumentDetail: function (entityId, entityType, customType, documentHashId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.documentGetDocumentDetail(entityId, entityType, customType, documentHashId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 下载 File 里的值
         * @param {string} fileUuid 文件 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetFile: function (fileUuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.documentGetFile(fileUuid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取处理详细信息
         * @param {number} processId 任务 process_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetProcess: function (processId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.documentGetProcess(processId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取任务信息,包括基础信息状态和结果
         * @param {string} taskHashId 任务 hash id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetTask: function (taskHashId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.documentGetTask(taskHashId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DocumentApiFp = DocumentApiFp;
/**
 * DocumentApi - factory interface
 * @export
 */
var DocumentApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DocumentApiFp)(configuration);
    return {
        /**
         *
         * @summary 创建文档
         * @param {DocumentCreateDocumentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentCreateDocument: function (body, options) {
            return localVarFp.documentCreateDocument(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 创建任务
         * @param {DocumentCreateTaskRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentCreateTask: function (body, options) {
            return localVarFp.documentCreateTask(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取文档基础信息
         * @param {string} [entityId]
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} [entityType]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {string} [customType] 用户自定义类型.
         * @param {string} [documentHashId] 文档 hash id（entity,custom_type和document_hash_id二选一）.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetDocument: function (entityId, entityType, customType, documentHashId, options) {
            return localVarFp.documentGetDocument(entityId, entityType, customType, documentHashId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取文档详细信息，包括已经处理的任务信息和任务id
         * @param {string} [entityId]
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} [entityType]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {string} [customType] 用户自定义类型.
         * @param {string} [documentHashId] 文档 hash id（entity,custom_type和document_hash_id二选一）.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetDocumentDetail: function (entityId, entityType, customType, documentHashId, options) {
            return localVarFp.documentGetDocumentDetail(entityId, entityType, customType, documentHashId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 下载 File 里的值
         * @param {string} fileUuid 文件 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetFile: function (fileUuid, options) {
            return localVarFp.documentGetFile(fileUuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取处理详细信息
         * @param {number} processId 任务 process_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetProcess: function (processId, options) {
            return localVarFp.documentGetProcess(processId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取任务信息,包括基础信息状态和结果
         * @param {string} taskHashId 任务 hash id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetTask: function (taskHashId, options) {
            return localVarFp.documentGetTask(taskHashId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DocumentApiFactory = DocumentApiFactory;
/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
var DocumentApi = /** @class */ (function (_super) {
    __extends(DocumentApi, _super);
    function DocumentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 创建文档
     * @param {DocumentCreateDocumentRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    DocumentApi.prototype.documentCreateDocument = function (body, options) {
        var _this = this;
        return (0, exports.DocumentApiFp)(this.configuration).documentCreateDocument(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 创建任务
     * @param {DocumentCreateTaskRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    DocumentApi.prototype.documentCreateTask = function (body, options) {
        var _this = this;
        return (0, exports.DocumentApiFp)(this.configuration).documentCreateTask(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取文档基础信息
     * @param {string} [entityId]
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} [entityType]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
     * @param {string} [customType] 用户自定义类型.
     * @param {string} [documentHashId] 文档 hash id（entity,custom_type和document_hash_id二选一）.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    DocumentApi.prototype.documentGetDocument = function (entityId, entityType, customType, documentHashId, options) {
        var _this = this;
        return (0, exports.DocumentApiFp)(this.configuration).documentGetDocument(entityId, entityType, customType, documentHashId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取文档详细信息，包括已经处理的任务信息和任务id
     * @param {string} [entityId]
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} [entityType]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
     * @param {string} [customType] 用户自定义类型.
     * @param {string} [documentHashId] 文档 hash id（entity,custom_type和document_hash_id二选一）.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    DocumentApi.prototype.documentGetDocumentDetail = function (entityId, entityType, customType, documentHashId, options) {
        var _this = this;
        return (0, exports.DocumentApiFp)(this.configuration).documentGetDocumentDetail(entityId, entityType, customType, documentHashId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 下载 File 里的值
     * @param {string} fileUuid 文件 uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    DocumentApi.prototype.documentGetFile = function (fileUuid, options) {
        var _this = this;
        return (0, exports.DocumentApiFp)(this.configuration).documentGetFile(fileUuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取处理详细信息
     * @param {number} processId 任务 process_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    DocumentApi.prototype.documentGetProcess = function (processId, options) {
        var _this = this;
        return (0, exports.DocumentApiFp)(this.configuration).documentGetProcess(processId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取任务信息,包括基础信息状态和结果
     * @param {string} taskHashId 任务 hash id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    DocumentApi.prototype.documentGetTask = function (taskHashId, options) {
        var _this = this;
        return (0, exports.DocumentApiFp)(this.configuration).documentGetTask(taskHashId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DocumentApi;
}(base_1.BaseAPI));
exports.DocumentApi = DocumentApi;
/**
 * FeedApi - axios parameter creator
 * @export
 */
var FeedApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary feed流列表
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app 业务名称
         * @param {string} [paginationCursor] cursor 游标.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedFeedList: function (app, paginationCursor, paginationSize, paginationHasMore, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('feedFeedList', 'app', app);
                    localVarPath = "/api/feed/{app}"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationCursor !== undefined) {
                        localVarQueryParameter['pagination.cursor'] = paginationCursor;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FeedApiAxiosParamCreator = FeedApiAxiosParamCreator;
/**
 * FeedApi - functional programming interface
 * @export
 */
var FeedApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FeedApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary feed流列表
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app 业务名称
         * @param {string} [paginationCursor] cursor 游标.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedFeedList: function (app, paginationCursor, paginationSize, paginationHasMore, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.feedFeedList(app, paginationCursor, paginationSize, paginationHasMore, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FeedApiFp = FeedApiFp;
/**
 * FeedApi - factory interface
 * @export
 */
var FeedApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FeedApiFp)(configuration);
    return {
        /**
         *
         * @summary feed流列表
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app 业务名称
         * @param {string} [paginationCursor] cursor 游标.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedFeedList: function (app, paginationCursor, paginationSize, paginationHasMore, options) {
            return localVarFp.feedFeedList(app, paginationCursor, paginationSize, paginationHasMore, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FeedApiFactory = FeedApiFactory;
/**
 * FeedApi - object-oriented interface
 * @export
 * @class FeedApi
 * @extends {BaseAPI}
 */
var FeedApi = /** @class */ (function (_super) {
    __extends(FeedApi, _super);
    function FeedApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary feed流列表
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app 业务名称
     * @param {string} [paginationCursor] cursor 游标.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedApi
     */
    FeedApi.prototype.feedFeedList = function (app, paginationCursor, paginationSize, paginationHasMore, options) {
        var _this = this;
        return (0, exports.FeedApiFp)(this.configuration).feedFeedList(app, paginationCursor, paginationSize, paginationHasMore, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FeedApi;
}(base_1.BaseAPI));
exports.FeedApi = FeedApi;
/**
 * HelloApi - axios parameter creator
 * @export
 */
var HelloApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {HelloHelloRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helloSayHello: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('helloSayHello', 'body', body);
                    localVarPath = "/v1/example/echo";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.HelloApiAxiosParamCreator = HelloApiAxiosParamCreator;
/**
 * HelloApi - functional programming interface
 * @export
 */
var HelloApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HelloApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {HelloHelloRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helloSayHello: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.helloSayHello(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.HelloApiFp = HelloApiFp;
/**
 * HelloApi - factory interface
 * @export
 */
var HelloApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HelloApiFp)(configuration);
    return {
        /**
         *
         * @param {HelloHelloRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helloSayHello: function (body, options) {
            return localVarFp.helloSayHello(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HelloApiFactory = HelloApiFactory;
/**
 * HelloApi - object-oriented interface
 * @export
 * @class HelloApi
 * @extends {BaseAPI}
 */
var HelloApi = /** @class */ (function (_super) {
    __extends(HelloApi, _super);
    function HelloApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {HelloHelloRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelloApi
     */
    HelloApi.prototype.helloSayHello = function (body, options) {
        var _this = this;
        return (0, exports.HelloApiFp)(this.configuration).helloSayHello(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HelloApi;
}(base_1.BaseAPI));
exports.HelloApi = HelloApi;
/**
 * HttpProxyApi - axios parameter creator
 * @export
 */
var HttpProxyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {HttpproxyWJProxyReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        httpProxyWJProxy: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('httpProxyWJProxy', 'body', body);
                    localVarPath = "/api/httpproxy/wj";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.HttpProxyApiAxiosParamCreator = HttpProxyApiAxiosParamCreator;
/**
 * HttpProxyApi - functional programming interface
 * @export
 */
var HttpProxyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HttpProxyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {HttpproxyWJProxyReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        httpProxyWJProxy: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.httpProxyWJProxy(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.HttpProxyApiFp = HttpProxyApiFp;
/**
 * HttpProxyApi - factory interface
 * @export
 */
var HttpProxyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HttpProxyApiFp)(configuration);
    return {
        /**
         *
         * @param {HttpproxyWJProxyReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        httpProxyWJProxy: function (body, options) {
            return localVarFp.httpProxyWJProxy(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HttpProxyApiFactory = HttpProxyApiFactory;
/**
 * HttpProxyApi - object-oriented interface
 * @export
 * @class HttpProxyApi
 * @extends {BaseAPI}
 */
var HttpProxyApi = /** @class */ (function (_super) {
    __extends(HttpProxyApi, _super);
    function HttpProxyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {HttpproxyWJProxyReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HttpProxyApi
     */
    HttpProxyApi.prototype.httpProxyWJProxy = function (body, options) {
        var _this = this;
        return (0, exports.HttpProxyApiFp)(this.configuration).httpProxyWJProxy(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HttpProxyApi;
}(base_1.BaseAPI));
exports.HttpProxyApi = HttpProxyApi;
/**
 * IpcityApi - axios parameter creator
 * @export
 */
var IpcityApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 获取指定事件的ip信息
         * @param {IpcityGetEventIPReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ipcityGetEventIP: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ipcityGetEventIP', 'body', body);
                    localVarPath = "/api/ipcity/event/ip";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {IpcityIP} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ipcityIsTencentIp: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ipcityIsTencentIp', 'body', body);
                    localVarPath = "/disable/api/ipcity/istencentip";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {IpcityIP} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ipcitySearch: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ipcitySearch', 'body', body);
                    localVarPath = "/disable/api/ipcity/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.IpcityApiAxiosParamCreator = IpcityApiAxiosParamCreator;
/**
 * IpcityApi - functional programming interface
 * @export
 */
var IpcityApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.IpcityApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 获取指定事件的ip信息
         * @param {IpcityGetEventIPReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ipcityGetEventIP: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ipcityGetEventIP(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {IpcityIP} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ipcityIsTencentIp: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ipcityIsTencentIp(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {IpcityIP} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ipcitySearch: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ipcitySearch(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.IpcityApiFp = IpcityApiFp;
/**
 * IpcityApi - factory interface
 * @export
 */
var IpcityApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.IpcityApiFp)(configuration);
    return {
        /**
         *
         * @summary 获取指定事件的ip信息
         * @param {IpcityGetEventIPReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ipcityGetEventIP: function (body, options) {
            return localVarFp.ipcityGetEventIP(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {IpcityIP} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ipcityIsTencentIp: function (body, options) {
            return localVarFp.ipcityIsTencentIp(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {IpcityIP} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ipcitySearch: function (body, options) {
            return localVarFp.ipcitySearch(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.IpcityApiFactory = IpcityApiFactory;
/**
 * IpcityApi - object-oriented interface
 * @export
 * @class IpcityApi
 * @extends {BaseAPI}
 */
var IpcityApi = /** @class */ (function (_super) {
    __extends(IpcityApi, _super);
    function IpcityApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 获取指定事件的ip信息
     * @param {IpcityGetEventIPReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IpcityApi
     */
    IpcityApi.prototype.ipcityGetEventIP = function (body, options) {
        var _this = this;
        return (0, exports.IpcityApiFp)(this.configuration).ipcityGetEventIP(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {IpcityIP} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IpcityApi
     */
    IpcityApi.prototype.ipcityIsTencentIp = function (body, options) {
        var _this = this;
        return (0, exports.IpcityApiFp)(this.configuration).ipcityIsTencentIp(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {IpcityIP} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IpcityApi
     */
    IpcityApi.prototype.ipcitySearch = function (body, options) {
        var _this = this;
        return (0, exports.IpcityApiFp)(this.configuration).ipcitySearch(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return IpcityApi;
}(base_1.BaseAPI));
exports.IpcityApi = IpcityApi;
/**
 * LikeApi - axios parameter creator
 * @export
 */
var LikeApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {LikeLikeCountRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likeLikeCount: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('likeLikeCount', 'body', body);
                    localVarPath = "/api/micro/txc/like/count";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {LikeLikeStatusRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likeLikeStatus: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('likeLikeStatus', 'body', body);
                    localVarPath = "/api/micro/txc/like/status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.LikeApiAxiosParamCreator = LikeApiAxiosParamCreator;
/**
 * LikeApi - functional programming interface
 * @export
 */
var LikeApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LikeApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {LikeLikeCountRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likeLikeCount: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.likeLikeCount(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {LikeLikeStatusRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likeLikeStatus: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.likeLikeStatus(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LikeApiFp = LikeApiFp;
/**
 * LikeApi - factory interface
 * @export
 */
var LikeApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LikeApiFp)(configuration);
    return {
        /**
         *
         * @param {LikeLikeCountRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likeLikeCount: function (body, options) {
            return localVarFp.likeLikeCount(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {LikeLikeStatusRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likeLikeStatus: function (body, options) {
            return localVarFp.likeLikeStatus(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LikeApiFactory = LikeApiFactory;
/**
 * LikeApi - object-oriented interface
 * @export
 * @class LikeApi
 * @extends {BaseAPI}
 */
var LikeApi = /** @class */ (function (_super) {
    __extends(LikeApi, _super);
    function LikeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {LikeLikeCountRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LikeApi
     */
    LikeApi.prototype.likeLikeCount = function (body, options) {
        var _this = this;
        return (0, exports.LikeApiFp)(this.configuration).likeLikeCount(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {LikeLikeStatusRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LikeApi
     */
    LikeApi.prototype.likeLikeStatus = function (body, options) {
        var _this = this;
        return (0, exports.LikeApiFp)(this.configuration).likeLikeStatus(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LikeApi;
}(base_1.BaseAPI));
exports.LikeApi = LikeApi;
/**
 * MessageApi - axios parameter creator
 * @export
 */
var MessageApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {MessageRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageSendMessage: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('messageSendMessage', 'body', body);
                    localVarPath = "/v1/example/test";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.MessageApiAxiosParamCreator = MessageApiAxiosParamCreator;
/**
 * MessageApi - functional programming interface
 * @export
 */
var MessageApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MessageApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {MessageRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageSendMessage: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.messageSendMessage(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.MessageApiFp = MessageApiFp;
/**
 * MessageApi - factory interface
 * @export
 */
var MessageApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MessageApiFp)(configuration);
    return {
        /**
         *
         * @param {MessageRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageSendMessage: function (body, options) {
            return localVarFp.messageSendMessage(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MessageApiFactory = MessageApiFactory;
/**
 * MessageApi - object-oriented interface
 * @export
 * @class MessageApi
 * @extends {BaseAPI}
 */
var MessageApi = /** @class */ (function (_super) {
    __extends(MessageApi, _super);
    function MessageApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {MessageRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    MessageApi.prototype.messageSendMessage = function (body, options) {
        var _this = this;
        return (0, exports.MessageApiFp)(this.configuration).messageSendMessage(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MessageApi;
}(base_1.BaseAPI));
exports.MessageApi = MessageApi;
/**
 * MicroproxyApi - axios parameter creator
 * @export
 */
var MicroproxyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 志愿者系统跟ieg的openid转换
         * @param {MicroproxyOpenidConvertReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        microproxyOpenidConvert: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('microproxyOpenidConvert', 'body', body);
                    localVarPath = "/api/microproxy/openid-convert";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 请求内部rpc接口
         * @param {MicroproxyReqData} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        microproxyRequest: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('microproxyRequest', 'body', body);
                    localVarPath = "/api/microproxy/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.MicroproxyApiAxiosParamCreator = MicroproxyApiAxiosParamCreator;
/**
 * MicroproxyApi - functional programming interface
 * @export
 */
var MicroproxyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MicroproxyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 志愿者系统跟ieg的openid转换
         * @param {MicroproxyOpenidConvertReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        microproxyOpenidConvert: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.microproxyOpenidConvert(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 请求内部rpc接口
         * @param {MicroproxyReqData} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        microproxyRequest: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.microproxyRequest(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.MicroproxyApiFp = MicroproxyApiFp;
/**
 * MicroproxyApi - factory interface
 * @export
 */
var MicroproxyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MicroproxyApiFp)(configuration);
    return {
        /**
         *
         * @summary 志愿者系统跟ieg的openid转换
         * @param {MicroproxyOpenidConvertReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        microproxyOpenidConvert: function (body, options) {
            return localVarFp.microproxyOpenidConvert(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 请求内部rpc接口
         * @param {MicroproxyReqData} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        microproxyRequest: function (body, options) {
            return localVarFp.microproxyRequest(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MicroproxyApiFactory = MicroproxyApiFactory;
/**
 * MicroproxyApi - object-oriented interface
 * @export
 * @class MicroproxyApi
 * @extends {BaseAPI}
 */
var MicroproxyApi = /** @class */ (function (_super) {
    __extends(MicroproxyApi, _super);
    function MicroproxyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 志愿者系统跟ieg的openid转换
     * @param {MicroproxyOpenidConvertReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MicroproxyApi
     */
    MicroproxyApi.prototype.microproxyOpenidConvert = function (body, options) {
        var _this = this;
        return (0, exports.MicroproxyApiFp)(this.configuration).microproxyOpenidConvert(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 请求内部rpc接口
     * @param {MicroproxyReqData} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MicroproxyApi
     */
    MicroproxyApi.prototype.microproxyRequest = function (body, options) {
        var _this = this;
        return (0, exports.MicroproxyApiFp)(this.configuration).microproxyRequest(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MicroproxyApi;
}(base_1.BaseAPI));
exports.MicroproxyApi = MicroproxyApi;
/**
 * NoticeApi - axios parameter creator
 * @export
 */
var NoticeApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 获取消息提醒开关
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeGetRemindSwitch: function (app, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/notice/remind-switch";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (app !== undefined) {
                        localVarQueryParameter['app'] = app;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 标记为已读
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} filterAppName
         * @param {NoticeMarkAsReadReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeMarkAsRead: function (filterAppName, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'filterAppName' is not null or undefined
                    (0, common_1.assertParamExists)('noticeMarkAsRead', 'filterAppName', filterAppName);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('noticeMarkAsRead', 'body', body);
                    localVarPath = "/api/notice/read/{filter.appName}"
                        .replace("{".concat("filter.appName", "}"), encodeURIComponent(String(filterAppName)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 通知列表
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} filterAppName
         * @param {Array<'INVALID_ACTION' | 'Comment' | 'Like' | 'Collect' | 'Nps' | 'SystemAudit' | 'SystemUnpublish'>} [filterActionTypes]  - INVALID_ACTION: 占位  - Comment: 评论  - Like: 赞  - Collect: 收藏  - Nps: 评分  - SystemAudit: 系统审核  - SystemUnpublish: 系统下架
         * @param {Array<'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'>} [filterEntityTypes]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeNoticeList: function (filterAppName, filterActionTypes, filterEntityTypes, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'filterAppName' is not null or undefined
                    (0, common_1.assertParamExists)('noticeNoticeList', 'filterAppName', filterAppName);
                    localVarPath = "/api/notice/{filter.appName}"
                        .replace("{".concat("filter.appName", "}"), encodeURIComponent(String(filterAppName)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (filterActionTypes) {
                        localVarQueryParameter['filter.actionTypes'] = filterActionTypes;
                    }
                    if (filterEntityTypes) {
                        localVarQueryParameter['filter.entityTypes'] = filterEntityTypes;
                    }
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 设置消息提醒开关
         * @param {NoticeSetRemindSwitchReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeSetRemindSwitch: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('noticeSetRemindSwitch', 'body', body);
                    localVarPath = "/api/notice/remind-switch";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 未读消息数
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} filterAppName
         * @param {Array<'INVALID_ACTION' | 'Comment' | 'Like' | 'Collect' | 'Nps' | 'SystemAudit' | 'SystemUnpublish'>} [filterActionTypes]  - INVALID_ACTION: 占位  - Comment: 评论  - Like: 赞  - Collect: 收藏  - Nps: 评分  - SystemAudit: 系统审核  - SystemUnpublish: 系统下架
         * @param {Array<'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'>} [filterEntityTypes]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeUnreadCount: function (filterAppName, filterActionTypes, filterEntityTypes, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'filterAppName' is not null or undefined
                    (0, common_1.assertParamExists)('noticeUnreadCount', 'filterAppName', filterAppName);
                    localVarPath = "/api/notice/unread-count/{filter.appName}"
                        .replace("{".concat("filter.appName", "}"), encodeURIComponent(String(filterAppName)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (filterActionTypes) {
                        localVarQueryParameter['filter.actionTypes'] = filterActionTypes;
                    }
                    if (filterEntityTypes) {
                        localVarQueryParameter['filter.entityTypes'] = filterEntityTypes;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.NoticeApiAxiosParamCreator = NoticeApiAxiosParamCreator;
/**
 * NoticeApi - functional programming interface
 * @export
 */
var NoticeApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.NoticeApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 获取消息提醒开关
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeGetRemindSwitch: function (app, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.noticeGetRemindSwitch(app, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 标记为已读
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} filterAppName
         * @param {NoticeMarkAsReadReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeMarkAsRead: function (filterAppName, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.noticeMarkAsRead(filterAppName, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 通知列表
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} filterAppName
         * @param {Array<'INVALID_ACTION' | 'Comment' | 'Like' | 'Collect' | 'Nps' | 'SystemAudit' | 'SystemUnpublish'>} [filterActionTypes]  - INVALID_ACTION: 占位  - Comment: 评论  - Like: 赞  - Collect: 收藏  - Nps: 评分  - SystemAudit: 系统审核  - SystemUnpublish: 系统下架
         * @param {Array<'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'>} [filterEntityTypes]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeNoticeList: function (filterAppName, filterActionTypes, filterEntityTypes, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.noticeNoticeList(filterAppName, filterActionTypes, filterEntityTypes, paginationPage, paginationSize, paginationHasMore, paginationTotal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 设置消息提醒开关
         * @param {NoticeSetRemindSwitchReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeSetRemindSwitch: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.noticeSetRemindSwitch(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 未读消息数
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} filterAppName
         * @param {Array<'INVALID_ACTION' | 'Comment' | 'Like' | 'Collect' | 'Nps' | 'SystemAudit' | 'SystemUnpublish'>} [filterActionTypes]  - INVALID_ACTION: 占位  - Comment: 评论  - Like: 赞  - Collect: 收藏  - Nps: 评分  - SystemAudit: 系统审核  - SystemUnpublish: 系统下架
         * @param {Array<'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'>} [filterEntityTypes]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeUnreadCount: function (filterAppName, filterActionTypes, filterEntityTypes, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.noticeUnreadCount(filterAppName, filterActionTypes, filterEntityTypes, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.NoticeApiFp = NoticeApiFp;
/**
 * NoticeApi - factory interface
 * @export
 */
var NoticeApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.NoticeApiFp)(configuration);
    return {
        /**
         *
         * @summary 获取消息提醒开关
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeGetRemindSwitch: function (app, options) {
            return localVarFp.noticeGetRemindSwitch(app, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 标记为已读
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} filterAppName
         * @param {NoticeMarkAsReadReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeMarkAsRead: function (filterAppName, body, options) {
            return localVarFp.noticeMarkAsRead(filterAppName, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 通知列表
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} filterAppName
         * @param {Array<'INVALID_ACTION' | 'Comment' | 'Like' | 'Collect' | 'Nps' | 'SystemAudit' | 'SystemUnpublish'>} [filterActionTypes]  - INVALID_ACTION: 占位  - Comment: 评论  - Like: 赞  - Collect: 收藏  - Nps: 评分  - SystemAudit: 系统审核  - SystemUnpublish: 系统下架
         * @param {Array<'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'>} [filterEntityTypes]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeNoticeList: function (filterAppName, filterActionTypes, filterEntityTypes, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return localVarFp.noticeNoticeList(filterAppName, filterActionTypes, filterEntityTypes, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 设置消息提醒开关
         * @param {NoticeSetRemindSwitchReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeSetRemindSwitch: function (body, options) {
            return localVarFp.noticeSetRemindSwitch(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 未读消息数
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} filterAppName
         * @param {Array<'INVALID_ACTION' | 'Comment' | 'Like' | 'Collect' | 'Nps' | 'SystemAudit' | 'SystemUnpublish'>} [filterActionTypes]  - INVALID_ACTION: 占位  - Comment: 评论  - Like: 赞  - Collect: 收藏  - Nps: 评分  - SystemAudit: 系统审核  - SystemUnpublish: 系统下架
         * @param {Array<'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'>} [filterEntityTypes]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noticeUnreadCount: function (filterAppName, filterActionTypes, filterEntityTypes, options) {
            return localVarFp.noticeUnreadCount(filterAppName, filterActionTypes, filterEntityTypes, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.NoticeApiFactory = NoticeApiFactory;
/**
 * NoticeApi - object-oriented interface
 * @export
 * @class NoticeApi
 * @extends {BaseAPI}
 */
var NoticeApi = /** @class */ (function (_super) {
    __extends(NoticeApi, _super);
    function NoticeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 获取消息提醒开关
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeApi
     */
    NoticeApi.prototype.noticeGetRemindSwitch = function (app, options) {
        var _this = this;
        return (0, exports.NoticeApiFp)(this.configuration).noticeGetRemindSwitch(app, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 标记为已读
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} filterAppName
     * @param {NoticeMarkAsReadReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeApi
     */
    NoticeApi.prototype.noticeMarkAsRead = function (filterAppName, body, options) {
        var _this = this;
        return (0, exports.NoticeApiFp)(this.configuration).noticeMarkAsRead(filterAppName, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 通知列表
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} filterAppName
     * @param {Array<'INVALID_ACTION' | 'Comment' | 'Like' | 'Collect' | 'Nps' | 'SystemAudit' | 'SystemUnpublish'>} [filterActionTypes]  - INVALID_ACTION: 占位  - Comment: 评论  - Like: 赞  - Collect: 收藏  - Nps: 评分  - SystemAudit: 系统审核  - SystemUnpublish: 系统下架
     * @param {Array<'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'>} [filterEntityTypes]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeApi
     */
    NoticeApi.prototype.noticeNoticeList = function (filterAppName, filterActionTypes, filterEntityTypes, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
        var _this = this;
        return (0, exports.NoticeApiFp)(this.configuration).noticeNoticeList(filterAppName, filterActionTypes, filterEntityTypes, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 设置消息提醒开关
     * @param {NoticeSetRemindSwitchReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeApi
     */
    NoticeApi.prototype.noticeSetRemindSwitch = function (body, options) {
        var _this = this;
        return (0, exports.NoticeApiFp)(this.configuration).noticeSetRemindSwitch(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 未读消息数
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} filterAppName
     * @param {Array<'INVALID_ACTION' | 'Comment' | 'Like' | 'Collect' | 'Nps' | 'SystemAudit' | 'SystemUnpublish'>} [filterActionTypes]  - INVALID_ACTION: 占位  - Comment: 评论  - Like: 赞  - Collect: 收藏  - Nps: 评分  - SystemAudit: 系统审核  - SystemUnpublish: 系统下架
     * @param {Array<'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'>} [filterEntityTypes]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeApi
     */
    NoticeApi.prototype.noticeUnreadCount = function (filterAppName, filterActionTypes, filterEntityTypes, options) {
        var _this = this;
        return (0, exports.NoticeApiFp)(this.configuration).noticeUnreadCount(filterAppName, filterActionTypes, filterEntityTypes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return NoticeApi;
}(base_1.BaseAPI));
exports.NoticeApi = NoticeApi;
/**
 * NpsApi - axios parameter creator
 * @export
 */
var NpsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 当前namespace下的nps应用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        npsGetNpsApps: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/nps/apps";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 注册评分项目
         * @param {NpsRegisterRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        npsRegister: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('npsRegister', 'body', body);
                    localVarPath = "/api/nps/register";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 展示历史评分
         * @param {string} [entityId]
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} [entityType]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        npsReveal: function (entityId, entityType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/nps/reveal";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (entityId !== undefined) {
                        localVarQueryParameter['entity.id'] = entityId;
                    }
                    if (entityType !== undefined) {
                        localVarQueryParameter['entity.type'] = entityType;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary NPS评分
         * @param {NpsScoreRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        npsScore: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('npsScore', 'body', body);
                    localVarPath = "/api/nps/score";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 评分统计信息
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        npsScoreRatedCount: function (entityType, entityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('npsScoreRatedCount', 'entityType', entityType);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('npsScoreRatedCount', 'entityId', entityId);
                    localVarPath = "/api/nps/score/{entity.type}/{entity.id}/count"
                        .replace("{".concat("entity.type", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("entity.id", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.NpsApiAxiosParamCreator = NpsApiAxiosParamCreator;
/**
 * NpsApi - functional programming interface
 * @export
 */
var NpsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.NpsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 当前namespace下的nps应用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        npsGetNpsApps: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.npsGetNpsApps(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 注册评分项目
         * @param {NpsRegisterRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        npsRegister: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.npsRegister(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 展示历史评分
         * @param {string} [entityId]
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} [entityType]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        npsReveal: function (entityId, entityType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.npsReveal(entityId, entityType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary NPS评分
         * @param {NpsScoreRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        npsScore: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.npsScore(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 评分统计信息
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        npsScoreRatedCount: function (entityType, entityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.npsScoreRatedCount(entityType, entityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.NpsApiFp = NpsApiFp;
/**
 * NpsApi - factory interface
 * @export
 */
var NpsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.NpsApiFp)(configuration);
    return {
        /**
         *
         * @summary 当前namespace下的nps应用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        npsGetNpsApps: function (options) {
            return localVarFp.npsGetNpsApps(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 注册评分项目
         * @param {NpsRegisterRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        npsRegister: function (body, options) {
            return localVarFp.npsRegister(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 展示历史评分
         * @param {string} [entityId]
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} [entityType]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        npsReveal: function (entityId, entityType, options) {
            return localVarFp.npsReveal(entityId, entityType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary NPS评分
         * @param {NpsScoreRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        npsScore: function (body, options) {
            return localVarFp.npsScore(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 评分统计信息
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        npsScoreRatedCount: function (entityType, entityId, options) {
            return localVarFp.npsScoreRatedCount(entityType, entityId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.NpsApiFactory = NpsApiFactory;
/**
 * NpsApi - object-oriented interface
 * @export
 * @class NpsApi
 * @extends {BaseAPI}
 */
var NpsApi = /** @class */ (function (_super) {
    __extends(NpsApi, _super);
    function NpsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 当前namespace下的nps应用
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NpsApi
     */
    NpsApi.prototype.npsGetNpsApps = function (options) {
        var _this = this;
        return (0, exports.NpsApiFp)(this.configuration).npsGetNpsApps(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 注册评分项目
     * @param {NpsRegisterRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NpsApi
     */
    NpsApi.prototype.npsRegister = function (body, options) {
        var _this = this;
        return (0, exports.NpsApiFp)(this.configuration).npsRegister(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 展示历史评分
     * @param {string} [entityId]
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} [entityType]  - UNDEFINED: 异常占位  - ResearchReport: 调研云报告  - Comment: 评论  - Article: 文章  - RegisteredNPS: NPS注册实体  - Research: 调研云  - TXCTopic: 兔小巢话题
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NpsApi
     */
    NpsApi.prototype.npsReveal = function (entityId, entityType, options) {
        var _this = this;
        return (0, exports.NpsApiFp)(this.configuration).npsReveal(entityId, entityType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary NPS评分
     * @param {NpsScoreRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NpsApi
     */
    NpsApi.prototype.npsScore = function (body, options) {
        var _this = this;
        return (0, exports.NpsApiFp)(this.configuration).npsScore(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 评分统计信息
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NpsApi
     */
    NpsApi.prototype.npsScoreRatedCount = function (entityType, entityId, options) {
        var _this = this;
        return (0, exports.NpsApiFp)(this.configuration).npsScoreRatedCount(entityType, entityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return NpsApi;
}(base_1.BaseAPI));
exports.NpsApi = NpsApi;
/**
 * OaavatarApi - axios parameter creator
 * @export
 */
var OaavatarApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {OaavatarAvatarUrlRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oaavatarAvatarUrl: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('oaavatarAvatarUrl', 'body', body);
                    localVarPath = "/api/micro/avatarurl";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.OaavatarApiAxiosParamCreator = OaavatarApiAxiosParamCreator;
/**
 * OaavatarApi - functional programming interface
 * @export
 */
var OaavatarApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OaavatarApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {OaavatarAvatarUrlRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oaavatarAvatarUrl: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.oaavatarAvatarUrl(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.OaavatarApiFp = OaavatarApiFp;
/**
 * OaavatarApi - factory interface
 * @export
 */
var OaavatarApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OaavatarApiFp)(configuration);
    return {
        /**
         *
         * @param {OaavatarAvatarUrlRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oaavatarAvatarUrl: function (body, options) {
            return localVarFp.oaavatarAvatarUrl(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OaavatarApiFactory = OaavatarApiFactory;
/**
 * OaavatarApi - object-oriented interface
 * @export
 * @class OaavatarApi
 * @extends {BaseAPI}
 */
var OaavatarApi = /** @class */ (function (_super) {
    __extends(OaavatarApi, _super);
    function OaavatarApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {OaavatarAvatarUrlRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OaavatarApi
     */
    OaavatarApi.prototype.oaavatarAvatarUrl = function (body, options) {
        var _this = this;
        return (0, exports.OaavatarApiFp)(this.configuration).oaavatarAvatarUrl(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OaavatarApi;
}(base_1.BaseAPI));
exports.OaavatarApi = OaavatarApi;
/**
 * OcrApi - axios parameter creator
 * @export
 */
var OcrApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 获取抗原棒检测结果
         * @param {string} [imageUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ocrGetCovidResult: function (imageUrl, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ocr/covid";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (imageUrl !== undefined) {
                        localVarQueryParameter['imageUrl'] = imageUrl;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.OcrApiAxiosParamCreator = OcrApiAxiosParamCreator;
/**
 * OcrApi - functional programming interface
 * @export
 */
var OcrApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OcrApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 获取抗原棒检测结果
         * @param {string} [imageUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ocrGetCovidResult: function (imageUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ocrGetCovidResult(imageUrl, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.OcrApiFp = OcrApiFp;
/**
 * OcrApi - factory interface
 * @export
 */
var OcrApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OcrApiFp)(configuration);
    return {
        /**
         *
         * @summary 获取抗原棒检测结果
         * @param {string} [imageUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ocrGetCovidResult: function (imageUrl, options) {
            return localVarFp.ocrGetCovidResult(imageUrl, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OcrApiFactory = OcrApiFactory;
/**
 * OcrApi - object-oriented interface
 * @export
 * @class OcrApi
 * @extends {BaseAPI}
 */
var OcrApi = /** @class */ (function (_super) {
    __extends(OcrApi, _super);
    function OcrApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 获取抗原棒检测结果
     * @param {string} [imageUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OcrApi
     */
    OcrApi.prototype.ocrGetCovidResult = function (imageUrl, options) {
        var _this = this;
        return (0, exports.OcrApiFp)(this.configuration).ocrGetCovidResult(imageUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OcrApi;
}(base_1.BaseAPI));
exports.OcrApi = OcrApi;
/**
 * OrganizationApi - axios parameter creator
 * @export
 */
var OrganizationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 团队添加成员
         * @param {number} teamId 添加到哪个团队
         * @param {OrganizationAddMemberRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAddMembers: function (teamId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationAddMembers', 'teamId', teamId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationAddMembers', 'body', body);
                    localVarPath = "/api/organization/teams/{teamId}/members"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 管理员渠道获取团队成员信息,无需验证用户身份
         * @param {number} teamId
         * @param {string} memberGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAdminGetTeamMember: function (teamId, memberGuid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationAdminGetTeamMember', 'teamId', teamId);
                    // verify required parameter 'memberGuid' is not null or undefined
                    (0, common_1.assertParamExists)('organizationAdminGetTeamMember', 'memberGuid', memberGuid);
                    localVarPath = "/admin/api/organization/teams/{teamId}/members/{memberGuid}"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)))
                        .replace("{".concat("memberGuid", "}"), encodeURIComponent(String(memberGuid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 批量移动成员到多个分组下
         * @param {OrganizationBatchMoveTeamMemberGroupReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationBatchMoveTeamMemberGroup: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationBatchMoveTeamMemberGroup', 'body', body);
                    localVarPath = "/api/organization/members/movement";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 设置角色
         * @param {number} teamId 团队id
         * @param {string} userId 用户id
         * @param {OrganizationChangeMemberRoleRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationChangeMemberRole: function (teamId, userId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationChangeMemberRole', 'teamId', teamId);
                    // verify required parameter 'userId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationChangeMemberRole', 'userId', userId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationChangeMemberRole', 'body', body);
                    localVarPath = "/api/organization/teams/{teamId}/members/{userId}"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)))
                        .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 新建分组
         * @param {number} teamId
         * @param {OrganizationCreateGroupReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationCreateGroup: function (teamId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationCreateGroup', 'teamId', teamId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationCreateGroup', 'body', body);
                    localVarPath = "/api/organization/{teamId}/groups"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary C端成员创建团队
         * @param {OrganizationCreateOfficalTeamReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationCreateOfficalTeam: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationCreateOfficalTeam', 'body', body);
                    localVarPath = "/api/organization/official/teams";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 企业创建团队
         * @param {OrganizationCreateTeamRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationCreateTeam: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationCreateTeam', 'body', body);
                    localVarPath = "/api/organization/teams";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 删除分组
         * @param {number} teamId 团队id
         * @param {number} groupId 组id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationDeleteGroup: function (teamId, groupId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationDeleteGroup', 'teamId', teamId);
                    // verify required parameter 'groupId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationDeleteGroup', 'groupId', groupId);
                    localVarPath = "/api/organization/{teamId}/groups/{groupId}"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)))
                        .replace("{".concat("groupId", "}"), encodeURIComponent(String(groupId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 主动退出团队
         * @param {number} teamId
         * @param {OrganizationExitTeamMembershipReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationExitTeamMembership: function (teamId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationExitTeamMembership', 'teamId', teamId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationExitTeamMembership', 'body', body);
                    localVarPath = "/api/organization/{teamId}/membership"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取团队专区活跃团队
         * @param {number} [page] 页码.
         * @param {number} [size] 页数量.
         * @param {boolean} [hasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [total] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetActiveTeamList: function (page, size, hasMore, total, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/organization/teams/active";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (hasMore !== undefined) {
                        localVarQueryParameter['hasMore'] = hasMore;
                    }
                    if (total !== undefined) {
                        localVarQueryParameter['total'] = total;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取团队管理员列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetAdminTeamList: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/organization/teams/admin";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取部门架构
         * @param {number} departmentId 部门id，值为0时为获取最top级别的数据
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetDepartmentHierarchy: function (departmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'departmentId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationGetDepartmentHierarchy', 'departmentId', departmentId);
                    localVarPath = "/api/organization/departments/{departmentId}"
                        .replace("{".concat("departmentId", "}"), encodeURIComponent(String(departmentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取部门下的成员
         * @param {number} departmentId 部门id
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetDepartmentMemberList: function (departmentId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'departmentId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationGetDepartmentMemberList', 'departmentId', departmentId);
                    localVarPath = "/api/organization/{departmentId}/users"
                        .replace("{".concat("departmentId", "}"), encodeURIComponent(String(departmentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取邀请信息
         * @param {string} code 邀请码
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetInvitationInfo: function (code, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'code' is not null or undefined
                    (0, common_1.assertParamExists)('organizationGetInvitationInfo', 'code', code);
                    localVarPath = "/api/organization/invitation/{code}"
                        .replace("{".concat("code", "}"), encodeURIComponent(String(code)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取团队信息
         * @param {number} teamId 团队id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeam: function (teamId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationGetTeam', 'teamId', teamId);
                    localVarPath = "/api/organization/teams/{teamId}"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取团队管理员列表
         * @param {number} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamAdministrators: function (teamId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationGetTeamAdministrators', 'teamId', teamId);
                    localVarPath = "/api/organization/teams/{teamId}/admins"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取团队管理员列表(内部请求)
         * @param {number} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamAdministratorsForInternal: function (teamId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationGetTeamAdministratorsForInternal', 'teamId', teamId);
                    localVarPath = "/disable/api/organization/teams/{teamId}/admins"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取团队组织架构
         * @param {number} teamId 团队id
         * @param {number} departmentId 组id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamHierarchy: function (teamId, departmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationGetTeamHierarchy', 'teamId', teamId);
                    // verify required parameter 'departmentId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationGetTeamHierarchy', 'departmentId', departmentId);
                    localVarPath = "/api/organization/teams/{teamId}/departments/{departmentId}"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)))
                        .replace("{".concat("departmentId", "}"), encodeURIComponent(String(departmentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 生成邀请码
         * @param {number} [teamId] 团队id.
         * @param {'NORMAL' | 'ADMIN' | 'CREATOR' | 'NOT_MEMBER'} [role] 角色.   - NORMAL: 普通成员  - ADMIN: 管理员  - CREATOR: 创建者  - NOT_MEMBER: 非成员
         * @param {number} [groupId] 指定要加入的组,不传递则加入未分组.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamInviteCode: function (teamId, role, groupId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/organization/teams/invitation/code";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (teamId !== undefined) {
                        localVarQueryParameter['teamId'] = teamId;
                    }
                    if (role !== undefined) {
                        localVarQueryParameter['role'] = role;
                    }
                    if (groupId !== undefined) {
                        localVarQueryParameter['groupId'] = groupId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 团队邀请信息查询
         * @param {OrganizationGetTeamInvitedHistoryReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamInvitedHistory: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationGetTeamInvitedHistory', 'body', body);
                    localVarPath = "/disable/api/organization/teams/invitation/history";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取我的团队列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamList: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/organization/teams";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取团队成员信息
         * @param {number} teamId
         * @param {string} memberGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamMember: function (teamId, memberGuid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationGetTeamMember', 'teamId', teamId);
                    // verify required parameter 'memberGuid' is not null or undefined
                    (0, common_1.assertParamExists)('organizationGetTeamMember', 'memberGuid', memberGuid);
                    localVarPath = "/api/organization/teams/{teamId}/members/{memberGuid}"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)))
                        .replace("{".concat("memberGuid", "}"), encodeURIComponent(String(memberGuid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取指定分组的团队成员列表
         * @param {number} teamId 团队id
         * @param {number} departmentId 部门id
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamMemberList: function (teamId, departmentId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationGetTeamMemberList', 'teamId', teamId);
                    // verify required parameter 'departmentId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationGetTeamMemberList', 'departmentId', departmentId);
                    localVarPath = "/api/organization/teams/{teamId}/departments/{departmentId}/members"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)))
                        .replace("{".concat("departmentId", "}"), encodeURIComponent(String(departmentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取团队成员列表
         * @param {number} teamId
         * @param {number} [page] 页码.
         * @param {number} [size] 页数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamMembers: function (teamId, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationGetTeamMembers', 'teamId', teamId);
                    localVarPath = "/api/organization/teams/{teamId}/members"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 批量获取团队信息
         * @param {OrganizationTeamIDList} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeams: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationGetTeams', 'body', body);
                    localVarPath = "/api/organization/teams/info";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取指定用户的团队列表
         * @param {string} [guid]
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetUserTeamList: function (guid, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/disable/api/organization/teams";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (guid !== undefined) {
                        localVarQueryParameter['guid'] = guid;
                    }
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取用户在指定团队列表中的角色
         * @param {OrganizationTeamIDList} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetUserTeamRole: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationGetUserTeamRole', 'body', body);
                    localVarPath = "/api/organization/teams/roles";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 通过邀请码加入团队
         * @param {OrganizationJoinTeamWithInviteCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationJoinTeamWithInviteCode: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationJoinTeamWithInviteCode', 'body', body);
                    localVarPath = "/api/organization/teams/invitation/join";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 编辑分组
         * @param {OrganizationModifyGroupReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationModifyGroup: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationModifyGroup', 'body', body);
                    localVarPath = "/api/organization/groups/modification";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 修改分组名称
         * @param {number} teamId
         * @param {number} groupId
         * @param {OrganizationModifyGroupNameReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationModifyGroupName: function (teamId, groupId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationModifyGroupName', 'teamId', teamId);
                    // verify required parameter 'groupId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationModifyGroupName', 'groupId', groupId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationModifyGroupName', 'body', body);
                    localVarPath = "/api/organization/{teamId}/groups/{groupId}"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)))
                        .replace("{".concat("groupId", "}"), encodeURIComponent(String(groupId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 调整用户全部分组
         * @param {string} memberGuid 待移动的成员
         * @param {OrganizationModifyMemberGroupReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationModifyMemberGroup: function (memberGuid, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'memberGuid' is not null or undefined
                    (0, common_1.assertParamExists)('organizationModifyMemberGroup', 'memberGuid', memberGuid);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationModifyMemberGroup', 'body', body);
                    localVarPath = "/api/organization/members/{memberGuid}/groups"
                        .replace("{".concat("memberGuid", "}"), encodeURIComponent(String(memberGuid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 移动分组
         * @param {OrganizationMoveGroupReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationMoveGroup: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationMoveGroup', 'body', body);
                    localVarPath = "/api/organization/groups/movement";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 更新团队信息
         * @param {number} teamId 团队id
         * @param {OrganizationPutTeamRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPutTeam: function (teamId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationPutTeam', 'teamId', teamId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationPutTeam', 'body', body);
                    localVarPath = "/api/organization/teams/{teamId}"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 移除团队组成员
         * @param {number} teamId 团队id
         * @param {number} departmentId 小组id
         * @param {OrganizationRemoveGroupMemberRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationRemoveGroupMember: function (teamId, departmentId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationRemoveGroupMember', 'teamId', teamId);
                    // verify required parameter 'departmentId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationRemoveGroupMember', 'departmentId', departmentId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationRemoveGroupMember', 'body', body);
                    localVarPath = "/api/organization/teams/{teamId}/departments/{departmentId}/members/batchDelete"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)))
                        .replace("{".concat("departmentId", "}"), encodeURIComponent(String(departmentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 解散团队
         * @param {number} teamId 团队id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationRemoveTeam: function (teamId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationRemoveTeam', 'teamId', teamId);
                    localVarPath = "/api/organization/teams/{teamId}"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 移除团队成员
         * @param {number} teamId 团队id
         * @param {OrganizationRemoveTeamMemberRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationRemoveTeamMember: function (teamId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationRemoveTeamMember', 'teamId', teamId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationRemoveTeamMember', 'body', body);
                    localVarPath = "/api/organization/teams/{teamId}/members/batchDelete"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 搜索部门下的成员
         * @param {number} departmentId 团队id
         * @param {string} [keyword] 搜索词.
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationSearchDepartmentMembers: function (departmentId, keyword, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'departmentId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationSearchDepartmentMembers', 'departmentId', departmentId);
                    localVarPath = "/api/organization/departments/{departmentId}/search"
                        .replace("{".concat("departmentId", "}"), encodeURIComponent(String(departmentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (keyword !== undefined) {
                        localVarQueryParameter['keyword'] = keyword;
                    }
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 搜索组名
         * @param {string} [keyword] 搜索词.
         * @param {number} [teamId]
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationSearchGroupByName: function (keyword, teamId, paginationId, paginationSize, paginationHasMore, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/organization/group/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (keyword !== undefined) {
                        localVarQueryParameter['keyword'] = keyword;
                    }
                    if (teamId !== undefined) {
                        localVarQueryParameter['teamId'] = teamId;
                    }
                    if (paginationId !== undefined) {
                        localVarQueryParameter['pagination.id'] = paginationId;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 搜索我的团队成员列表
         * @param {number} teamId 团队id
         * @param {string} [keyword] 搜索词.
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationSearchTeamMembers: function (teamId, keyword, paginationId, paginationSize, paginationHasMore, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('organizationSearchTeamMembers', 'teamId', teamId);
                    localVarPath = "/api/organization/teams/{teamId}/search"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (keyword !== undefined) {
                        localVarQueryParameter['keyword'] = keyword;
                    }
                    if (paginationId !== undefined) {
                        localVarQueryParameter['pagination.id'] = paginationId;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 批量获取团队信息
         * @param {OrganizationSearchTeamsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationSearchTeams: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationSearchTeams', 'body', body);
                    localVarPath = "/api/organization/teams/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 移交团队成员
         * @param {OrganizationTransferCreatorReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationTransferCreator: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('organizationTransferCreator', 'body', body);
                    localVarPath = "/api/organization/creator/transfer";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.OrganizationApiAxiosParamCreator = OrganizationApiAxiosParamCreator;
/**
 * OrganizationApi - functional programming interface
 * @export
 */
var OrganizationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OrganizationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 团队添加成员
         * @param {number} teamId 添加到哪个团队
         * @param {OrganizationAddMemberRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAddMembers: function (teamId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationAddMembers(teamId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 管理员渠道获取团队成员信息,无需验证用户身份
         * @param {number} teamId
         * @param {string} memberGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAdminGetTeamMember: function (teamId, memberGuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationAdminGetTeamMember(teamId, memberGuid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 批量移动成员到多个分组下
         * @param {OrganizationBatchMoveTeamMemberGroupReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationBatchMoveTeamMemberGroup: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationBatchMoveTeamMemberGroup(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 设置角色
         * @param {number} teamId 团队id
         * @param {string} userId 用户id
         * @param {OrganizationChangeMemberRoleRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationChangeMemberRole: function (teamId, userId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationChangeMemberRole(teamId, userId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 新建分组
         * @param {number} teamId
         * @param {OrganizationCreateGroupReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationCreateGroup: function (teamId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationCreateGroup(teamId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary C端成员创建团队
         * @param {OrganizationCreateOfficalTeamReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationCreateOfficalTeam: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationCreateOfficalTeam(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 企业创建团队
         * @param {OrganizationCreateTeamRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationCreateTeam: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationCreateTeam(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 删除分组
         * @param {number} teamId 团队id
         * @param {number} groupId 组id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationDeleteGroup: function (teamId, groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationDeleteGroup(teamId, groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 主动退出团队
         * @param {number} teamId
         * @param {OrganizationExitTeamMembershipReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationExitTeamMembership: function (teamId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationExitTeamMembership(teamId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取团队专区活跃团队
         * @param {number} [page] 页码.
         * @param {number} [size] 页数量.
         * @param {boolean} [hasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [total] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetActiveTeamList: function (page, size, hasMore, total, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetActiveTeamList(page, size, hasMore, total, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取团队管理员列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetAdminTeamList: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetAdminTeamList(paginationPage, paginationSize, paginationHasMore, paginationTotal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取部门架构
         * @param {number} departmentId 部门id，值为0时为获取最top级别的数据
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetDepartmentHierarchy: function (departmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetDepartmentHierarchy(departmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取部门下的成员
         * @param {number} departmentId 部门id
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetDepartmentMemberList: function (departmentId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetDepartmentMemberList(departmentId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取邀请信息
         * @param {string} code 邀请码
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetInvitationInfo: function (code, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetInvitationInfo(code, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取团队信息
         * @param {number} teamId 团队id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeam: function (teamId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetTeam(teamId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取团队管理员列表
         * @param {number} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamAdministrators: function (teamId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetTeamAdministrators(teamId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取团队管理员列表(内部请求)
         * @param {number} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamAdministratorsForInternal: function (teamId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetTeamAdministratorsForInternal(teamId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取团队组织架构
         * @param {number} teamId 团队id
         * @param {number} departmentId 组id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamHierarchy: function (teamId, departmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetTeamHierarchy(teamId, departmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 生成邀请码
         * @param {number} [teamId] 团队id.
         * @param {'NORMAL' | 'ADMIN' | 'CREATOR' | 'NOT_MEMBER'} [role] 角色.   - NORMAL: 普通成员  - ADMIN: 管理员  - CREATOR: 创建者  - NOT_MEMBER: 非成员
         * @param {number} [groupId] 指定要加入的组,不传递则加入未分组.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamInviteCode: function (teamId, role, groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetTeamInviteCode(teamId, role, groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 团队邀请信息查询
         * @param {OrganizationGetTeamInvitedHistoryReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamInvitedHistory: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetTeamInvitedHistory(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取我的团队列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamList: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetTeamList(paginationPage, paginationSize, paginationHasMore, paginationTotal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取团队成员信息
         * @param {number} teamId
         * @param {string} memberGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamMember: function (teamId, memberGuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetTeamMember(teamId, memberGuid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取指定分组的团队成员列表
         * @param {number} teamId 团队id
         * @param {number} departmentId 部门id
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamMemberList: function (teamId, departmentId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetTeamMemberList(teamId, departmentId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取团队成员列表
         * @param {number} teamId
         * @param {number} [page] 页码.
         * @param {number} [size] 页数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamMembers: function (teamId, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetTeamMembers(teamId, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 批量获取团队信息
         * @param {OrganizationTeamIDList} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeams: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetTeams(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取指定用户的团队列表
         * @param {string} [guid]
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetUserTeamList: function (guid, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetUserTeamList(guid, paginationPage, paginationSize, paginationHasMore, paginationTotal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取用户在指定团队列表中的角色
         * @param {OrganizationTeamIDList} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetUserTeamRole: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationGetUserTeamRole(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 通过邀请码加入团队
         * @param {OrganizationJoinTeamWithInviteCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationJoinTeamWithInviteCode: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationJoinTeamWithInviteCode(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 编辑分组
         * @param {OrganizationModifyGroupReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationModifyGroup: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationModifyGroup(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 修改分组名称
         * @param {number} teamId
         * @param {number} groupId
         * @param {OrganizationModifyGroupNameReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationModifyGroupName: function (teamId, groupId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationModifyGroupName(teamId, groupId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 调整用户全部分组
         * @param {string} memberGuid 待移动的成员
         * @param {OrganizationModifyMemberGroupReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationModifyMemberGroup: function (memberGuid, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationModifyMemberGroup(memberGuid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 移动分组
         * @param {OrganizationMoveGroupReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationMoveGroup: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationMoveGroup(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 更新团队信息
         * @param {number} teamId 团队id
         * @param {OrganizationPutTeamRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPutTeam: function (teamId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationPutTeam(teamId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 移除团队组成员
         * @param {number} teamId 团队id
         * @param {number} departmentId 小组id
         * @param {OrganizationRemoveGroupMemberRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationRemoveGroupMember: function (teamId, departmentId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationRemoveGroupMember(teamId, departmentId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 解散团队
         * @param {number} teamId 团队id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationRemoveTeam: function (teamId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationRemoveTeam(teamId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 移除团队成员
         * @param {number} teamId 团队id
         * @param {OrganizationRemoveTeamMemberRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationRemoveTeamMember: function (teamId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationRemoveTeamMember(teamId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 搜索部门下的成员
         * @param {number} departmentId 团队id
         * @param {string} [keyword] 搜索词.
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationSearchDepartmentMembers: function (departmentId, keyword, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationSearchDepartmentMembers(departmentId, keyword, paginationPage, paginationSize, paginationHasMore, paginationTotal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 搜索组名
         * @param {string} [keyword] 搜索词.
         * @param {number} [teamId]
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationSearchGroupByName: function (keyword, teamId, paginationId, paginationSize, paginationHasMore, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationSearchGroupByName(keyword, teamId, paginationId, paginationSize, paginationHasMore, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 搜索我的团队成员列表
         * @param {number} teamId 团队id
         * @param {string} [keyword] 搜索词.
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationSearchTeamMembers: function (teamId, keyword, paginationId, paginationSize, paginationHasMore, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationSearchTeamMembers(teamId, keyword, paginationId, paginationSize, paginationHasMore, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 批量获取团队信息
         * @param {OrganizationSearchTeamsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationSearchTeams: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationSearchTeams(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 移交团队成员
         * @param {OrganizationTransferCreatorReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationTransferCreator: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationTransferCreator(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.OrganizationApiFp = OrganizationApiFp;
/**
 * OrganizationApi - factory interface
 * @export
 */
var OrganizationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OrganizationApiFp)(configuration);
    return {
        /**
         *
         * @summary 团队添加成员
         * @param {number} teamId 添加到哪个团队
         * @param {OrganizationAddMemberRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAddMembers: function (teamId, body, options) {
            return localVarFp.organizationAddMembers(teamId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 管理员渠道获取团队成员信息,无需验证用户身份
         * @param {number} teamId
         * @param {string} memberGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAdminGetTeamMember: function (teamId, memberGuid, options) {
            return localVarFp.organizationAdminGetTeamMember(teamId, memberGuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 批量移动成员到多个分组下
         * @param {OrganizationBatchMoveTeamMemberGroupReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationBatchMoveTeamMemberGroup: function (body, options) {
            return localVarFp.organizationBatchMoveTeamMemberGroup(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 设置角色
         * @param {number} teamId 团队id
         * @param {string} userId 用户id
         * @param {OrganizationChangeMemberRoleRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationChangeMemberRole: function (teamId, userId, body, options) {
            return localVarFp.organizationChangeMemberRole(teamId, userId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 新建分组
         * @param {number} teamId
         * @param {OrganizationCreateGroupReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationCreateGroup: function (teamId, body, options) {
            return localVarFp.organizationCreateGroup(teamId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary C端成员创建团队
         * @param {OrganizationCreateOfficalTeamReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationCreateOfficalTeam: function (body, options) {
            return localVarFp.organizationCreateOfficalTeam(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 企业创建团队
         * @param {OrganizationCreateTeamRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationCreateTeam: function (body, options) {
            return localVarFp.organizationCreateTeam(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 删除分组
         * @param {number} teamId 团队id
         * @param {number} groupId 组id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationDeleteGroup: function (teamId, groupId, options) {
            return localVarFp.organizationDeleteGroup(teamId, groupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 主动退出团队
         * @param {number} teamId
         * @param {OrganizationExitTeamMembershipReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationExitTeamMembership: function (teamId, body, options) {
            return localVarFp.organizationExitTeamMembership(teamId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取团队专区活跃团队
         * @param {number} [page] 页码.
         * @param {number} [size] 页数量.
         * @param {boolean} [hasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [total] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetActiveTeamList: function (page, size, hasMore, total, options) {
            return localVarFp.organizationGetActiveTeamList(page, size, hasMore, total, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取团队管理员列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetAdminTeamList: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return localVarFp.organizationGetAdminTeamList(paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取部门架构
         * @param {number} departmentId 部门id，值为0时为获取最top级别的数据
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetDepartmentHierarchy: function (departmentId, options) {
            return localVarFp.organizationGetDepartmentHierarchy(departmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取部门下的成员
         * @param {number} departmentId 部门id
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetDepartmentMemberList: function (departmentId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return localVarFp.organizationGetDepartmentMemberList(departmentId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取邀请信息
         * @param {string} code 邀请码
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetInvitationInfo: function (code, options) {
            return localVarFp.organizationGetInvitationInfo(code, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取团队信息
         * @param {number} teamId 团队id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeam: function (teamId, options) {
            return localVarFp.organizationGetTeam(teamId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取团队管理员列表
         * @param {number} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamAdministrators: function (teamId, options) {
            return localVarFp.organizationGetTeamAdministrators(teamId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取团队管理员列表(内部请求)
         * @param {number} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamAdministratorsForInternal: function (teamId, options) {
            return localVarFp.organizationGetTeamAdministratorsForInternal(teamId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取团队组织架构
         * @param {number} teamId 团队id
         * @param {number} departmentId 组id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamHierarchy: function (teamId, departmentId, options) {
            return localVarFp.organizationGetTeamHierarchy(teamId, departmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 生成邀请码
         * @param {number} [teamId] 团队id.
         * @param {'NORMAL' | 'ADMIN' | 'CREATOR' | 'NOT_MEMBER'} [role] 角色.   - NORMAL: 普通成员  - ADMIN: 管理员  - CREATOR: 创建者  - NOT_MEMBER: 非成员
         * @param {number} [groupId] 指定要加入的组,不传递则加入未分组.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamInviteCode: function (teamId, role, groupId, options) {
            return localVarFp.organizationGetTeamInviteCode(teamId, role, groupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 团队邀请信息查询
         * @param {OrganizationGetTeamInvitedHistoryReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamInvitedHistory: function (body, options) {
            return localVarFp.organizationGetTeamInvitedHistory(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取我的团队列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamList: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return localVarFp.organizationGetTeamList(paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取团队成员信息
         * @param {number} teamId
         * @param {string} memberGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamMember: function (teamId, memberGuid, options) {
            return localVarFp.organizationGetTeamMember(teamId, memberGuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取指定分组的团队成员列表
         * @param {number} teamId 团队id
         * @param {number} departmentId 部门id
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamMemberList: function (teamId, departmentId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return localVarFp.organizationGetTeamMemberList(teamId, departmentId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取团队成员列表
         * @param {number} teamId
         * @param {number} [page] 页码.
         * @param {number} [size] 页数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeamMembers: function (teamId, page, size, options) {
            return localVarFp.organizationGetTeamMembers(teamId, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 批量获取团队信息
         * @param {OrganizationTeamIDList} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetTeams: function (body, options) {
            return localVarFp.organizationGetTeams(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取指定用户的团队列表
         * @param {string} [guid]
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetUserTeamList: function (guid, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return localVarFp.organizationGetUserTeamList(guid, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取用户在指定团队列表中的角色
         * @param {OrganizationTeamIDList} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetUserTeamRole: function (body, options) {
            return localVarFp.organizationGetUserTeamRole(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 通过邀请码加入团队
         * @param {OrganizationJoinTeamWithInviteCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationJoinTeamWithInviteCode: function (body, options) {
            return localVarFp.organizationJoinTeamWithInviteCode(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 编辑分组
         * @param {OrganizationModifyGroupReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationModifyGroup: function (body, options) {
            return localVarFp.organizationModifyGroup(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 修改分组名称
         * @param {number} teamId
         * @param {number} groupId
         * @param {OrganizationModifyGroupNameReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationModifyGroupName: function (teamId, groupId, body, options) {
            return localVarFp.organizationModifyGroupName(teamId, groupId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 调整用户全部分组
         * @param {string} memberGuid 待移动的成员
         * @param {OrganizationModifyMemberGroupReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationModifyMemberGroup: function (memberGuid, body, options) {
            return localVarFp.organizationModifyMemberGroup(memberGuid, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 移动分组
         * @param {OrganizationMoveGroupReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationMoveGroup: function (body, options) {
            return localVarFp.organizationMoveGroup(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 更新团队信息
         * @param {number} teamId 团队id
         * @param {OrganizationPutTeamRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPutTeam: function (teamId, body, options) {
            return localVarFp.organizationPutTeam(teamId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 移除团队组成员
         * @param {number} teamId 团队id
         * @param {number} departmentId 小组id
         * @param {OrganizationRemoveGroupMemberRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationRemoveGroupMember: function (teamId, departmentId, body, options) {
            return localVarFp.organizationRemoveGroupMember(teamId, departmentId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 解散团队
         * @param {number} teamId 团队id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationRemoveTeam: function (teamId, options) {
            return localVarFp.organizationRemoveTeam(teamId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 移除团队成员
         * @param {number} teamId 团队id
         * @param {OrganizationRemoveTeamMemberRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationRemoveTeamMember: function (teamId, body, options) {
            return localVarFp.organizationRemoveTeamMember(teamId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 搜索部门下的成员
         * @param {number} departmentId 团队id
         * @param {string} [keyword] 搜索词.
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationSearchDepartmentMembers: function (departmentId, keyword, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return localVarFp.organizationSearchDepartmentMembers(departmentId, keyword, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 搜索组名
         * @param {string} [keyword] 搜索词.
         * @param {number} [teamId]
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationSearchGroupByName: function (keyword, teamId, paginationId, paginationSize, paginationHasMore, options) {
            return localVarFp.organizationSearchGroupByName(keyword, teamId, paginationId, paginationSize, paginationHasMore, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 搜索我的团队成员列表
         * @param {number} teamId 团队id
         * @param {string} [keyword] 搜索词.
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationSearchTeamMembers: function (teamId, keyword, paginationId, paginationSize, paginationHasMore, options) {
            return localVarFp.organizationSearchTeamMembers(teamId, keyword, paginationId, paginationSize, paginationHasMore, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 批量获取团队信息
         * @param {OrganizationSearchTeamsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationSearchTeams: function (body, options) {
            return localVarFp.organizationSearchTeams(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 移交团队成员
         * @param {OrganizationTransferCreatorReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationTransferCreator: function (body, options) {
            return localVarFp.organizationTransferCreator(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OrganizationApiFactory = OrganizationApiFactory;
/**
 * OrganizationApi - object-oriented interface
 * @export
 * @class OrganizationApi
 * @extends {BaseAPI}
 */
var OrganizationApi = /** @class */ (function (_super) {
    __extends(OrganizationApi, _super);
    function OrganizationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 团队添加成员
     * @param {number} teamId 添加到哪个团队
     * @param {OrganizationAddMemberRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationAddMembers = function (teamId, body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationAddMembers(teamId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 管理员渠道获取团队成员信息,无需验证用户身份
     * @param {number} teamId
     * @param {string} memberGuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationAdminGetTeamMember = function (teamId, memberGuid, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationAdminGetTeamMember(teamId, memberGuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 批量移动成员到多个分组下
     * @param {OrganizationBatchMoveTeamMemberGroupReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationBatchMoveTeamMemberGroup = function (body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationBatchMoveTeamMemberGroup(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 设置角色
     * @param {number} teamId 团队id
     * @param {string} userId 用户id
     * @param {OrganizationChangeMemberRoleRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationChangeMemberRole = function (teamId, userId, body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationChangeMemberRole(teamId, userId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 新建分组
     * @param {number} teamId
     * @param {OrganizationCreateGroupReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationCreateGroup = function (teamId, body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationCreateGroup(teamId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary C端成员创建团队
     * @param {OrganizationCreateOfficalTeamReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationCreateOfficalTeam = function (body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationCreateOfficalTeam(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 企业创建团队
     * @param {OrganizationCreateTeamRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationCreateTeam = function (body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationCreateTeam(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 删除分组
     * @param {number} teamId 团队id
     * @param {number} groupId 组id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationDeleteGroup = function (teamId, groupId, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationDeleteGroup(teamId, groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 主动退出团队
     * @param {number} teamId
     * @param {OrganizationExitTeamMembershipReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationExitTeamMembership = function (teamId, body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationExitTeamMembership(teamId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取团队专区活跃团队
     * @param {number} [page] 页码.
     * @param {number} [size] 页数量.
     * @param {boolean} [hasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [total] 总数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetActiveTeamList = function (page, size, hasMore, total, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetActiveTeamList(page, size, hasMore, total, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取团队管理员列表
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetAdminTeamList = function (paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetAdminTeamList(paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取部门架构
     * @param {number} departmentId 部门id，值为0时为获取最top级别的数据
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetDepartmentHierarchy = function (departmentId, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetDepartmentHierarchy(departmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取部门下的成员
     * @param {number} departmentId 部门id
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetDepartmentMemberList = function (departmentId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetDepartmentMemberList(departmentId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取邀请信息
     * @param {string} code 邀请码
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetInvitationInfo = function (code, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetInvitationInfo(code, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取团队信息
     * @param {number} teamId 团队id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetTeam = function (teamId, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetTeam(teamId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取团队管理员列表
     * @param {number} teamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetTeamAdministrators = function (teamId, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetTeamAdministrators(teamId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取团队管理员列表(内部请求)
     * @param {number} teamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetTeamAdministratorsForInternal = function (teamId, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetTeamAdministratorsForInternal(teamId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取团队组织架构
     * @param {number} teamId 团队id
     * @param {number} departmentId 组id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetTeamHierarchy = function (teamId, departmentId, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetTeamHierarchy(teamId, departmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 生成邀请码
     * @param {number} [teamId] 团队id.
     * @param {'NORMAL' | 'ADMIN' | 'CREATOR' | 'NOT_MEMBER'} [role] 角色.   - NORMAL: 普通成员  - ADMIN: 管理员  - CREATOR: 创建者  - NOT_MEMBER: 非成员
     * @param {number} [groupId] 指定要加入的组,不传递则加入未分组.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetTeamInviteCode = function (teamId, role, groupId, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetTeamInviteCode(teamId, role, groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 团队邀请信息查询
     * @param {OrganizationGetTeamInvitedHistoryReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetTeamInvitedHistory = function (body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetTeamInvitedHistory(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取我的团队列表
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetTeamList = function (paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetTeamList(paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取团队成员信息
     * @param {number} teamId
     * @param {string} memberGuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetTeamMember = function (teamId, memberGuid, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetTeamMember(teamId, memberGuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取指定分组的团队成员列表
     * @param {number} teamId 团队id
     * @param {number} departmentId 部门id
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetTeamMemberList = function (teamId, departmentId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetTeamMemberList(teamId, departmentId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取团队成员列表
     * @param {number} teamId
     * @param {number} [page] 页码.
     * @param {number} [size] 页数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetTeamMembers = function (teamId, page, size, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetTeamMembers(teamId, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 批量获取团队信息
     * @param {OrganizationTeamIDList} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetTeams = function (body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetTeams(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取指定用户的团队列表
     * @param {string} [guid]
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetUserTeamList = function (guid, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetUserTeamList(guid, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取用户在指定团队列表中的角色
     * @param {OrganizationTeamIDList} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationGetUserTeamRole = function (body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationGetUserTeamRole(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 通过邀请码加入团队
     * @param {OrganizationJoinTeamWithInviteCodeReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationJoinTeamWithInviteCode = function (body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationJoinTeamWithInviteCode(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 编辑分组
     * @param {OrganizationModifyGroupReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationModifyGroup = function (body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationModifyGroup(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 修改分组名称
     * @param {number} teamId
     * @param {number} groupId
     * @param {OrganizationModifyGroupNameReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationModifyGroupName = function (teamId, groupId, body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationModifyGroupName(teamId, groupId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 调整用户全部分组
     * @param {string} memberGuid 待移动的成员
     * @param {OrganizationModifyMemberGroupReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationModifyMemberGroup = function (memberGuid, body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationModifyMemberGroup(memberGuid, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 移动分组
     * @param {OrganizationMoveGroupReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationMoveGroup = function (body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationMoveGroup(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 更新团队信息
     * @param {number} teamId 团队id
     * @param {OrganizationPutTeamRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationPutTeam = function (teamId, body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationPutTeam(teamId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 移除团队组成员
     * @param {number} teamId 团队id
     * @param {number} departmentId 小组id
     * @param {OrganizationRemoveGroupMemberRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationRemoveGroupMember = function (teamId, departmentId, body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationRemoveGroupMember(teamId, departmentId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 解散团队
     * @param {number} teamId 团队id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationRemoveTeam = function (teamId, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationRemoveTeam(teamId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 移除团队成员
     * @param {number} teamId 团队id
     * @param {OrganizationRemoveTeamMemberRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationRemoveTeamMember = function (teamId, body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationRemoveTeamMember(teamId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 搜索部门下的成员
     * @param {number} departmentId 团队id
     * @param {string} [keyword] 搜索词.
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationSearchDepartmentMembers = function (departmentId, keyword, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationSearchDepartmentMembers(departmentId, keyword, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 搜索组名
     * @param {string} [keyword] 搜索词.
     * @param {number} [teamId]
     * @param {number} [paginationId] id 标识符.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationSearchGroupByName = function (keyword, teamId, paginationId, paginationSize, paginationHasMore, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationSearchGroupByName(keyword, teamId, paginationId, paginationSize, paginationHasMore, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 搜索我的团队成员列表
     * @param {number} teamId 团队id
     * @param {string} [keyword] 搜索词.
     * @param {number} [paginationId] id 标识符.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationSearchTeamMembers = function (teamId, keyword, paginationId, paginationSize, paginationHasMore, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationSearchTeamMembers(teamId, keyword, paginationId, paginationSize, paginationHasMore, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 批量获取团队信息
     * @param {OrganizationSearchTeamsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationSearchTeams = function (body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationSearchTeams(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 移交团队成员
     * @param {OrganizationTransferCreatorReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.organizationTransferCreator = function (body, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).organizationTransferCreator(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OrganizationApi;
}(base_1.BaseAPI));
exports.OrganizationApi = OrganizationApi;
/**
 * PermissionApi - axios parameter creator
 * @export
 */
var PermissionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 目前只给测试使用的
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAddPoliciesReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAddPolicies: function (appType, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('permissionAddPolicies', 'appType', appType);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('permissionAddPolicies', 'body', body);
                    localVarPath = "/api/permission/manage/{appType}/add-policies"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 添加策略
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAddPolicyReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAddPolicy: function (appType, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('permissionAddPolicy', 'appType', appType);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('permissionAddPolicy', 'body', body);
                    localVarPath = "/api/permission/manage/{appType}/add-policy"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 添加角色
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAddRoleReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAddRole: function (appType, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('permissionAddRole', 'appType', appType);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('permissionAddRole', 'body', body);
                    localVarPath = "/api/permission/manage/{appType}/add-role"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 给用户添加角色
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAddRoleForUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAddRoleForUser: function (appType, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('permissionAddRoleForUser', 'appType', appType);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('permissionAddRoleForUser', 'body', body);
                    localVarPath = "/disable/{appType}/add-role-for-user"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 角色关联策略 1对多
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAssociateRolePolicyReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssociateRolePolicy: function (appType, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('permissionAssociateRolePolicy', 'appType', appType);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('permissionAssociateRolePolicy', 'body', body);
                    localVarPath = "/api/permission/manage/{appType}/associate-role-policy"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 用户关联角色 1对多
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAssociateUserRoleReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssociateUserRole: function (appType, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('permissionAssociateUserRole', 'appType', appType);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('permissionAssociateUserRole', 'body', body);
                    localVarPath = "/api/permission/manage/{appType}/associate-user-role"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 给用户减少角色
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionDeleteRoleForUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionDeleteRoleForUser: function (appType, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('permissionDeleteRoleForUser', 'appType', appType);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('permissionDeleteRoleForUser', 'body', body);
                    localVarPath = "/disable/{appType}/delete_role_for_user"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 批量查询用户的角色
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionGetRolesForUsersReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionGetRolesForUsers: function (appType, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('permissionGetRolesForUsers', 'appType', appType);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('permissionGetRolesForUsers', 'body', body);
                    localVarPath = "/disable/{appType}/get-roles-for-users"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 权限是否许可
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {PermissionHasPermissionReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionHasPermission: function (appType, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appType' is not null or undefined
                    (0, common_1.assertParamExists)('permissionHasPermission', 'appType', appType);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('permissionHasPermission', 'body', body);
                    localVarPath = "/disable/{appType}/has-permission"
                        .replace("{".concat("appType", "}"), encodeURIComponent(String(appType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.PermissionApiAxiosParamCreator = PermissionApiAxiosParamCreator;
/**
 * PermissionApi - functional programming interface
 * @export
 */
var PermissionApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PermissionApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 目前只给测试使用的
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAddPoliciesReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAddPolicies: function (appType, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.permissionAddPolicies(appType, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 添加策略
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAddPolicyReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAddPolicy: function (appType, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.permissionAddPolicy(appType, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 添加角色
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAddRoleReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAddRole: function (appType, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.permissionAddRole(appType, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 给用户添加角色
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAddRoleForUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAddRoleForUser: function (appType, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.permissionAddRoleForUser(appType, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 角色关联策略 1对多
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAssociateRolePolicyReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssociateRolePolicy: function (appType, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.permissionAssociateRolePolicy(appType, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 用户关联角色 1对多
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAssociateUserRoleReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssociateUserRole: function (appType, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.permissionAssociateUserRole(appType, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 给用户减少角色
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionDeleteRoleForUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionDeleteRoleForUser: function (appType, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.permissionDeleteRoleForUser(appType, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 批量查询用户的角色
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionGetRolesForUsersReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionGetRolesForUsers: function (appType, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.permissionGetRolesForUsers(appType, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 权限是否许可
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {PermissionHasPermissionReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionHasPermission: function (appType, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.permissionHasPermission(appType, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PermissionApiFp = PermissionApiFp;
/**
 * PermissionApi - factory interface
 * @export
 */
var PermissionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PermissionApiFp)(configuration);
    return {
        /**
         *
         * @summary 目前只给测试使用的
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAddPoliciesReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAddPolicies: function (appType, body, options) {
            return localVarFp.permissionAddPolicies(appType, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 添加策略
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAddPolicyReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAddPolicy: function (appType, body, options) {
            return localVarFp.permissionAddPolicy(appType, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 添加角色
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAddRoleReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAddRole: function (appType, body, options) {
            return localVarFp.permissionAddRole(appType, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 给用户添加角色
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAddRoleForUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAddRoleForUser: function (appType, body, options) {
            return localVarFp.permissionAddRoleForUser(appType, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 角色关联策略 1对多
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAssociateRolePolicyReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssociateRolePolicy: function (appType, body, options) {
            return localVarFp.permissionAssociateRolePolicy(appType, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 用户关联角色 1对多
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionAssociateUserRoleReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssociateUserRole: function (appType, body, options) {
            return localVarFp.permissionAssociateUserRole(appType, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 给用户减少角色
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionDeleteRoleForUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionDeleteRoleForUser: function (appType, body, options) {
            return localVarFp.permissionDeleteRoleForUser(appType, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 批量查询用户的角色
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
         * @param {PermissionGetRolesForUsersReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionGetRolesForUsers: function (appType, body, options) {
            return localVarFp.permissionGetRolesForUsers(appType, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 权限是否许可
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
         * @param {PermissionHasPermissionReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionHasPermission: function (appType, body, options) {
            return localVarFp.permissionHasPermission(appType, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PermissionApiFactory = PermissionApiFactory;
/**
 * PermissionApi - object-oriented interface
 * @export
 * @class PermissionApi
 * @extends {BaseAPI}
 */
var PermissionApi = /** @class */ (function (_super) {
    __extends(PermissionApi, _super);
    function PermissionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 目前只给测试使用的
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
     * @param {PermissionAddPoliciesReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionApi
     */
    PermissionApi.prototype.permissionAddPolicies = function (appType, body, options) {
        var _this = this;
        return (0, exports.PermissionApiFp)(this.configuration).permissionAddPolicies(appType, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 添加策略
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
     * @param {PermissionAddPolicyReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionApi
     */
    PermissionApi.prototype.permissionAddPolicy = function (appType, body, options) {
        var _this = this;
        return (0, exports.PermissionApiFp)(this.configuration).permissionAddPolicy(appType, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 添加角色
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
     * @param {PermissionAddRoleReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionApi
     */
    PermissionApi.prototype.permissionAddRole = function (appType, body, options) {
        var _this = this;
        return (0, exports.PermissionApiFp)(this.configuration).permissionAddRole(appType, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 给用户添加角色
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
     * @param {PermissionAddRoleForUserReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionApi
     */
    PermissionApi.prototype.permissionAddRoleForUser = function (appType, body, options) {
        var _this = this;
        return (0, exports.PermissionApiFp)(this.configuration).permissionAddRoleForUser(appType, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 角色关联策略 1对多
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
     * @param {PermissionAssociateRolePolicyReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionApi
     */
    PermissionApi.prototype.permissionAssociateRolePolicy = function (appType, body, options) {
        var _this = this;
        return (0, exports.PermissionApiFp)(this.configuration).permissionAssociateRolePolicy(appType, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 用户关联角色 1对多
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
     * @param {PermissionAssociateUserRoleReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionApi
     */
    PermissionApi.prototype.permissionAssociateUserRole = function (appType, body, options) {
        var _this = this;
        return (0, exports.PermissionApiFp)(this.configuration).permissionAssociateUserRole(appType, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 给用户减少角色
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
     * @param {PermissionDeleteRoleForUserReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionApi
     */
    PermissionApi.prototype.permissionDeleteRoleForUser = function (appType, body, options) {
        var _this = this;
        return (0, exports.PermissionApiFp)(this.configuration).permissionDeleteRoleForUser(appType, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 批量查询用户的角色
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType 应用类型，例如 TECHFORGOODPX
     * @param {PermissionGetRolesForUsersReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionApi
     */
    PermissionApi.prototype.permissionGetRolesForUsers = function (appType, body, options) {
        var _this = this;
        return (0, exports.PermissionApiFp)(this.configuration).permissionGetRolesForUsers(appType, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 权限是否许可
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appType
     * @param {PermissionHasPermissionReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionApi
     */
    PermissionApi.prototype.permissionHasPermission = function (appType, body, options) {
        var _this = this;
        return (0, exports.PermissionApiFp)(this.configuration).permissionHasPermission(appType, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PermissionApi;
}(base_1.BaseAPI));
exports.PermissionApi = PermissionApi;
/**
 * PermissionaclApi - axios parameter creator
 * @export
 */
var PermissionaclApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 管理后台 增删改查permission
         * @param {PermissionaclAdminAddPermissionRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionaclAdminAddPermission: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('permissionaclAdminAddPermission', 'body', body);
                    localVarPath = "/admin/api/permissionacl/permissions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionaclAdminBatchPermission: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/api/permissionacl/permissions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} permissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionaclAdminDeletePermisiion: function (permissionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'permissionId' is not null or undefined
                    (0, common_1.assertParamExists)('permissionaclAdminDeletePermisiion', 'permissionId', permissionId);
                    localVarPath = "/admin/api/permissionacl/permissions/{permissionId}"
                        .replace("{".concat("permissionId", "}"), encodeURIComponent(String(permissionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} permissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionaclAdminGetPermission: function (permissionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'permissionId' is not null or undefined
                    (0, common_1.assertParamExists)('permissionaclAdminGetPermission', 'permissionId', permissionId);
                    localVarPath = "/admin/api/permissionacl/permissions/{permissionId}"
                        .replace("{".concat("permissionId", "}"), encodeURIComponent(String(permissionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 更新permission
         * @param {number} permissionId
         * @param {PermissionaclAdminUpdatePermissionRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionaclAdminUpdatePermission: function (permissionId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'permissionId' is not null or undefined
                    (0, common_1.assertParamExists)('permissionaclAdminUpdatePermission', 'permissionId', permissionId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('permissionaclAdminUpdatePermission', 'body', body);
                    localVarPath = "/admin/api/permissionacl/permissions/{permissionId}"
                        .replace("{".concat("permissionId", "}"), encodeURIComponent(String(permissionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.PermissionaclApiAxiosParamCreator = PermissionaclApiAxiosParamCreator;
/**
 * PermissionaclApi - functional programming interface
 * @export
 */
var PermissionaclApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PermissionaclApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 管理后台 增删改查permission
         * @param {PermissionaclAdminAddPermissionRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionaclAdminAddPermission: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.permissionaclAdminAddPermission(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionaclAdminBatchPermission: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.permissionaclAdminBatchPermission(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} permissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionaclAdminDeletePermisiion: function (permissionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.permissionaclAdminDeletePermisiion(permissionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} permissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionaclAdminGetPermission: function (permissionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.permissionaclAdminGetPermission(permissionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 更新permission
         * @param {number} permissionId
         * @param {PermissionaclAdminUpdatePermissionRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionaclAdminUpdatePermission: function (permissionId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.permissionaclAdminUpdatePermission(permissionId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PermissionaclApiFp = PermissionaclApiFp;
/**
 * PermissionaclApi - factory interface
 * @export
 */
var PermissionaclApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PermissionaclApiFp)(configuration);
    return {
        /**
         *
         * @summary 管理后台 增删改查permission
         * @param {PermissionaclAdminAddPermissionRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionaclAdminAddPermission: function (body, options) {
            return localVarFp.permissionaclAdminAddPermission(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionaclAdminBatchPermission: function (options) {
            return localVarFp.permissionaclAdminBatchPermission(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} permissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionaclAdminDeletePermisiion: function (permissionId, options) {
            return localVarFp.permissionaclAdminDeletePermisiion(permissionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} permissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionaclAdminGetPermission: function (permissionId, options) {
            return localVarFp.permissionaclAdminGetPermission(permissionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 更新permission
         * @param {number} permissionId
         * @param {PermissionaclAdminUpdatePermissionRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionaclAdminUpdatePermission: function (permissionId, body, options) {
            return localVarFp.permissionaclAdminUpdatePermission(permissionId, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PermissionaclApiFactory = PermissionaclApiFactory;
/**
 * PermissionaclApi - object-oriented interface
 * @export
 * @class PermissionaclApi
 * @extends {BaseAPI}
 */
var PermissionaclApi = /** @class */ (function (_super) {
    __extends(PermissionaclApi, _super);
    function PermissionaclApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 管理后台 增删改查permission
     * @param {PermissionaclAdminAddPermissionRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionaclApi
     */
    PermissionaclApi.prototype.permissionaclAdminAddPermission = function (body, options) {
        var _this = this;
        return (0, exports.PermissionaclApiFp)(this.configuration).permissionaclAdminAddPermission(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionaclApi
     */
    PermissionaclApi.prototype.permissionaclAdminBatchPermission = function (options) {
        var _this = this;
        return (0, exports.PermissionaclApiFp)(this.configuration).permissionaclAdminBatchPermission(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} permissionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionaclApi
     */
    PermissionaclApi.prototype.permissionaclAdminDeletePermisiion = function (permissionId, options) {
        var _this = this;
        return (0, exports.PermissionaclApiFp)(this.configuration).permissionaclAdminDeletePermisiion(permissionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} permissionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionaclApi
     */
    PermissionaclApi.prototype.permissionaclAdminGetPermission = function (permissionId, options) {
        var _this = this;
        return (0, exports.PermissionaclApiFp)(this.configuration).permissionaclAdminGetPermission(permissionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 更新permission
     * @param {number} permissionId
     * @param {PermissionaclAdminUpdatePermissionRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionaclApi
     */
    PermissionaclApi.prototype.permissionaclAdminUpdatePermission = function (permissionId, body, options) {
        var _this = this;
        return (0, exports.PermissionaclApiFp)(this.configuration).permissionaclAdminUpdatePermission(permissionId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PermissionaclApi;
}(base_1.BaseAPI));
exports.PermissionaclApi = PermissionaclApi;
/**
 * RbacApi - axios parameter creator
 * @export
 */
var RbacApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {RbacUserAccessRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rbacUserHasAccess: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('rbacUserHasAccess', 'body', body);
                    localVarPath = "/api/rbac/user_has_access";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {RbacUserRoleRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rbacUserHasRole: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('rbacUserHasRole', 'body', body);
                    localVarPath = "/api/rbac/user_has_role";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.RbacApiAxiosParamCreator = RbacApiAxiosParamCreator;
/**
 * RbacApi - functional programming interface
 * @export
 */
var RbacApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RbacApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {RbacUserAccessRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rbacUserHasAccess: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rbacUserHasAccess(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RbacUserRoleRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rbacUserHasRole: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rbacUserHasRole(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.RbacApiFp = RbacApiFp;
/**
 * RbacApi - factory interface
 * @export
 */
var RbacApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RbacApiFp)(configuration);
    return {
        /**
         *
         * @param {RbacUserAccessRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rbacUserHasAccess: function (body, options) {
            return localVarFp.rbacUserHasAccess(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RbacUserRoleRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rbacUserHasRole: function (body, options) {
            return localVarFp.rbacUserHasRole(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RbacApiFactory = RbacApiFactory;
/**
 * RbacApi - object-oriented interface
 * @export
 * @class RbacApi
 * @extends {BaseAPI}
 */
var RbacApi = /** @class */ (function (_super) {
    __extends(RbacApi, _super);
    function RbacApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {RbacUserAccessRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbacApi
     */
    RbacApi.prototype.rbacUserHasAccess = function (body, options) {
        var _this = this;
        return (0, exports.RbacApiFp)(this.configuration).rbacUserHasAccess(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RbacUserRoleRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbacApi
     */
    RbacApi.prototype.rbacUserHasRole = function (body, options) {
        var _this = this;
        return (0, exports.RbacApiFp)(this.configuration).rbacUserHasRole(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RbacApi;
}(base_1.BaseAPI));
exports.RbacApi = RbacApi;
/**
 * ReportApi - axios parameter creator
 * @export
 */
var ReportApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 创建一个报告
         * @param {ReportReportInfo} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportCreate: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('reportCreate', 'body', body);
                    localVarPath = "/api/report/reporter";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 删除一个报告
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('reportDelete', 'id', id);
                    localVarPath = "/api/report/reporter/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取一份报告
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('reportGet', 'id', id);
                    localVarPath = "/api/report/reporter/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 单个问卷信息
         * @param {string} id 问卷id
         * @param {string} [openid] openid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetSurvey: function (id, openid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('reportGetSurvey', 'id', id);
                    localVarPath = "/api/report/reporter/survey/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (openid !== undefined) {
                        localVarQueryParameter['openid'] = openid;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 个人工作台报告列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at'} [orderBy]
         * @param {'desc' | 'asc'} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportListReport: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/report/reporter/reports";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 团队工作台报告列表
         * @param {number} teamId 归属团队
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at'} [orderBy]
         * @param {'desc' | 'asc'} [sort]
         * @param {number} [mine] 是否获取个人报告 1&#x3D;是，其他&#x3D;否.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportListTeamReport: function (teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, mine, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('reportListTeamReport', 'teamId', teamId);
                    localVarPath = "/api/report/reporter/teamreports/{teamId}"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    if (mine !== undefined) {
                        localVarQueryParameter['mine'] = mine;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 问卷列表
         * @param {string} [openid]
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportListWJ: function (openid, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/report/reporter/surveies";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (openid !== undefined) {
                        localVarQueryParameter['openid'] = openid;
                    }
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 保存一份报告
         * @param {number} id 报告id
         * @param {ReportSaveReportReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSave: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('reportSave', 'id', id);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('reportSave', 'body', body);
                    localVarPath = "/api/report/reporter/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 搜索列表
         * @param {string} [filterTitle]
         * @param {string} [filterSurveyId]
         * @param {string} [filterOpenId]
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSearch: function (filterTitle, filterSurveyId, filterOpenId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/report/reporter/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (filterTitle !== undefined) {
                        localVarQueryParameter['filter.title'] = filterTitle;
                    }
                    if (filterSurveyId !== undefined) {
                        localVarQueryParameter['filter.surveyId'] = filterSurveyId;
                    }
                    if (filterOpenId !== undefined) {
                        localVarQueryParameter['filter.openId'] = filterOpenId;
                    }
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 问卷更新回调
         * @param {string} openid
         * @param {ReportSurveyHookReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSurveyHook: function (openid, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'openid' is not null or undefined
                    (0, common_1.assertParamExists)('reportSurveyHook', 'openid', openid);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('reportSurveyHook', 'body', body);
                    localVarPath = "/api/report/survey/hook/{openid}"
                        .replace("{".concat("openid", "}"), encodeURIComponent(String(openid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 问卷交叉统计数据
         * @param {string} id 问卷id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSurveyIntersectStat: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('reportSurveyIntersectStat', 'id', id);
                    localVarPath = "/api/report/survey/intersection/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 问卷题目统计数据
         * @param {string} id 问卷id
         * @param {string} [openid] openid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSurveyStat: function (id, openid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('reportSurveyStat', 'id', id);
                    localVarPath = "/api/report/reporter/surveies/{id}/stat"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (openid !== undefined) {
                        localVarQueryParameter['openid'] = openid;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ReportApiAxiosParamCreator = ReportApiAxiosParamCreator;
/**
 * ReportApi - functional programming interface
 * @export
 */
var ReportApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ReportApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 创建一个报告
         * @param {ReportReportInfo} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportCreate: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportCreate(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 删除一个报告
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDelete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取一份报告
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGet: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 单个问卷信息
         * @param {string} id 问卷id
         * @param {string} [openid] openid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetSurvey: function (id, openid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportGetSurvey(id, openid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 个人工作台报告列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at'} [orderBy]
         * @param {'desc' | 'asc'} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportListReport: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportListReport(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 团队工作台报告列表
         * @param {number} teamId 归属团队
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at'} [orderBy]
         * @param {'desc' | 'asc'} [sort]
         * @param {number} [mine] 是否获取个人报告 1&#x3D;是，其他&#x3D;否.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportListTeamReport: function (teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, mine, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportListTeamReport(teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, mine, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 问卷列表
         * @param {string} [openid]
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportListWJ: function (openid, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportListWJ(openid, paginationPage, paginationSize, paginationHasMore, paginationTotal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 保存一份报告
         * @param {number} id 报告id
         * @param {ReportSaveReportReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSave: function (id, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportSave(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 搜索列表
         * @param {string} [filterTitle]
         * @param {string} [filterSurveyId]
         * @param {string} [filterOpenId]
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSearch: function (filterTitle, filterSurveyId, filterOpenId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportSearch(filterTitle, filterSurveyId, filterOpenId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 问卷更新回调
         * @param {string} openid
         * @param {ReportSurveyHookReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSurveyHook: function (openid, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportSurveyHook(openid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 问卷交叉统计数据
         * @param {string} id 问卷id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSurveyIntersectStat: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportSurveyIntersectStat(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 问卷题目统计数据
         * @param {string} id 问卷id
         * @param {string} [openid] openid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSurveyStat: function (id, openid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportSurveyStat(id, openid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ReportApiFp = ReportApiFp;
/**
 * ReportApi - factory interface
 * @export
 */
var ReportApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ReportApiFp)(configuration);
    return {
        /**
         *
         * @summary 创建一个报告
         * @param {ReportReportInfo} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportCreate: function (body, options) {
            return localVarFp.reportCreate(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 删除一个报告
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDelete: function (id, options) {
            return localVarFp.reportDelete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取一份报告
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGet: function (id, options) {
            return localVarFp.reportGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 单个问卷信息
         * @param {string} id 问卷id
         * @param {string} [openid] openid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetSurvey: function (id, openid, options) {
            return localVarFp.reportGetSurvey(id, openid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 个人工作台报告列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at'} [orderBy]
         * @param {'desc' | 'asc'} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportListReport: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, options) {
            return localVarFp.reportListReport(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 团队工作台报告列表
         * @param {number} teamId 归属团队
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'default' | 'created_at' | 'updated_at'} [orderBy]
         * @param {'desc' | 'asc'} [sort]
         * @param {number} [mine] 是否获取个人报告 1&#x3D;是，其他&#x3D;否.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportListTeamReport: function (teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, mine, options) {
            return localVarFp.reportListTeamReport(teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, mine, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 问卷列表
         * @param {string} [openid]
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportListWJ: function (openid, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return localVarFp.reportListWJ(openid, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 保存一份报告
         * @param {number} id 报告id
         * @param {ReportSaveReportReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSave: function (id, body, options) {
            return localVarFp.reportSave(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 搜索列表
         * @param {string} [filterTitle]
         * @param {string} [filterSurveyId]
         * @param {string} [filterOpenId]
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSearch: function (filterTitle, filterSurveyId, filterOpenId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return localVarFp.reportSearch(filterTitle, filterSurveyId, filterOpenId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 问卷更新回调
         * @param {string} openid
         * @param {ReportSurveyHookReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSurveyHook: function (openid, body, options) {
            return localVarFp.reportSurveyHook(openid, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 问卷交叉统计数据
         * @param {string} id 问卷id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSurveyIntersectStat: function (id, options) {
            return localVarFp.reportSurveyIntersectStat(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 问卷题目统计数据
         * @param {string} id 问卷id
         * @param {string} [openid] openid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSurveyStat: function (id, openid, options) {
            return localVarFp.reportSurveyStat(id, openid, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ReportApiFactory = ReportApiFactory;
/**
 * ReportApi - object-oriented interface
 * @export
 * @class ReportApi
 * @extends {BaseAPI}
 */
var ReportApi = /** @class */ (function (_super) {
    __extends(ReportApi, _super);
    function ReportApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 创建一个报告
     * @param {ReportReportInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    ReportApi.prototype.reportCreate = function (body, options) {
        var _this = this;
        return (0, exports.ReportApiFp)(this.configuration).reportCreate(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 删除一个报告
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    ReportApi.prototype.reportDelete = function (id, options) {
        var _this = this;
        return (0, exports.ReportApiFp)(this.configuration).reportDelete(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取一份报告
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    ReportApi.prototype.reportGet = function (id, options) {
        var _this = this;
        return (0, exports.ReportApiFp)(this.configuration).reportGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 单个问卷信息
     * @param {string} id 问卷id
     * @param {string} [openid] openid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    ReportApi.prototype.reportGetSurvey = function (id, openid, options) {
        var _this = this;
        return (0, exports.ReportApiFp)(this.configuration).reportGetSurvey(id, openid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 个人工作台报告列表
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {'default' | 'created_at' | 'updated_at'} [orderBy]
     * @param {'desc' | 'asc'} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    ReportApi.prototype.reportListReport = function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, options) {
        var _this = this;
        return (0, exports.ReportApiFp)(this.configuration).reportListReport(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 团队工作台报告列表
     * @param {number} teamId 归属团队
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {'default' | 'created_at' | 'updated_at'} [orderBy]
     * @param {'desc' | 'asc'} [sort]
     * @param {number} [mine] 是否获取个人报告 1&#x3D;是，其他&#x3D;否.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    ReportApi.prototype.reportListTeamReport = function (teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, mine, options) {
        var _this = this;
        return (0, exports.ReportApiFp)(this.configuration).reportListTeamReport(teamId, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, mine, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 问卷列表
     * @param {string} [openid]
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    ReportApi.prototype.reportListWJ = function (openid, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
        var _this = this;
        return (0, exports.ReportApiFp)(this.configuration).reportListWJ(openid, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 保存一份报告
     * @param {number} id 报告id
     * @param {ReportSaveReportReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    ReportApi.prototype.reportSave = function (id, body, options) {
        var _this = this;
        return (0, exports.ReportApiFp)(this.configuration).reportSave(id, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 搜索列表
     * @param {string} [filterTitle]
     * @param {string} [filterSurveyId]
     * @param {string} [filterOpenId]
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    ReportApi.prototype.reportSearch = function (filterTitle, filterSurveyId, filterOpenId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
        var _this = this;
        return (0, exports.ReportApiFp)(this.configuration).reportSearch(filterTitle, filterSurveyId, filterOpenId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 问卷更新回调
     * @param {string} openid
     * @param {ReportSurveyHookReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    ReportApi.prototype.reportSurveyHook = function (openid, body, options) {
        var _this = this;
        return (0, exports.ReportApiFp)(this.configuration).reportSurveyHook(openid, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 问卷交叉统计数据
     * @param {string} id 问卷id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    ReportApi.prototype.reportSurveyIntersectStat = function (id, options) {
        var _this = this;
        return (0, exports.ReportApiFp)(this.configuration).reportSurveyIntersectStat(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 问卷题目统计数据
     * @param {string} id 问卷id
     * @param {string} [openid] openid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    ReportApi.prototype.reportSurveyStat = function (id, openid, options) {
        var _this = this;
        return (0, exports.ReportApiFp)(this.configuration).reportSurveyStat(id, openid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ReportApi;
}(base_1.BaseAPI));
exports.ReportApi = ReportApi;
/**
 * ResearchReportApi - axios parameter creator
 * @export
 */
var ResearchReportApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 审核报告
         * @param {ResearchreportAdminAuditResearchReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportAdminAuditResearchReport: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportAdminAuditResearchReport', 'body', body);
                    localVarPath = "/admin/api/researchreport/audit";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 下架报告
         * @param {ResearchreportAdminDisabledResearchReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportAdminDisabledResearchReport: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportAdminDisabledResearchReport', 'body', body);
                    localVarPath = "/admin/api/researchreport/disabled";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取 id hash salt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportAdminGetHashSalt: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/api/researchreport/salt";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 通过 hash id 批量获取研究报告
         * @param {ResearchreportBatchResearchReportsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportBatchResearchReports: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportBatchResearchReports', 'body', body);
                    localVarPath = "/api/researchreport/researchreports/batch";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 创建研究报告
         * @param {ResearchreportCreateResearchReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportCreateResearchReport: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportCreateResearchReport', 'body', body);
                    localVarPath = "/api/researchreport/researchreports";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 删除研究报告
         * @param {string} researchreportHashId 研究报告 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDeleteResearchReport: function (researchreportHashId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'researchreportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportDeleteResearchReport', 'researchreportHashId', researchreportHashId);
                    localVarPath = "/api/researchreport/researchreports/{researchreportHashId}"
                        .replace("{".concat("researchreportHashId", "}"), encodeURIComponent(String(researchreportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 下线报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDisabledResearchReport: function (researchreportHashId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'researchreportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportDisabledResearchReport', 'researchreportHashId', researchreportHashId);
                    localVarPath = "/api/researchreport/researchreports/{researchreportHashId}/disabled"
                        .replace("{".concat("researchreportHashId", "}"), encodeURIComponent(String(researchreportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 下载文件
         * @param {string} fileUuid 文件 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDownloadFile: function (fileUuid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'fileUuid' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportDownloadFile', 'fileUuid', fileUuid);
                    localVarPath = "/api/researchreport/file/{fileUuid}/download"
                        .replace("{".concat("fileUuid", "}"), encodeURIComponent(String(fileUuid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 下载研究报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDownloadOriginalResearchReport: function (researchreportHashId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'researchreportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportDownloadOriginalResearchReport', 'researchreportHashId', researchreportHashId);
                    localVarPath = "/api/researchreport/researchreports/{researchreportHashId}/download/origin"
                        .replace("{".concat("researchreportHashId", "}"), encodeURIComponent(String(researchreportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary web端下载研究报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {string} [randomString] 图形验证码随机字符串.
         * @param {string} [ticket] 图形验证码ticket.
         * @param {string} [permissionTicket] 权限票据.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDownloadResearchReport: function (researchreportHashId, randomString, ticket, permissionTicket, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'researchreportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportDownloadResearchReport', 'researchreportHashId', researchreportHashId);
                    localVarPath = "/api/researchreport/researchreports/{researchreportHashId}/download"
                        .replace("{".concat("researchreportHashId", "}"), encodeURIComponent(String(researchreportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (randomString !== undefined) {
                        localVarQueryParameter['randomString'] = randomString;
                    }
                    if (ticket !== undefined) {
                        localVarQueryParameter['ticket'] = ticket;
                    }
                    if (permissionTicket !== undefined) {
                        localVarQueryParameter['permissionTicket'] = permissionTicket;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 小程序端下载研究报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {string} [randomString] 图形验证码随机字符串.
         * @param {string} [ticket] 图形验证码ticket.
         * @param {string} [permissionTicket] 权限票据.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDownloadResearchReportOnMP: function (researchreportHashId, randomString, ticket, permissionTicket, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'researchreportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportDownloadResearchReportOnMP', 'researchreportHashId', researchreportHashId);
                    localVarPath = "/api/researchreport/researchreports/{researchreportHashId}/mp/download"
                        .replace("{".concat("researchreportHashId", "}"), encodeURIComponent(String(researchreportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (randomString !== undefined) {
                        localVarQueryParameter['randomString'] = randomString;
                    }
                    if (ticket !== undefined) {
                        localVarQueryParameter['ticket'] = ticket;
                    }
                    if (permissionTicket !== undefined) {
                        localVarQueryParameter['permissionTicket'] = permissionTicket;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary GetCollectedUserInfoTicket 留资票据,拿到票据可以前往查阅报告
         * @param {string} reportHashId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetCollectedUserInfoTicket: function (reportHashId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'reportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportGetCollectedUserInfoTicket', 'reportHashId', reportHashId);
                    localVarPath = "/api/researchreport/{reportHashId}/info/collection/ticket"
                        .replace("{".concat("reportHashId", "}"), encodeURIComponent(String(reportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary GetCollectedUserInfos 分页查看已收集到的用户信息
         * @param {string} reportHashId
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetCollectedUserInfos: function (reportHashId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'reportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportGetCollectedUserInfos', 'reportHashId', reportHashId);
                    localVarPath = "/api/researchreport/{reportHashId}/info/collections"
                        .replace("{".concat("reportHashId", "}"), encodeURIComponent(String(reportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取筛选器
         * @param {Array<number>} [firstLevalTagIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetFilter: function (firstLevalTagIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/researchreport/filter";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (firstLevalTagIds) {
                        localVarQueryParameter['firstLevalTagIds'] = firstLevalTagIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 移动端：获取预览token
         * @param {string} researchreportHashId 研究报告 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetRRPreviewToken: function (researchreportHashId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'researchreportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportGetRRPreviewToken', 'researchreportHashId', researchreportHashId);
                    localVarPath = "/api/researchreport/researchreports/{researchreportHashId}/get_preview_token"
                        .replace("{".concat("researchreportHashId", "}"), encodeURIComponent(String(researchreportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取空间对我开放的研究报告列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
         * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {number} [teamId] 团队id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetRRsTeamForMe: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, teamId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/researchreport/researchreports/space/teamforme";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (area !== undefined) {
                        localVarQueryParameter['area'] = area;
                    }
                    if (source !== undefined) {
                        localVarQueryParameter['source'] = source;
                    }
                    if (reportType !== undefined) {
                        localVarQueryParameter['reportType'] = reportType;
                    }
                    if (researchMethod !== undefined) {
                        localVarQueryParameter['researchMethod'] = researchMethod;
                    }
                    if (crowd !== undefined) {
                        localVarQueryParameter['crowd'] = crowd;
                    }
                    if (custom !== undefined) {
                        localVarQueryParameter['custom'] = custom;
                    }
                    if (time !== undefined) {
                        localVarQueryParameter['time'] = time;
                    }
                    if (teamId !== undefined) {
                        localVarQueryParameter['teamId'] = teamId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary GetRequiredFieldsForContent 获取内容所需的用户信息字段
         * @param {string} reportHashId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetRequiredFieldsForContent: function (reportHashId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'reportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportGetRequiredFieldsForContent', 'reportHashId', reportHashId);
                    localVarPath = "/api/researchreport/{reportHashId}/info/collection/fields"
                        .replace("{".concat("reportHashId", "}"), encodeURIComponent(String(reportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取研究报告详情
         * @param {string} researchreportHashId 研究报告ID
         * @param {number} [isEdit] 是否是编辑页.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetResearchReport: function (researchreportHashId, isEdit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'researchreportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportGetResearchReport', 'researchreportHashId', researchreportHashId);
                    localVarPath = "/api/researchreport/researchreports/{researchreportHashId}"
                        .replace("{".concat("researchreportHashId", "}"), encodeURIComponent(String(researchreportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (isEdit !== undefined) {
                        localVarQueryParameter['isEdit'] = isEdit;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取联合发布者的信息
         * @param {string} researchreportHashId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetResearchReportJointPublisher: function (researchreportHashId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'researchreportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportGetResearchReportJointPublisher', 'researchreportHashId', researchreportHashId);
                    localVarPath = "/api/researchreport/{researchreportHashId}/joint/publishers"
                        .replace("{".concat("researchreportHashId", "}"), encodeURIComponent(String(researchreportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取报告公开的归属信息
         * @param {string} researchreportHashId 报告hash id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetResearchReportPublicInfo: function (researchreportHashId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'researchreportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportGetResearchReportPublicInfo', 'researchreportHashId', researchreportHashId);
                    localVarPath = "/api/researchreport/{researchreportHashId}/public/info"
                        .replace("{".concat("researchreportHashId", "}"), encodeURIComponent(String(researchreportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取研究报告列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
         * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {number} [mine] 是否获取个人报告 1&#x3D;是，其他&#x3D;否.
         * @param {number} [teamId] 团队id.
         * @param {number} [isHot] 是否获取当前热门报告 1&#x3D;是，其他&#x3D;否.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetResearchReports: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, mine, teamId, isHot, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/researchreport/researchreports";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (area !== undefined) {
                        localVarQueryParameter['area'] = area;
                    }
                    if (source !== undefined) {
                        localVarQueryParameter['source'] = source;
                    }
                    if (reportType !== undefined) {
                        localVarQueryParameter['reportType'] = reportType;
                    }
                    if (researchMethod !== undefined) {
                        localVarQueryParameter['researchMethod'] = researchMethod;
                    }
                    if (crowd !== undefined) {
                        localVarQueryParameter['crowd'] = crowd;
                    }
                    if (custom !== undefined) {
                        localVarQueryParameter['custom'] = custom;
                    }
                    if (time !== undefined) {
                        localVarQueryParameter['time'] = time;
                    }
                    if (mine !== undefined) {
                        localVarQueryParameter['mine'] = mine;
                    }
                    if (teamId !== undefined) {
                        localVarQueryParameter['teamId'] = teamId;
                    }
                    if (isHot !== undefined) {
                        localVarQueryParameter['isHot'] = isHot;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取空间研究报告列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
         * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [userGuid] 用户guid.
         * @param {number} [teamId] 团队id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetSpaceResearchReports: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, userGuid, teamId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/researchreport/researchreports/space";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (area !== undefined) {
                        localVarQueryParameter['area'] = area;
                    }
                    if (source !== undefined) {
                        localVarQueryParameter['source'] = source;
                    }
                    if (reportType !== undefined) {
                        localVarQueryParameter['reportType'] = reportType;
                    }
                    if (researchMethod !== undefined) {
                        localVarQueryParameter['researchMethod'] = researchMethod;
                    }
                    if (crowd !== undefined) {
                        localVarQueryParameter['crowd'] = crowd;
                    }
                    if (custom !== undefined) {
                        localVarQueryParameter['custom'] = custom;
                    }
                    if (time !== undefined) {
                        localVarQueryParameter['time'] = time;
                    }
                    if (userGuid !== undefined) {
                        localVarQueryParameter['userGuid'] = userGuid;
                    }
                    if (teamId !== undefined) {
                        localVarQueryParameter['teamId'] = teamId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取研究报告缩略图
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {number} page 缩略图页码
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetThumbnail: function (researchreportHashId, page, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'researchreportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportGetThumbnail', 'researchreportHashId', researchreportHashId);
                    // verify required parameter 'page' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportGetThumbnail', 'page', page);
                    localVarPath = "/api/researchreport/researchreports/{researchreportHashId}/thumbnail/{page}"
                        .replace("{".concat("researchreportHashId", "}"), encodeURIComponent(String(researchreportHashId)))
                        .replace("{".concat("page", "}"), encodeURIComponent(String(page)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取工作台研究报告列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
         * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {number} [mine] 是否只获取个人报告 1&#x3D;是，其他&#x3D;否，用于团队工作台.
         * @param {number} [teamId] 团队id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetWorkbenchResearchReports: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, mine, teamId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/researchreport/researchreports/workbench";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (area !== undefined) {
                        localVarQueryParameter['area'] = area;
                    }
                    if (source !== undefined) {
                        localVarQueryParameter['source'] = source;
                    }
                    if (reportType !== undefined) {
                        localVarQueryParameter['reportType'] = reportType;
                    }
                    if (researchMethod !== undefined) {
                        localVarQueryParameter['researchMethod'] = researchMethod;
                    }
                    if (crowd !== undefined) {
                        localVarQueryParameter['crowd'] = crowd;
                    }
                    if (custom !== undefined) {
                        localVarQueryParameter['custom'] = custom;
                    }
                    if (time !== undefined) {
                        localVarQueryParameter['time'] = time;
                    }
                    if (mine !== undefined) {
                        localVarQueryParameter['mine'] = mine;
                    }
                    if (teamId !== undefined) {
                        localVarQueryParameter['teamId'] = teamId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 中断审核
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportInterruptReviwing: function (researchreportHashId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'researchreportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportInterruptReviwing', 'researchreportHashId', researchreportHashId);
                    localVarPath = "/api/researchreport/researchreports/{researchreportHashId}/interrupt_reviewing"
                        .replace("{".concat("researchreportHashId", "}"), encodeURIComponent(String(researchreportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary IsValid 报告id是否是合法的
         * @param {string} researchreportHashId 研究报告ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportIsValid: function (researchreportHashId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'researchreportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportIsValid', 'researchreportHashId', researchreportHashId);
                    localVarPath = "/admin/api/researchreport/isvalid/{researchreportHashId}"
                        .replace("{".concat("researchreportHashId", "}"), encodeURIComponent(String(researchreportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 预览研究报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {string} [token] 临时 token，移动端H5使用.
         * @param {string} [randomString] 图形验证码随机字符串.
         * @param {string} [ticket] 图形验证码ticket.
         * @param {string} [permissionTicket] 权限票据.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportPreviewResearchReport: function (researchreportHashId, token, randomString, ticket, permissionTicket, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'researchreportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportPreviewResearchReport', 'researchreportHashId', researchreportHashId);
                    localVarPath = "/api/researchreport/researchreports/{researchreportHashId}/preview"
                        .replace("{".concat("researchreportHashId", "}"), encodeURIComponent(String(researchreportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (token !== undefined) {
                        localVarQueryParameter['token'] = token;
                    }
                    if (randomString !== undefined) {
                        localVarQueryParameter['randomString'] = randomString;
                    }
                    if (ticket !== undefined) {
                        localVarQueryParameter['ticket'] = ticket;
                    }
                    if (permissionTicket !== undefined) {
                        localVarQueryParameter['permissionTicket'] = permissionTicket;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取推荐研究报告
         * @param {string} [keyword]
         * @param {string} [scene] 场景 all/user/team，默认all.
         * @param {string} [userGuid] scene &#x3D; user 时必填.
         * @param {string} [teamId] scene &#x3D; team 时必填.
         * @param {string} [currentHashId] 当前报告的ID，用来去重.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportRecommendResearchReports: function (keyword, scene, userGuid, teamId, currentHashId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/researchreport/recommend";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (keyword !== undefined) {
                        localVarQueryParameter['keyword'] = keyword;
                    }
                    if (scene !== undefined) {
                        localVarQueryParameter['scene'] = scene;
                    }
                    if (userGuid !== undefined) {
                        localVarQueryParameter['userGuid'] = userGuid;
                    }
                    if (teamId !== undefined) {
                        localVarQueryParameter['teamId'] = teamId;
                    }
                    if (currentHashId !== undefined) {
                        localVarQueryParameter['currentHashId'] = currentHashId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 搜索研究报告
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
         * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [keyword] 搜索关键词.
         * @param {string} [scene] 搜索场景 all/user/team.
         * @param {string} [userGuid] scene &#x3D; user 时必填.
         * @param {string} [teamId] scene &#x3D; team 时必填.
         * @param {boolean} [notRecordKeyword] 不记录搜索词.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportSearchResearchReports: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, keyword, scene, userGuid, teamId, notRecordKeyword, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/researchreport/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (area !== undefined) {
                        localVarQueryParameter['area'] = area;
                    }
                    if (source !== undefined) {
                        localVarQueryParameter['source'] = source;
                    }
                    if (reportType !== undefined) {
                        localVarQueryParameter['reportType'] = reportType;
                    }
                    if (researchMethod !== undefined) {
                        localVarQueryParameter['researchMethod'] = researchMethod;
                    }
                    if (crowd !== undefined) {
                        localVarQueryParameter['crowd'] = crowd;
                    }
                    if (custom !== undefined) {
                        localVarQueryParameter['custom'] = custom;
                    }
                    if (time !== undefined) {
                        localVarQueryParameter['time'] = time;
                    }
                    if (keyword !== undefined) {
                        localVarQueryParameter['keyword'] = keyword;
                    }
                    if (scene !== undefined) {
                        localVarQueryParameter['scene'] = scene;
                    }
                    if (userGuid !== undefined) {
                        localVarQueryParameter['userGuid'] = userGuid;
                    }
                    if (teamId !== undefined) {
                        localVarQueryParameter['teamId'] = teamId;
                    }
                    if (notRecordKeyword !== undefined) {
                        localVarQueryParameter['notRecordKeyword'] = notRecordKeyword;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary SetRequiredFieldsForContent 留资,设置报告所需的用户信息字段
         * @param {string} reportHashId
         * @param {ResearchreportSetRequiredFieldsForContentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportSetRequiredFieldsForContent: function (reportHashId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'reportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportSetRequiredFieldsForContent', 'reportHashId', reportHashId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportSetRequiredFieldsForContent', 'body', body);
                    localVarPath = "/api/researchreport/{reportHashId}/info/collection/fields"
                        .replace("{".concat("reportHashId", "}"), encodeURIComponent(String(reportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 更新研究报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {ResearchreportUpdateResearchReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportUpdateResearchReport: function (researchreportHashId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'researchreportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportUpdateResearchReport', 'researchreportHashId', researchreportHashId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportUpdateResearchReport', 'body', body);
                    localVarPath = "/api/researchreport/researchreports/{researchreportHashId}"
                        .replace("{".concat("researchreportHashId", "}"), encodeURIComponent(String(researchreportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 上传文件
         * @param {ResearchreportUploadFileRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportUploadFile: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportUploadFile', 'body', body);
                    localVarPath = "/api/researchreport/files";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary ValidateAndSaveUserInfo 留资,验证并保存用户信息
         * @param {string} reportHashId
         * @param {ResearchreportValidateAndSaveUserInfoRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportValidateAndSaveUserInfo: function (reportHashId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'reportHashId' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportValidateAndSaveUserInfo', 'reportHashId', reportHashId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('researchReportValidateAndSaveUserInfo', 'body', body);
                    localVarPath = "/api/researchreport/{reportHashId}/info/collection"
                        .replace("{".concat("reportHashId", "}"), encodeURIComponent(String(reportHashId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ResearchReportApiAxiosParamCreator = ResearchReportApiAxiosParamCreator;
/**
 * ResearchReportApi - functional programming interface
 * @export
 */
var ResearchReportApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ResearchReportApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 审核报告
         * @param {ResearchreportAdminAuditResearchReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportAdminAuditResearchReport: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportAdminAuditResearchReport(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 下架报告
         * @param {ResearchreportAdminDisabledResearchReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportAdminDisabledResearchReport: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportAdminDisabledResearchReport(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取 id hash salt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportAdminGetHashSalt: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportAdminGetHashSalt(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 通过 hash id 批量获取研究报告
         * @param {ResearchreportBatchResearchReportsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportBatchResearchReports: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportBatchResearchReports(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 创建研究报告
         * @param {ResearchreportCreateResearchReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportCreateResearchReport: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportCreateResearchReport(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 删除研究报告
         * @param {string} researchreportHashId 研究报告 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDeleteResearchReport: function (researchreportHashId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportDeleteResearchReport(researchreportHashId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 下线报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDisabledResearchReport: function (researchreportHashId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportDisabledResearchReport(researchreportHashId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 下载文件
         * @param {string} fileUuid 文件 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDownloadFile: function (fileUuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportDownloadFile(fileUuid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 下载研究报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDownloadOriginalResearchReport: function (researchreportHashId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportDownloadOriginalResearchReport(researchreportHashId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary web端下载研究报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {string} [randomString] 图形验证码随机字符串.
         * @param {string} [ticket] 图形验证码ticket.
         * @param {string} [permissionTicket] 权限票据.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDownloadResearchReport: function (researchreportHashId, randomString, ticket, permissionTicket, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportDownloadResearchReport(researchreportHashId, randomString, ticket, permissionTicket, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 小程序端下载研究报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {string} [randomString] 图形验证码随机字符串.
         * @param {string} [ticket] 图形验证码ticket.
         * @param {string} [permissionTicket] 权限票据.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDownloadResearchReportOnMP: function (researchreportHashId, randomString, ticket, permissionTicket, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportDownloadResearchReportOnMP(researchreportHashId, randomString, ticket, permissionTicket, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary GetCollectedUserInfoTicket 留资票据,拿到票据可以前往查阅报告
         * @param {string} reportHashId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetCollectedUserInfoTicket: function (reportHashId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportGetCollectedUserInfoTicket(reportHashId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary GetCollectedUserInfos 分页查看已收集到的用户信息
         * @param {string} reportHashId
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetCollectedUserInfos: function (reportHashId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportGetCollectedUserInfos(reportHashId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取筛选器
         * @param {Array<number>} [firstLevalTagIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetFilter: function (firstLevalTagIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportGetFilter(firstLevalTagIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 移动端：获取预览token
         * @param {string} researchreportHashId 研究报告 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetRRPreviewToken: function (researchreportHashId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportGetRRPreviewToken(researchreportHashId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取空间对我开放的研究报告列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
         * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {number} [teamId] 团队id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetRRsTeamForMe: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, teamId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportGetRRsTeamForMe(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, teamId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary GetRequiredFieldsForContent 获取内容所需的用户信息字段
         * @param {string} reportHashId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetRequiredFieldsForContent: function (reportHashId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportGetRequiredFieldsForContent(reportHashId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取研究报告详情
         * @param {string} researchreportHashId 研究报告ID
         * @param {number} [isEdit] 是否是编辑页.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetResearchReport: function (researchreportHashId, isEdit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportGetResearchReport(researchreportHashId, isEdit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取联合发布者的信息
         * @param {string} researchreportHashId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetResearchReportJointPublisher: function (researchreportHashId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportGetResearchReportJointPublisher(researchreportHashId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取报告公开的归属信息
         * @param {string} researchreportHashId 报告hash id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetResearchReportPublicInfo: function (researchreportHashId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportGetResearchReportPublicInfo(researchreportHashId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取研究报告列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
         * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {number} [mine] 是否获取个人报告 1&#x3D;是，其他&#x3D;否.
         * @param {number} [teamId] 团队id.
         * @param {number} [isHot] 是否获取当前热门报告 1&#x3D;是，其他&#x3D;否.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetResearchReports: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, mine, teamId, isHot, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportGetResearchReports(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, mine, teamId, isHot, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取空间研究报告列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
         * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [userGuid] 用户guid.
         * @param {number} [teamId] 团队id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetSpaceResearchReports: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, userGuid, teamId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportGetSpaceResearchReports(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, userGuid, teamId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取研究报告缩略图
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {number} page 缩略图页码
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetThumbnail: function (researchreportHashId, page, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportGetThumbnail(researchreportHashId, page, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取工作台研究报告列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
         * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {number} [mine] 是否只获取个人报告 1&#x3D;是，其他&#x3D;否，用于团队工作台.
         * @param {number} [teamId] 团队id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetWorkbenchResearchReports: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, mine, teamId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportGetWorkbenchResearchReports(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, mine, teamId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 中断审核
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportInterruptReviwing: function (researchreportHashId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportInterruptReviwing(researchreportHashId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary IsValid 报告id是否是合法的
         * @param {string} researchreportHashId 研究报告ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportIsValid: function (researchreportHashId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportIsValid(researchreportHashId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 预览研究报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {string} [token] 临时 token，移动端H5使用.
         * @param {string} [randomString] 图形验证码随机字符串.
         * @param {string} [ticket] 图形验证码ticket.
         * @param {string} [permissionTicket] 权限票据.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportPreviewResearchReport: function (researchreportHashId, token, randomString, ticket, permissionTicket, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportPreviewResearchReport(researchreportHashId, token, randomString, ticket, permissionTicket, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取推荐研究报告
         * @param {string} [keyword]
         * @param {string} [scene] 场景 all/user/team，默认all.
         * @param {string} [userGuid] scene &#x3D; user 时必填.
         * @param {string} [teamId] scene &#x3D; team 时必填.
         * @param {string} [currentHashId] 当前报告的ID，用来去重.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportRecommendResearchReports: function (keyword, scene, userGuid, teamId, currentHashId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportRecommendResearchReports(keyword, scene, userGuid, teamId, currentHashId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 搜索研究报告
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
         * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [keyword] 搜索关键词.
         * @param {string} [scene] 搜索场景 all/user/team.
         * @param {string} [userGuid] scene &#x3D; user 时必填.
         * @param {string} [teamId] scene &#x3D; team 时必填.
         * @param {boolean} [notRecordKeyword] 不记录搜索词.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportSearchResearchReports: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, keyword, scene, userGuid, teamId, notRecordKeyword, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportSearchResearchReports(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, keyword, scene, userGuid, teamId, notRecordKeyword, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary SetRequiredFieldsForContent 留资,设置报告所需的用户信息字段
         * @param {string} reportHashId
         * @param {ResearchreportSetRequiredFieldsForContentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportSetRequiredFieldsForContent: function (reportHashId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportSetRequiredFieldsForContent(reportHashId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 更新研究报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {ResearchreportUpdateResearchReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportUpdateResearchReport: function (researchreportHashId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportUpdateResearchReport(researchreportHashId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 上传文件
         * @param {ResearchreportUploadFileRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportUploadFile: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportUploadFile(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary ValidateAndSaveUserInfo 留资,验证并保存用户信息
         * @param {string} reportHashId
         * @param {ResearchreportValidateAndSaveUserInfoRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportValidateAndSaveUserInfo: function (reportHashId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.researchReportValidateAndSaveUserInfo(reportHashId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ResearchReportApiFp = ResearchReportApiFp;
/**
 * ResearchReportApi - factory interface
 * @export
 */
var ResearchReportApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ResearchReportApiFp)(configuration);
    return {
        /**
         *
         * @summary 审核报告
         * @param {ResearchreportAdminAuditResearchReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportAdminAuditResearchReport: function (body, options) {
            return localVarFp.researchReportAdminAuditResearchReport(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 下架报告
         * @param {ResearchreportAdminDisabledResearchReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportAdminDisabledResearchReport: function (body, options) {
            return localVarFp.researchReportAdminDisabledResearchReport(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取 id hash salt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportAdminGetHashSalt: function (options) {
            return localVarFp.researchReportAdminGetHashSalt(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 通过 hash id 批量获取研究报告
         * @param {ResearchreportBatchResearchReportsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportBatchResearchReports: function (body, options) {
            return localVarFp.researchReportBatchResearchReports(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 创建研究报告
         * @param {ResearchreportCreateResearchReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportCreateResearchReport: function (body, options) {
            return localVarFp.researchReportCreateResearchReport(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 删除研究报告
         * @param {string} researchreportHashId 研究报告 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDeleteResearchReport: function (researchreportHashId, options) {
            return localVarFp.researchReportDeleteResearchReport(researchreportHashId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 下线报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDisabledResearchReport: function (researchreportHashId, options) {
            return localVarFp.researchReportDisabledResearchReport(researchreportHashId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 下载文件
         * @param {string} fileUuid 文件 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDownloadFile: function (fileUuid, options) {
            return localVarFp.researchReportDownloadFile(fileUuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 下载研究报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDownloadOriginalResearchReport: function (researchreportHashId, options) {
            return localVarFp.researchReportDownloadOriginalResearchReport(researchreportHashId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary web端下载研究报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {string} [randomString] 图形验证码随机字符串.
         * @param {string} [ticket] 图形验证码ticket.
         * @param {string} [permissionTicket] 权限票据.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDownloadResearchReport: function (researchreportHashId, randomString, ticket, permissionTicket, options) {
            return localVarFp.researchReportDownloadResearchReport(researchreportHashId, randomString, ticket, permissionTicket, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 小程序端下载研究报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {string} [randomString] 图形验证码随机字符串.
         * @param {string} [ticket] 图形验证码ticket.
         * @param {string} [permissionTicket] 权限票据.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportDownloadResearchReportOnMP: function (researchreportHashId, randomString, ticket, permissionTicket, options) {
            return localVarFp.researchReportDownloadResearchReportOnMP(researchreportHashId, randomString, ticket, permissionTicket, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary GetCollectedUserInfoTicket 留资票据,拿到票据可以前往查阅报告
         * @param {string} reportHashId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetCollectedUserInfoTicket: function (reportHashId, options) {
            return localVarFp.researchReportGetCollectedUserInfoTicket(reportHashId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary GetCollectedUserInfos 分页查看已收集到的用户信息
         * @param {string} reportHashId
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetCollectedUserInfos: function (reportHashId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return localVarFp.researchReportGetCollectedUserInfos(reportHashId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取筛选器
         * @param {Array<number>} [firstLevalTagIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetFilter: function (firstLevalTagIds, options) {
            return localVarFp.researchReportGetFilter(firstLevalTagIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 移动端：获取预览token
         * @param {string} researchreportHashId 研究报告 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetRRPreviewToken: function (researchreportHashId, options) {
            return localVarFp.researchReportGetRRPreviewToken(researchreportHashId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取空间对我开放的研究报告列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
         * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {number} [teamId] 团队id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetRRsTeamForMe: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, teamId, options) {
            return localVarFp.researchReportGetRRsTeamForMe(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, teamId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary GetRequiredFieldsForContent 获取内容所需的用户信息字段
         * @param {string} reportHashId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetRequiredFieldsForContent: function (reportHashId, options) {
            return localVarFp.researchReportGetRequiredFieldsForContent(reportHashId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取研究报告详情
         * @param {string} researchreportHashId 研究报告ID
         * @param {number} [isEdit] 是否是编辑页.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetResearchReport: function (researchreportHashId, isEdit, options) {
            return localVarFp.researchReportGetResearchReport(researchreportHashId, isEdit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取联合发布者的信息
         * @param {string} researchreportHashId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetResearchReportJointPublisher: function (researchreportHashId, options) {
            return localVarFp.researchReportGetResearchReportJointPublisher(researchreportHashId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取报告公开的归属信息
         * @param {string} researchreportHashId 报告hash id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetResearchReportPublicInfo: function (researchreportHashId, options) {
            return localVarFp.researchReportGetResearchReportPublicInfo(researchreportHashId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取研究报告列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
         * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {number} [mine] 是否获取个人报告 1&#x3D;是，其他&#x3D;否.
         * @param {number} [teamId] 团队id.
         * @param {number} [isHot] 是否获取当前热门报告 1&#x3D;是，其他&#x3D;否.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetResearchReports: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, mine, teamId, isHot, options) {
            return localVarFp.researchReportGetResearchReports(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, mine, teamId, isHot, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取空间研究报告列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
         * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [userGuid] 用户guid.
         * @param {number} [teamId] 团队id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetSpaceResearchReports: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, userGuid, teamId, options) {
            return localVarFp.researchReportGetSpaceResearchReports(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, userGuid, teamId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取研究报告缩略图
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {number} page 缩略图页码
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetThumbnail: function (researchreportHashId, page, options) {
            return localVarFp.researchReportGetThumbnail(researchreportHashId, page, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取工作台研究报告列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
         * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {number} [mine] 是否只获取个人报告 1&#x3D;是，其他&#x3D;否，用于团队工作台.
         * @param {number} [teamId] 团队id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportGetWorkbenchResearchReports: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, mine, teamId, options) {
            return localVarFp.researchReportGetWorkbenchResearchReports(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, mine, teamId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 中断审核
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportInterruptReviwing: function (researchreportHashId, options) {
            return localVarFp.researchReportInterruptReviwing(researchreportHashId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary IsValid 报告id是否是合法的
         * @param {string} researchreportHashId 研究报告ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportIsValid: function (researchreportHashId, options) {
            return localVarFp.researchReportIsValid(researchreportHashId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 预览研究报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {string} [token] 临时 token，移动端H5使用.
         * @param {string} [randomString] 图形验证码随机字符串.
         * @param {string} [ticket] 图形验证码ticket.
         * @param {string} [permissionTicket] 权限票据.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportPreviewResearchReport: function (researchreportHashId, token, randomString, ticket, permissionTicket, options) {
            return localVarFp.researchReportPreviewResearchReport(researchreportHashId, token, randomString, ticket, permissionTicket, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取推荐研究报告
         * @param {string} [keyword]
         * @param {string} [scene] 场景 all/user/team，默认all.
         * @param {string} [userGuid] scene &#x3D; user 时必填.
         * @param {string} [teamId] scene &#x3D; team 时必填.
         * @param {string} [currentHashId] 当前报告的ID，用来去重.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportRecommendResearchReports: function (keyword, scene, userGuid, teamId, currentHashId, options) {
            return localVarFp.researchReportRecommendResearchReports(keyword, scene, userGuid, teamId, currentHashId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 搜索研究报告
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
         * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
         * @param {string} [keyword] 搜索关键词.
         * @param {string} [scene] 搜索场景 all/user/team.
         * @param {string} [userGuid] scene &#x3D; user 时必填.
         * @param {string} [teamId] scene &#x3D; team 时必填.
         * @param {boolean} [notRecordKeyword] 不记录搜索词.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportSearchResearchReports: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, keyword, scene, userGuid, teamId, notRecordKeyword, options) {
            return localVarFp.researchReportSearchResearchReports(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, keyword, scene, userGuid, teamId, notRecordKeyword, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary SetRequiredFieldsForContent 留资,设置报告所需的用户信息字段
         * @param {string} reportHashId
         * @param {ResearchreportSetRequiredFieldsForContentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportSetRequiredFieldsForContent: function (reportHashId, body, options) {
            return localVarFp.researchReportSetRequiredFieldsForContent(reportHashId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 更新研究报告
         * @param {string} researchreportHashId 研究报告 hash id
         * @param {ResearchreportUpdateResearchReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportUpdateResearchReport: function (researchreportHashId, body, options) {
            return localVarFp.researchReportUpdateResearchReport(researchreportHashId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 上传文件
         * @param {ResearchreportUploadFileRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportUploadFile: function (body, options) {
            return localVarFp.researchReportUploadFile(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary ValidateAndSaveUserInfo 留资,验证并保存用户信息
         * @param {string} reportHashId
         * @param {ResearchreportValidateAndSaveUserInfoRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        researchReportValidateAndSaveUserInfo: function (reportHashId, body, options) {
            return localVarFp.researchReportValidateAndSaveUserInfo(reportHashId, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ResearchReportApiFactory = ResearchReportApiFactory;
/**
 * ResearchReportApi - object-oriented interface
 * @export
 * @class ResearchReportApi
 * @extends {BaseAPI}
 */
var ResearchReportApi = /** @class */ (function (_super) {
    __extends(ResearchReportApi, _super);
    function ResearchReportApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 审核报告
     * @param {ResearchreportAdminAuditResearchReportRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportAdminAuditResearchReport = function (body, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportAdminAuditResearchReport(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 下架报告
     * @param {ResearchreportAdminDisabledResearchReportRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportAdminDisabledResearchReport = function (body, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportAdminDisabledResearchReport(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取 id hash salt
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportAdminGetHashSalt = function (options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportAdminGetHashSalt(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 通过 hash id 批量获取研究报告
     * @param {ResearchreportBatchResearchReportsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportBatchResearchReports = function (body, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportBatchResearchReports(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 创建研究报告
     * @param {ResearchreportCreateResearchReportRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportCreateResearchReport = function (body, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportCreateResearchReport(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 删除研究报告
     * @param {string} researchreportHashId 研究报告 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportDeleteResearchReport = function (researchreportHashId, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportDeleteResearchReport(researchreportHashId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 下线报告
     * @param {string} researchreportHashId 研究报告 hash id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportDisabledResearchReport = function (researchreportHashId, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportDisabledResearchReport(researchreportHashId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 下载文件
     * @param {string} fileUuid 文件 uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportDownloadFile = function (fileUuid, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportDownloadFile(fileUuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 下载研究报告
     * @param {string} researchreportHashId 研究报告 hash id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportDownloadOriginalResearchReport = function (researchreportHashId, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportDownloadOriginalResearchReport(researchreportHashId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary web端下载研究报告
     * @param {string} researchreportHashId 研究报告 hash id
     * @param {string} [randomString] 图形验证码随机字符串.
     * @param {string} [ticket] 图形验证码ticket.
     * @param {string} [permissionTicket] 权限票据.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportDownloadResearchReport = function (researchreportHashId, randomString, ticket, permissionTicket, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportDownloadResearchReport(researchreportHashId, randomString, ticket, permissionTicket, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 小程序端下载研究报告
     * @param {string} researchreportHashId 研究报告 hash id
     * @param {string} [randomString] 图形验证码随机字符串.
     * @param {string} [ticket] 图形验证码ticket.
     * @param {string} [permissionTicket] 权限票据.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportDownloadResearchReportOnMP = function (researchreportHashId, randomString, ticket, permissionTicket, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportDownloadResearchReportOnMP(researchreportHashId, randomString, ticket, permissionTicket, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary GetCollectedUserInfoTicket 留资票据,拿到票据可以前往查阅报告
     * @param {string} reportHashId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportGetCollectedUserInfoTicket = function (reportHashId, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportGetCollectedUserInfoTicket(reportHashId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary GetCollectedUserInfos 分页查看已收集到的用户信息
     * @param {string} reportHashId
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportGetCollectedUserInfos = function (reportHashId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportGetCollectedUserInfos(reportHashId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取筛选器
     * @param {Array<number>} [firstLevalTagIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportGetFilter = function (firstLevalTagIds, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportGetFilter(firstLevalTagIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 移动端：获取预览token
     * @param {string} researchreportHashId 研究报告 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportGetRRPreviewToken = function (researchreportHashId, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportGetRRPreviewToken(researchreportHashId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取空间对我开放的研究报告列表
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
     * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {number} [teamId] 团队id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportGetRRsTeamForMe = function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, teamId, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportGetRRsTeamForMe(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, teamId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary GetRequiredFieldsForContent 获取内容所需的用户信息字段
     * @param {string} reportHashId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportGetRequiredFieldsForContent = function (reportHashId, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportGetRequiredFieldsForContent(reportHashId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取研究报告详情
     * @param {string} researchreportHashId 研究报告ID
     * @param {number} [isEdit] 是否是编辑页.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportGetResearchReport = function (researchreportHashId, isEdit, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportGetResearchReport(researchreportHashId, isEdit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取联合发布者的信息
     * @param {string} researchreportHashId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportGetResearchReportJointPublisher = function (researchreportHashId, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportGetResearchReportJointPublisher(researchreportHashId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取报告公开的归属信息
     * @param {string} researchreportHashId 报告hash id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportGetResearchReportPublicInfo = function (researchreportHashId, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportGetResearchReportPublicInfo(researchreportHashId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取研究报告列表
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
     * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {number} [mine] 是否获取个人报告 1&#x3D;是，其他&#x3D;否.
     * @param {number} [teamId] 团队id.
     * @param {number} [isHot] 是否获取当前热门报告 1&#x3D;是，其他&#x3D;否.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportGetResearchReports = function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, mine, teamId, isHot, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportGetResearchReports(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, mine, teamId, isHot, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取空间研究报告列表
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
     * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [userGuid] 用户guid.
     * @param {number} [teamId] 团队id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportGetSpaceResearchReports = function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, userGuid, teamId, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportGetSpaceResearchReports(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, userGuid, teamId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取研究报告缩略图
     * @param {string} researchreportHashId 研究报告 hash id
     * @param {number} page 缩略图页码
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportGetThumbnail = function (researchreportHashId, page, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportGetThumbnail(researchreportHashId, page, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取工作台研究报告列表
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
     * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {number} [mine] 是否只获取个人报告 1&#x3D;是，其他&#x3D;否，用于团队工作台.
     * @param {number} [teamId] 团队id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportGetWorkbenchResearchReports = function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, mine, teamId, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportGetWorkbenchResearchReports(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, mine, teamId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 中断审核
     * @param {string} researchreportHashId 研究报告 hash id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportInterruptReviwing = function (researchreportHashId, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportInterruptReviwing(researchreportHashId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary IsValid 报告id是否是合法的
     * @param {string} researchreportHashId 研究报告ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportIsValid = function (researchreportHashId, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportIsValid(researchreportHashId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 预览研究报告
     * @param {string} researchreportHashId 研究报告 hash id
     * @param {string} [token] 临时 token，移动端H5使用.
     * @param {string} [randomString] 图形验证码随机字符串.
     * @param {string} [ticket] 图形验证码ticket.
     * @param {string} [permissionTicket] 权限票据.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportPreviewResearchReport = function (researchreportHashId, token, randomString, ticket, permissionTicket, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportPreviewResearchReport(researchreportHashId, token, randomString, ticket, permissionTicket, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取推荐研究报告
     * @param {string} [keyword]
     * @param {string} [scene] 场景 all/user/team，默认all.
     * @param {string} [userGuid] scene &#x3D; user 时必填.
     * @param {string} [teamId] scene &#x3D; team 时必填.
     * @param {string} [currentHashId] 当前报告的ID，用来去重.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportRecommendResearchReports = function (keyword, scene, userGuid, teamId, currentHashId, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportRecommendResearchReports(keyword, scene, userGuid, teamId, currentHashId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 搜索研究报告
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {string} [orderBy] 排序,可选值 default/researched_at/view/comment/collect/created_at/updated_at.
     * @param {string} [area] 行业标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [source] 来源标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [reportType] 报告类型标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [researchMethod] 研究方法标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [crowd] 人群标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [custom] 自定义标签筛选 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [time] 年份筛选器 字符串类型，英文逗号分割开的 filter id，例：\&quot;5,7,42\&quot;.
     * @param {string} [keyword] 搜索关键词.
     * @param {string} [scene] 搜索场景 all/user/team.
     * @param {string} [userGuid] scene &#x3D; user 时必填.
     * @param {string} [teamId] scene &#x3D; team 时必填.
     * @param {boolean} [notRecordKeyword] 不记录搜索词.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportSearchResearchReports = function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, keyword, scene, userGuid, teamId, notRecordKeyword, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportSearchResearchReports(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, area, source, reportType, researchMethod, crowd, custom, time, keyword, scene, userGuid, teamId, notRecordKeyword, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary SetRequiredFieldsForContent 留资,设置报告所需的用户信息字段
     * @param {string} reportHashId
     * @param {ResearchreportSetRequiredFieldsForContentRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportSetRequiredFieldsForContent = function (reportHashId, body, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportSetRequiredFieldsForContent(reportHashId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 更新研究报告
     * @param {string} researchreportHashId 研究报告 hash id
     * @param {ResearchreportUpdateResearchReportRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportUpdateResearchReport = function (researchreportHashId, body, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportUpdateResearchReport(researchreportHashId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 上传文件
     * @param {ResearchreportUploadFileRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportUploadFile = function (body, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportUploadFile(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary ValidateAndSaveUserInfo 留资,验证并保存用户信息
     * @param {string} reportHashId
     * @param {ResearchreportValidateAndSaveUserInfoRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResearchReportApi
     */
    ResearchReportApi.prototype.researchReportValidateAndSaveUserInfo = function (reportHashId, body, options) {
        var _this = this;
        return (0, exports.ResearchReportApiFp)(this.configuration).researchReportValidateAndSaveUserInfo(reportHashId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ResearchReportApi;
}(base_1.BaseAPI));
exports.ResearchReportApi = ResearchReportApi;
/**
 * SampleServiceApi - axios parameter creator
 * @export
 */
var SampleServiceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {SampleSearchTagCodeFilter} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sampleServiceSearchByTagCode: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('sampleServiceSearchByTagCode', 'body', body);
                    localVarPath = "/disable/sample/search/tag_code";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {SampleSearchTagIdFilter} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sampleServiceSearchByTagId: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('sampleServiceSearchByTagId', 'body', body);
                    localVarPath = "/disable/sample/search/tag_id";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {SampleSearchTagValueFilter} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sampleServiceSearchByTagValue: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('sampleServiceSearchByTagValue', 'body', body);
                    localVarPath = "/disable/sample/search/tag_value";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {SampleUpdateSampleMetricParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sampleServiceUpdateSampleMetric: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('sampleServiceUpdateSampleMetric', 'body', body);
                    localVarPath = "/disable/sample/update/metric";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SampleServiceApiAxiosParamCreator = SampleServiceApiAxiosParamCreator;
/**
 * SampleServiceApi - functional programming interface
 * @export
 */
var SampleServiceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SampleServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {SampleSearchTagCodeFilter} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sampleServiceSearchByTagCode: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sampleServiceSearchByTagCode(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {SampleSearchTagIdFilter} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sampleServiceSearchByTagId: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sampleServiceSearchByTagId(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {SampleSearchTagValueFilter} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sampleServiceSearchByTagValue: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sampleServiceSearchByTagValue(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {SampleUpdateSampleMetricParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sampleServiceUpdateSampleMetric: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sampleServiceUpdateSampleMetric(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SampleServiceApiFp = SampleServiceApiFp;
/**
 * SampleServiceApi - factory interface
 * @export
 */
var SampleServiceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SampleServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {SampleSearchTagCodeFilter} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sampleServiceSearchByTagCode: function (body, options) {
            return localVarFp.sampleServiceSearchByTagCode(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {SampleSearchTagIdFilter} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sampleServiceSearchByTagId: function (body, options) {
            return localVarFp.sampleServiceSearchByTagId(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {SampleSearchTagValueFilter} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sampleServiceSearchByTagValue: function (body, options) {
            return localVarFp.sampleServiceSearchByTagValue(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {SampleUpdateSampleMetricParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sampleServiceUpdateSampleMetric: function (body, options) {
            return localVarFp.sampleServiceUpdateSampleMetric(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SampleServiceApiFactory = SampleServiceApiFactory;
/**
 * SampleServiceApi - object-oriented interface
 * @export
 * @class SampleServiceApi
 * @extends {BaseAPI}
 */
var SampleServiceApi = /** @class */ (function (_super) {
    __extends(SampleServiceApi, _super);
    function SampleServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {SampleSearchTagCodeFilter} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SampleServiceApi
     */
    SampleServiceApi.prototype.sampleServiceSearchByTagCode = function (body, options) {
        var _this = this;
        return (0, exports.SampleServiceApiFp)(this.configuration).sampleServiceSearchByTagCode(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {SampleSearchTagIdFilter} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SampleServiceApi
     */
    SampleServiceApi.prototype.sampleServiceSearchByTagId = function (body, options) {
        var _this = this;
        return (0, exports.SampleServiceApiFp)(this.configuration).sampleServiceSearchByTagId(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {SampleSearchTagValueFilter} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SampleServiceApi
     */
    SampleServiceApi.prototype.sampleServiceSearchByTagValue = function (body, options) {
        var _this = this;
        return (0, exports.SampleServiceApiFp)(this.configuration).sampleServiceSearchByTagValue(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {SampleUpdateSampleMetricParams} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SampleServiceApi
     */
    SampleServiceApi.prototype.sampleServiceUpdateSampleMetric = function (body, options) {
        var _this = this;
        return (0, exports.SampleServiceApiFp)(this.configuration).sampleServiceUpdateSampleMetric(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SampleServiceApi;
}(base_1.BaseAPI));
exports.SampleServiceApi = SampleServiceApi;
/**
 * SearchApi - axios parameter creator
 * @export
 */
var SearchApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 管理后台搜索
         * @param {SearchDashboardRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDashboard: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('searchDashboard', 'body', body);
                    localVarPath = "/api/micro/txc/search/dashboard";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 查询搜索历史
         * @param {SearchHistoryRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchHistory: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('searchHistory', 'body', body);
                    localVarPath = "/api/micro/txc/search/history";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 查询热搜
         * @param {SearchHotRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchHot: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('searchHot', 'body', body);
                    localVarPath = "/api/micro/txc/search/hot";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 联想、补全
         * @param {SearchSuggestRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSuggest: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('searchSuggest', 'body', body);
                    localVarPath = "/api/micro/txc/search/suggest";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 用户侧搜索
         * @param {SearchUserRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('searchUser', 'body', body);
                    localVarPath = "/api/micro/txc/search/user";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SearchApiAxiosParamCreator = SearchApiAxiosParamCreator;
/**
 * SearchApi - functional programming interface
 * @export
 */
var SearchApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SearchApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 管理后台搜索
         * @param {SearchDashboardRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDashboard: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchDashboard(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 查询搜索历史
         * @param {SearchHistoryRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchHistory: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchHistory(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 查询热搜
         * @param {SearchHotRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchHot: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchHot(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 联想、补全
         * @param {SearchSuggestRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSuggest: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchSuggest(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 用户侧搜索
         * @param {SearchUserRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchUser(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SearchApiFp = SearchApiFp;
/**
 * SearchApi - factory interface
 * @export
 */
var SearchApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SearchApiFp)(configuration);
    return {
        /**
         *
         * @summary 管理后台搜索
         * @param {SearchDashboardRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDashboard: function (body, options) {
            return localVarFp.searchDashboard(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 查询搜索历史
         * @param {SearchHistoryRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchHistory: function (body, options) {
            return localVarFp.searchHistory(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 查询热搜
         * @param {SearchHotRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchHot: function (body, options) {
            return localVarFp.searchHot(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 联想、补全
         * @param {SearchSuggestRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSuggest: function (body, options) {
            return localVarFp.searchSuggest(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 用户侧搜索
         * @param {SearchUserRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser: function (body, options) {
            return localVarFp.searchUser(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SearchApiFactory = SearchApiFactory;
/**
 * SearchApi - object-oriented interface
 * @export
 * @class SearchApi
 * @extends {BaseAPI}
 */
var SearchApi = /** @class */ (function (_super) {
    __extends(SearchApi, _super);
    function SearchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 管理后台搜索
     * @param {SearchDashboardRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    SearchApi.prototype.searchDashboard = function (body, options) {
        var _this = this;
        return (0, exports.SearchApiFp)(this.configuration).searchDashboard(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 查询搜索历史
     * @param {SearchHistoryRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    SearchApi.prototype.searchHistory = function (body, options) {
        var _this = this;
        return (0, exports.SearchApiFp)(this.configuration).searchHistory(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 查询热搜
     * @param {SearchHotRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    SearchApi.prototype.searchHot = function (body, options) {
        var _this = this;
        return (0, exports.SearchApiFp)(this.configuration).searchHot(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 联想、补全
     * @param {SearchSuggestRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    SearchApi.prototype.searchSuggest = function (body, options) {
        var _this = this;
        return (0, exports.SearchApiFp)(this.configuration).searchSuggest(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 用户侧搜索
     * @param {SearchUserRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    SearchApi.prototype.searchUser = function (body, options) {
        var _this = this;
        return (0, exports.SearchApiFp)(this.configuration).searchUser(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SearchApi;
}(base_1.BaseAPI));
exports.SearchApi = SearchApi;
/**
 * ShortLinkApi - axios parameter creator
 * @export
 */
var ShortLinkApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 绑定短网址 替换短网址绑定的长网址
         * @param {ShortlinkBindRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkBind: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('shortLinkBind', 'body', body);
                    localVarPath = "/disable/shortlink/bind";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 新建短网址
         * @param {ShortlinkCreateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkCreate: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('shortLinkCreate', 'body', body);
                    localVarPath = "/disable/shortlink/create";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 批量新建短网址
         * @param {ShortlinkCreateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkCreateBatch: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('shortLinkCreateBatch', 'body', body);
                    localVarPath = "/disable/shortlink/create_batch";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 解除短网址绑定
         * @param {ShortlinkFreeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkFree: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('shortLinkFree', 'body', body);
                    localVarPath = "/disable/shortlink/free";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 查询短网址信息
         * @param {ShortlinkInspectRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkInspect: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('shortLinkInspect', 'body', body);
                    localVarPath = "/disable/shortlink/inspect";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 重定向
         * @param {string} linkPath 重定向路径
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkRedirect: function (linkPath, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'linkPath' is not null or undefined
                    (0, common_1.assertParamExists)('shortLinkRedirect', 'linkPath', linkPath);
                    localVarPath = "/{linkPath}"
                        .replace("{".concat("linkPath", "}"), encodeURIComponent(String(linkPath)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ShortLinkApiAxiosParamCreator = ShortLinkApiAxiosParamCreator;
/**
 * ShortLinkApi - functional programming interface
 * @export
 */
var ShortLinkApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShortLinkApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 绑定短网址 替换短网址绑定的长网址
         * @param {ShortlinkBindRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkBind: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shortLinkBind(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 新建短网址
         * @param {ShortlinkCreateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkCreate: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shortLinkCreate(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 批量新建短网址
         * @param {ShortlinkCreateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkCreateBatch: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shortLinkCreateBatch(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 解除短网址绑定
         * @param {ShortlinkFreeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkFree: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shortLinkFree(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 查询短网址信息
         * @param {ShortlinkInspectRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkInspect: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shortLinkInspect(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 重定向
         * @param {string} linkPath 重定向路径
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkRedirect: function (linkPath, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shortLinkRedirect(linkPath, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ShortLinkApiFp = ShortLinkApiFp;
/**
 * ShortLinkApi - factory interface
 * @export
 */
var ShortLinkApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShortLinkApiFp)(configuration);
    return {
        /**
         *
         * @summary 绑定短网址 替换短网址绑定的长网址
         * @param {ShortlinkBindRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkBind: function (body, options) {
            return localVarFp.shortLinkBind(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 新建短网址
         * @param {ShortlinkCreateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkCreate: function (body, options) {
            return localVarFp.shortLinkCreate(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 批量新建短网址
         * @param {ShortlinkCreateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkCreateBatch: function (body, options) {
            return localVarFp.shortLinkCreateBatch(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 解除短网址绑定
         * @param {ShortlinkFreeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkFree: function (body, options) {
            return localVarFp.shortLinkFree(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 查询短网址信息
         * @param {ShortlinkInspectRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkInspect: function (body, options) {
            return localVarFp.shortLinkInspect(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 重定向
         * @param {string} linkPath 重定向路径
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortLinkRedirect: function (linkPath, options) {
            return localVarFp.shortLinkRedirect(linkPath, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShortLinkApiFactory = ShortLinkApiFactory;
/**
 * ShortLinkApi - object-oriented interface
 * @export
 * @class ShortLinkApi
 * @extends {BaseAPI}
 */
var ShortLinkApi = /** @class */ (function (_super) {
    __extends(ShortLinkApi, _super);
    function ShortLinkApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 绑定短网址 替换短网址绑定的长网址
     * @param {ShortlinkBindRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShortLinkApi
     */
    ShortLinkApi.prototype.shortLinkBind = function (body, options) {
        var _this = this;
        return (0, exports.ShortLinkApiFp)(this.configuration).shortLinkBind(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 新建短网址
     * @param {ShortlinkCreateRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShortLinkApi
     */
    ShortLinkApi.prototype.shortLinkCreate = function (body, options) {
        var _this = this;
        return (0, exports.ShortLinkApiFp)(this.configuration).shortLinkCreate(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 批量新建短网址
     * @param {ShortlinkCreateRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShortLinkApi
     */
    ShortLinkApi.prototype.shortLinkCreateBatch = function (body, options) {
        var _this = this;
        return (0, exports.ShortLinkApiFp)(this.configuration).shortLinkCreateBatch(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 解除短网址绑定
     * @param {ShortlinkFreeRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShortLinkApi
     */
    ShortLinkApi.prototype.shortLinkFree = function (body, options) {
        var _this = this;
        return (0, exports.ShortLinkApiFp)(this.configuration).shortLinkFree(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 查询短网址信息
     * @param {ShortlinkInspectRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShortLinkApi
     */
    ShortLinkApi.prototype.shortLinkInspect = function (body, options) {
        var _this = this;
        return (0, exports.ShortLinkApiFp)(this.configuration).shortLinkInspect(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 重定向
     * @param {string} linkPath 重定向路径
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShortLinkApi
     */
    ShortLinkApi.prototype.shortLinkRedirect = function (linkPath, options) {
        var _this = this;
        return (0, exports.ShortLinkApiFp)(this.configuration).shortLinkRedirect(linkPath, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShortLinkApi;
}(base_1.BaseAPI));
exports.ShortLinkApi = ShortLinkApi;
/**
 * SpaceApi - axios parameter creator
 * @export
 */
var SpaceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 管理员查看用户是否关注了这些空间
         * @param {SpaceAdmindGetUserIsFollowedReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceAdmindGetUserIsFollowed: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('spaceAdmindGetUserIsFollowed', 'body', body);
                    localVarPath = "/admin/api/space/spaces/isfollowed";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 修改自定义标签
         * @param {number} teamId
         * @param {SpaceAlterCustomTagsReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceAlterCustomTags: function (teamId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('spaceAlterCustomTags', 'teamId', teamId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('spaceAlterCustomTags', 'body', body);
                    localVarPath = "/api/space/{teamId}/customtags"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 修改空间展示的官方标签
         * @param {number} teamId
         * @param {SpaceAlterOfficialTagsReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceAlterOfficialTags: function (teamId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('spaceAlterOfficialTags', 'teamId', teamId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('spaceAlterOfficialTags', 'body', body);
                    localVarPath = "/api/space/{teamId}/officialtags"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取指定空间信息
         * @param {SpaceBatchGetSpacesReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceBatchGetSpaces: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('spaceBatchGetSpaces', 'body', body);
                    localVarPath = "/api/space/batch/spaces";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 添加每周精选 - 发现页
         * @param {SpaceCreateChoicenessesReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceCreateChoicenesses: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('spaceCreateChoicenesses', 'body', body);
                    localVarPath = "/admin/api/space/choicenesses";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 添加空间推荐 - 空间推荐页
         * @param {SpaceCreateEditorsRecommendSpaceReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceCreateEditorsRecommendSpace: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('spaceCreateEditorsRecommendSpace', 'body', body);
                    localVarPath = "/admin/api/space/editorsrecommend/spaces";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 添加空间推荐 - 发现页
         * @param {SpaceCreateRecommendSpaceRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceCreateRecommendSpace: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('spaceCreateRecommendSpace', 'body', body);
                    localVarPath = "/admin/api/space/recommend/spaces";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 删除每周精选 - 发现页
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceDeleteChoicenesses: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/api/space/choicenesses";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 删除空间推荐 - 空间推荐页
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceDeleteEditorsRecommendSpace: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/api/space/editorsrecommend/spaces";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 删除空间推荐 - 发现页
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceDeleteRecommendSpace: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/api/space/recommend/spaces";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 关注
         * @param {SpaceFollowReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceFollow: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('spaceFollow', 'body', body);
                    localVarPath = "/api/space/follow";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 关注者列表
         * @param {'USER' | 'TEAM'} [idKind]  - USER: 个人空间  - TEAM: 团队空间
         * @param {string} [idId]
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceFollowerList: function (idKind, idId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/space/followers";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (idKind !== undefined) {
                        localVarQueryParameter['id.kind'] = idKind;
                    }
                    if (idId !== undefined) {
                        localVarQueryParameter['id.id'] = idId;
                    }
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取每周精选
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {string} [startDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetChoicenesses: function (app, startDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/space/choicenesses";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (app !== undefined) {
                        localVarQueryParameter['app'] = app;
                    }
                    if (startDate !== undefined) {
                        localVarQueryParameter['startDate'] = startDate;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取空间的自定义标签
         * @param {number} teamId
         * @param {'UNKNOW' | 'ResearchReport' | 'Article'} [objectType]  - ResearchReport: 报告  - Article: 文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {Array<number>} [tagIds] 加上支持部分标签.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetCustomTagsBySpace: function (teamId, objectType, app, tagIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('spaceGetCustomTagsBySpace', 'teamId', teamId);
                    localVarPath = "/api/space/{teamId}/customtags"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (objectType !== undefined) {
                        localVarQueryParameter['objectType'] = objectType;
                    }
                    if (app !== undefined) {
                        localVarQueryParameter['app'] = app;
                    }
                    if (tagIds) {
                        localVarQueryParameter['tagIds'] = tagIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取小编推荐-空间首页
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetEditorsRecommendSpace: function (app, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/space/editorsrecommend/spaces";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (app !== undefined) {
                        localVarQueryParameter['app'] = app;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取我的关注列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetFollowedSpaceList: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, app, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/space/followed/spaces";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (app !== undefined) {
                        localVarQueryParameter['app'] = app;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取空间推荐-发现页
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetRecommendSpace: function (app, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/space/recommend/spaces";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (app !== undefined) {
                        localVarQueryParameter['app'] = app;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取调研云团队空间信息
         * @param {number} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetResearchTeamSpace: function (teamId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('spaceGetResearchTeamSpace', 'teamId', teamId);
                    localVarPath = "/api/space/research/team/{teamId}"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取调研云个人空间信息
         * @param {string} userGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetResearchUserSpace: function (userGuid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'userGuid' is not null or undefined
                    (0, common_1.assertParamExists)('spaceGetResearchUserSpace', 'userGuid', userGuid);
                    localVarPath = "/api/space/research/user/{userGuid}"
                        .replace("{".concat("userGuid", "}"), encodeURIComponent(String(userGuid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取空间列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {'Invalid' | 'Overall' | 'Works' | 'Popularity' | 'Latest' | 'PopularityIncrease' | 'ReadIncrease'} [orderBy] 排序.   - Overall: 综合  - Works: 作品数  - Popularity: 人气  - Latest: 最近更新  - PopularityIncrease: 人气上升  - ReadIncrease: 阅读上升
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetSpaces: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, app, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/space/spaces";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (app !== undefined) {
                        localVarQueryParameter['app'] = app;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取空间的所有标签
         * @param {number} teamId
         * @param {'UNKNOW' | 'ResearchReport' | 'Article'} [objectType]  - ResearchReport: 报告  - Article: 文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetTagsBySpace: function (teamId, objectType, app, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'teamId' is not null or undefined
                    (0, common_1.assertParamExists)('spaceGetTagsBySpace', 'teamId', teamId);
                    localVarPath = "/api/space/{teamId}/tags"
                        .replace("{".concat("teamId", "}"), encodeURIComponent(String(teamId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (objectType !== undefined) {
                        localVarQueryParameter['objectType'] = objectType;
                    }
                    if (app !== undefined) {
                        localVarQueryParameter['app'] = app;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取用户所在团队的空间列表
         * @param {string} userGuid 用户id
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetTeamSpacesByUser: function (userGuid, paginationPage, paginationSize, paginationHasMore, paginationTotal, app, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'userGuid' is not null or undefined
                    (0, common_1.assertParamExists)('spaceGetTeamSpacesByUser', 'userGuid', userGuid);
                    localVarPath = "/api/space/{userGuid}/teamspaces"
                        .replace("{".concat("userGuid", "}"), encodeURIComponent(String(userGuid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (app !== undefined) {
                        localVarQueryParameter['app'] = app;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 用户是否关注了这些空间
         * @param {SpaceIsFollowedReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceIsFollowed: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('spaceIsFollowed', 'body', body);
                    localVarPath = "/api/space/spaces/isfollowed";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 移除关注者
         * @param {string} guid 关注者的guid
         * @param {'USER' | 'TEAM'} [idKind]  - USER: 个人空间  - TEAM: 团队空间
         * @param {string} [idId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceRemoveFollower: function (guid, idKind, idId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'guid' is not null or undefined
                    (0, common_1.assertParamExists)('spaceRemoveFollower', 'guid', guid);
                    localVarPath = "/api/space/followers/{guid}"
                        .replace("{".concat("guid", "}"), encodeURIComponent(String(guid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (idKind !== undefined) {
                        localVarQueryParameter['id.kind'] = idKind;
                    }
                    if (idId !== undefined) {
                        localVarQueryParameter['id.id'] = idId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [appType] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'Invalid' | 'Overall' | 'Works' | 'Popularity' | 'Latest' | 'PopularityIncrease' | 'ReadIncrease'} [orderBy] 排序类型.   - Overall: 综合  - Works: 作品数  - Popularity: 人气  - Latest: 最近更新  - PopularityIncrease: 人气上升  - ReadIncrease: 阅读上升
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {string} [keyword] 搜索关键词.
         * @param {boolean} [notRecordKeyword] 不记录搜索词.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceSearchSpaces: function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, keyword, notRecordKeyword, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/space/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (appType !== undefined) {
                        localVarQueryParameter['appType'] = appType;
                    }
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    if (keyword !== undefined) {
                        localVarQueryParameter['keyword'] = keyword;
                    }
                    if (notRecordKeyword !== undefined) {
                        localVarQueryParameter['notRecordKeyword'] = notRecordKeyword;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 取消关注
         * @param {SpaceUnFollowReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUnFollow: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('spaceUnFollow', 'body', body);
                    localVarPath = "/api/space/unfollow";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 更新每周精选 - 发现页
         * @param {SpaceUpdateChoicenessesReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateChoicenesses: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('spaceUpdateChoicenesses', 'body', body);
                    localVarPath = "/admin/api/space/choicenesses";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 更新空间推荐 - 空间推荐页
         * @param {SpaceUpdateEditorsRecommendSpaceReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateEditorsRecommendSpace: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('spaceUpdateEditorsRecommendSpace', 'body', body);
                    localVarPath = "/admin/api/space/editorsrecommend/spaces";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 批量更新用户空间项
         * @param {SpaceUpdateOrCreateItemsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateOrCreateItems: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('spaceUpdateOrCreateItems', 'body', body);
                    localVarPath = "/disable/space/research/user/items";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 更新空间推荐 - 发现页
         * @param {SpaceUpdateRecommendSpaceReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateRecommendSpace: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('spaceUpdateRecommendSpace', 'body', body);
                    localVarPath = "/admin/api/space/recommend/spaces";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 更新团队空间项的内容
         * @param {SpaceUpdateResearchTeamSpaceRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateResearchTeamSpace: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('spaceUpdateResearchTeamSpace', 'body', body);
                    localVarPath = "/api/space/research/team/items";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 更新用户空间项的内容
         * @param {SpaceUpdateResearchUserSpaceRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateResearchUserSpace: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('spaceUpdateResearchUserSpace', 'body', body);
                    localVarPath = "/api/space/research/user/items";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取最近浏览
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceViewHistory: function (app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/space/view/history";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (app !== undefined) {
                        localVarQueryParameter['app'] = app;
                    }
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SpaceApiAxiosParamCreator = SpaceApiAxiosParamCreator;
/**
 * SpaceApi - functional programming interface
 * @export
 */
var SpaceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SpaceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 管理员查看用户是否关注了这些空间
         * @param {SpaceAdmindGetUserIsFollowedReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceAdmindGetUserIsFollowed: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceAdmindGetUserIsFollowed(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 修改自定义标签
         * @param {number} teamId
         * @param {SpaceAlterCustomTagsReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceAlterCustomTags: function (teamId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceAlterCustomTags(teamId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 修改空间展示的官方标签
         * @param {number} teamId
         * @param {SpaceAlterOfficialTagsReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceAlterOfficialTags: function (teamId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceAlterOfficialTags(teamId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取指定空间信息
         * @param {SpaceBatchGetSpacesReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceBatchGetSpaces: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceBatchGetSpaces(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 添加每周精选 - 发现页
         * @param {SpaceCreateChoicenessesReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceCreateChoicenesses: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceCreateChoicenesses(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 添加空间推荐 - 空间推荐页
         * @param {SpaceCreateEditorsRecommendSpaceReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceCreateEditorsRecommendSpace: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceCreateEditorsRecommendSpace(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 添加空间推荐 - 发现页
         * @param {SpaceCreateRecommendSpaceRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceCreateRecommendSpace: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceCreateRecommendSpace(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 删除每周精选 - 发现页
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceDeleteChoicenesses: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceDeleteChoicenesses(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 删除空间推荐 - 空间推荐页
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceDeleteEditorsRecommendSpace: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceDeleteEditorsRecommendSpace(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 删除空间推荐 - 发现页
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceDeleteRecommendSpace: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceDeleteRecommendSpace(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 关注
         * @param {SpaceFollowReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceFollow: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceFollow(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 关注者列表
         * @param {'USER' | 'TEAM'} [idKind]  - USER: 个人空间  - TEAM: 团队空间
         * @param {string} [idId]
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceFollowerList: function (idKind, idId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceFollowerList(idKind, idId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取每周精选
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {string} [startDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetChoicenesses: function (app, startDate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceGetChoicenesses(app, startDate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取空间的自定义标签
         * @param {number} teamId
         * @param {'UNKNOW' | 'ResearchReport' | 'Article'} [objectType]  - ResearchReport: 报告  - Article: 文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {Array<number>} [tagIds] 加上支持部分标签.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetCustomTagsBySpace: function (teamId, objectType, app, tagIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceGetCustomTagsBySpace(teamId, objectType, app, tagIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取小编推荐-空间首页
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetEditorsRecommendSpace: function (app, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceGetEditorsRecommendSpace(app, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取我的关注列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetFollowedSpaceList: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, app, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceGetFollowedSpaceList(paginationPage, paginationSize, paginationHasMore, paginationTotal, app, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取空间推荐-发现页
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetRecommendSpace: function (app, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceGetRecommendSpace(app, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取调研云团队空间信息
         * @param {number} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetResearchTeamSpace: function (teamId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceGetResearchTeamSpace(teamId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取调研云个人空间信息
         * @param {string} userGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetResearchUserSpace: function (userGuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceGetResearchUserSpace(userGuid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取空间列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {'Invalid' | 'Overall' | 'Works' | 'Popularity' | 'Latest' | 'PopularityIncrease' | 'ReadIncrease'} [orderBy] 排序.   - Overall: 综合  - Works: 作品数  - Popularity: 人气  - Latest: 最近更新  - PopularityIncrease: 人气上升  - ReadIncrease: 阅读上升
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetSpaces: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, app, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceGetSpaces(paginationPage, paginationSize, paginationHasMore, paginationTotal, app, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取空间的所有标签
         * @param {number} teamId
         * @param {'UNKNOW' | 'ResearchReport' | 'Article'} [objectType]  - ResearchReport: 报告  - Article: 文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetTagsBySpace: function (teamId, objectType, app, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceGetTagsBySpace(teamId, objectType, app, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取用户所在团队的空间列表
         * @param {string} userGuid 用户id
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetTeamSpacesByUser: function (userGuid, paginationPage, paginationSize, paginationHasMore, paginationTotal, app, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceGetTeamSpacesByUser(userGuid, paginationPage, paginationSize, paginationHasMore, paginationTotal, app, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 用户是否关注了这些空间
         * @param {SpaceIsFollowedReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceIsFollowed: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceIsFollowed(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 移除关注者
         * @param {string} guid 关注者的guid
         * @param {'USER' | 'TEAM'} [idKind]  - USER: 个人空间  - TEAM: 团队空间
         * @param {string} [idId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceRemoveFollower: function (guid, idKind, idId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceRemoveFollower(guid, idKind, idId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [appType] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'Invalid' | 'Overall' | 'Works' | 'Popularity' | 'Latest' | 'PopularityIncrease' | 'ReadIncrease'} [orderBy] 排序类型.   - Overall: 综合  - Works: 作品数  - Popularity: 人气  - Latest: 最近更新  - PopularityIncrease: 人气上升  - ReadIncrease: 阅读上升
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {string} [keyword] 搜索关键词.
         * @param {boolean} [notRecordKeyword] 不记录搜索词.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceSearchSpaces: function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, keyword, notRecordKeyword, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceSearchSpaces(appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, keyword, notRecordKeyword, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 取消关注
         * @param {SpaceUnFollowReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUnFollow: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceUnFollow(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 更新每周精选 - 发现页
         * @param {SpaceUpdateChoicenessesReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateChoicenesses: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceUpdateChoicenesses(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 更新空间推荐 - 空间推荐页
         * @param {SpaceUpdateEditorsRecommendSpaceReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateEditorsRecommendSpace: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceUpdateEditorsRecommendSpace(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 批量更新用户空间项
         * @param {SpaceUpdateOrCreateItemsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateOrCreateItems: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceUpdateOrCreateItems(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 更新空间推荐 - 发现页
         * @param {SpaceUpdateRecommendSpaceReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateRecommendSpace: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceUpdateRecommendSpace(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 更新团队空间项的内容
         * @param {SpaceUpdateResearchTeamSpaceRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateResearchTeamSpace: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceUpdateResearchTeamSpace(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 更新用户空间项的内容
         * @param {SpaceUpdateResearchUserSpaceRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateResearchUserSpace: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceUpdateResearchUserSpace(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取最近浏览
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceViewHistory: function (app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.spaceViewHistory(app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SpaceApiFp = SpaceApiFp;
/**
 * SpaceApi - factory interface
 * @export
 */
var SpaceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SpaceApiFp)(configuration);
    return {
        /**
         *
         * @summary 管理员查看用户是否关注了这些空间
         * @param {SpaceAdmindGetUserIsFollowedReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceAdmindGetUserIsFollowed: function (body, options) {
            return localVarFp.spaceAdmindGetUserIsFollowed(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 修改自定义标签
         * @param {number} teamId
         * @param {SpaceAlterCustomTagsReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceAlterCustomTags: function (teamId, body, options) {
            return localVarFp.spaceAlterCustomTags(teamId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 修改空间展示的官方标签
         * @param {number} teamId
         * @param {SpaceAlterOfficialTagsReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceAlterOfficialTags: function (teamId, body, options) {
            return localVarFp.spaceAlterOfficialTags(teamId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取指定空间信息
         * @param {SpaceBatchGetSpacesReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceBatchGetSpaces: function (body, options) {
            return localVarFp.spaceBatchGetSpaces(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 添加每周精选 - 发现页
         * @param {SpaceCreateChoicenessesReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceCreateChoicenesses: function (body, options) {
            return localVarFp.spaceCreateChoicenesses(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 添加空间推荐 - 空间推荐页
         * @param {SpaceCreateEditorsRecommendSpaceReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceCreateEditorsRecommendSpace: function (body, options) {
            return localVarFp.spaceCreateEditorsRecommendSpace(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 添加空间推荐 - 发现页
         * @param {SpaceCreateRecommendSpaceRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceCreateRecommendSpace: function (body, options) {
            return localVarFp.spaceCreateRecommendSpace(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 删除每周精选 - 发现页
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceDeleteChoicenesses: function (id, options) {
            return localVarFp.spaceDeleteChoicenesses(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 删除空间推荐 - 空间推荐页
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceDeleteEditorsRecommendSpace: function (id, options) {
            return localVarFp.spaceDeleteEditorsRecommendSpace(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 删除空间推荐 - 发现页
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceDeleteRecommendSpace: function (id, options) {
            return localVarFp.spaceDeleteRecommendSpace(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 关注
         * @param {SpaceFollowReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceFollow: function (body, options) {
            return localVarFp.spaceFollow(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 关注者列表
         * @param {'USER' | 'TEAM'} [idKind]  - USER: 个人空间  - TEAM: 团队空间
         * @param {string} [idId]
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceFollowerList: function (idKind, idId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return localVarFp.spaceFollowerList(idKind, idId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取每周精选
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {string} [startDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetChoicenesses: function (app, startDate, options) {
            return localVarFp.spaceGetChoicenesses(app, startDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取空间的自定义标签
         * @param {number} teamId
         * @param {'UNKNOW' | 'ResearchReport' | 'Article'} [objectType]  - ResearchReport: 报告  - Article: 文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {Array<number>} [tagIds] 加上支持部分标签.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetCustomTagsBySpace: function (teamId, objectType, app, tagIds, options) {
            return localVarFp.spaceGetCustomTagsBySpace(teamId, objectType, app, tagIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取小编推荐-空间首页
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetEditorsRecommendSpace: function (app, options) {
            return localVarFp.spaceGetEditorsRecommendSpace(app, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取我的关注列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetFollowedSpaceList: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, app, options) {
            return localVarFp.spaceGetFollowedSpaceList(paginationPage, paginationSize, paginationHasMore, paginationTotal, app, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取空间推荐-发现页
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetRecommendSpace: function (app, options) {
            return localVarFp.spaceGetRecommendSpace(app, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取调研云团队空间信息
         * @param {number} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetResearchTeamSpace: function (teamId, options) {
            return localVarFp.spaceGetResearchTeamSpace(teamId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取调研云个人空间信息
         * @param {string} userGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetResearchUserSpace: function (userGuid, options) {
            return localVarFp.spaceGetResearchUserSpace(userGuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取空间列表
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {'Invalid' | 'Overall' | 'Works' | 'Popularity' | 'Latest' | 'PopularityIncrease' | 'ReadIncrease'} [orderBy] 排序.   - Overall: 综合  - Works: 作品数  - Popularity: 人气  - Latest: 最近更新  - PopularityIncrease: 人气上升  - ReadIncrease: 阅读上升
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetSpaces: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, app, orderBy, options) {
            return localVarFp.spaceGetSpaces(paginationPage, paginationSize, paginationHasMore, paginationTotal, app, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取空间的所有标签
         * @param {number} teamId
         * @param {'UNKNOW' | 'ResearchReport' | 'Article'} [objectType]  - ResearchReport: 报告  - Article: 文章
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetTagsBySpace: function (teamId, objectType, app, options) {
            return localVarFp.spaceGetTagsBySpace(teamId, objectType, app, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取用户所在团队的空间列表
         * @param {string} userGuid 用户id
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceGetTeamSpacesByUser: function (userGuid, paginationPage, paginationSize, paginationHasMore, paginationTotal, app, options) {
            return localVarFp.spaceGetTeamSpacesByUser(userGuid, paginationPage, paginationSize, paginationHasMore, paginationTotal, app, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 用户是否关注了这些空间
         * @param {SpaceIsFollowedReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceIsFollowed: function (body, options) {
            return localVarFp.spaceIsFollowed(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 移除关注者
         * @param {string} guid 关注者的guid
         * @param {'USER' | 'TEAM'} [idKind]  - USER: 个人空间  - TEAM: 团队空间
         * @param {string} [idId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceRemoveFollower: function (guid, idKind, idId, options) {
            return localVarFp.spaceRemoveFollower(guid, idKind, idId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [appType] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {'Invalid' | 'Overall' | 'Works' | 'Popularity' | 'Latest' | 'PopularityIncrease' | 'ReadIncrease'} [orderBy] 排序类型.   - Overall: 综合  - Works: 作品数  - Popularity: 人气  - Latest: 最近更新  - PopularityIncrease: 人气上升  - ReadIncrease: 阅读上升
         * @param {'desc' | 'asc'} [sort] 正/倒序.
         * @param {string} [keyword] 搜索关键词.
         * @param {boolean} [notRecordKeyword] 不记录搜索词.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceSearchSpaces: function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, keyword, notRecordKeyword, options) {
            return localVarFp.spaceSearchSpaces(appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, keyword, notRecordKeyword, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 取消关注
         * @param {SpaceUnFollowReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUnFollow: function (body, options) {
            return localVarFp.spaceUnFollow(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 更新每周精选 - 发现页
         * @param {SpaceUpdateChoicenessesReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateChoicenesses: function (body, options) {
            return localVarFp.spaceUpdateChoicenesses(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 更新空间推荐 - 空间推荐页
         * @param {SpaceUpdateEditorsRecommendSpaceReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateEditorsRecommendSpace: function (body, options) {
            return localVarFp.spaceUpdateEditorsRecommendSpace(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 批量更新用户空间项
         * @param {SpaceUpdateOrCreateItemsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateOrCreateItems: function (body, options) {
            return localVarFp.spaceUpdateOrCreateItems(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 更新空间推荐 - 发现页
         * @param {SpaceUpdateRecommendSpaceReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateRecommendSpace: function (body, options) {
            return localVarFp.spaceUpdateRecommendSpace(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 更新团队空间项的内容
         * @param {SpaceUpdateResearchTeamSpaceRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateResearchTeamSpace: function (body, options) {
            return localVarFp.spaceUpdateResearchTeamSpace(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 更新用户空间项的内容
         * @param {SpaceUpdateResearchUserSpaceRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceUpdateResearchUserSpace: function (body, options) {
            return localVarFp.spaceUpdateResearchUserSpace(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取最近浏览
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spaceViewHistory: function (app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
            return localVarFp.spaceViewHistory(app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SpaceApiFactory = SpaceApiFactory;
/**
 * SpaceApi - object-oriented interface
 * @export
 * @class SpaceApi
 * @extends {BaseAPI}
 */
var SpaceApi = /** @class */ (function (_super) {
    __extends(SpaceApi, _super);
    function SpaceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 管理员查看用户是否关注了这些空间
     * @param {SpaceAdmindGetUserIsFollowedReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceAdmindGetUserIsFollowed = function (body, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceAdmindGetUserIsFollowed(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 修改自定义标签
     * @param {number} teamId
     * @param {SpaceAlterCustomTagsReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceAlterCustomTags = function (teamId, body, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceAlterCustomTags(teamId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 修改空间展示的官方标签
     * @param {number} teamId
     * @param {SpaceAlterOfficialTagsReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceAlterOfficialTags = function (teamId, body, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceAlterOfficialTags(teamId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取指定空间信息
     * @param {SpaceBatchGetSpacesReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceBatchGetSpaces = function (body, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceBatchGetSpaces(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 添加每周精选 - 发现页
     * @param {SpaceCreateChoicenessesReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceCreateChoicenesses = function (body, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceCreateChoicenesses(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 添加空间推荐 - 空间推荐页
     * @param {SpaceCreateEditorsRecommendSpaceReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceCreateEditorsRecommendSpace = function (body, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceCreateEditorsRecommendSpace(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 添加空间推荐 - 发现页
     * @param {SpaceCreateRecommendSpaceRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceCreateRecommendSpace = function (body, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceCreateRecommendSpace(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 删除每周精选 - 发现页
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceDeleteChoicenesses = function (id, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceDeleteChoicenesses(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 删除空间推荐 - 空间推荐页
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceDeleteEditorsRecommendSpace = function (id, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceDeleteEditorsRecommendSpace(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 删除空间推荐 - 发现页
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceDeleteRecommendSpace = function (id, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceDeleteRecommendSpace(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 关注
     * @param {SpaceFollowReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceFollow = function (body, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceFollow(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 关注者列表
     * @param {'USER' | 'TEAM'} [idKind]  - USER: 个人空间  - TEAM: 团队空间
     * @param {string} [idId]
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceFollowerList = function (idKind, idId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceFollowerList(idKind, idId, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取每周精选
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
     * @param {string} [startDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceGetChoicenesses = function (app, startDate, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceGetChoicenesses(app, startDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取空间的自定义标签
     * @param {number} teamId
     * @param {'UNKNOW' | 'ResearchReport' | 'Article'} [objectType]  - ResearchReport: 报告  - Article: 文章
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
     * @param {Array<number>} [tagIds] 加上支持部分标签.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceGetCustomTagsBySpace = function (teamId, objectType, app, tagIds, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceGetCustomTagsBySpace(teamId, objectType, app, tagIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取小编推荐-空间首页
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceGetEditorsRecommendSpace = function (app, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceGetEditorsRecommendSpace(app, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取我的关注列表
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceGetFollowedSpaceList = function (paginationPage, paginationSize, paginationHasMore, paginationTotal, app, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceGetFollowedSpaceList(paginationPage, paginationSize, paginationHasMore, paginationTotal, app, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取空间推荐-发现页
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceGetRecommendSpace = function (app, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceGetRecommendSpace(app, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取调研云团队空间信息
     * @param {number} teamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceGetResearchTeamSpace = function (teamId, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceGetResearchTeamSpace(teamId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取调研云个人空间信息
     * @param {string} userGuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceGetResearchUserSpace = function (userGuid, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceGetResearchUserSpace(userGuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取空间列表
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
     * @param {'Invalid' | 'Overall' | 'Works' | 'Popularity' | 'Latest' | 'PopularityIncrease' | 'ReadIncrease'} [orderBy] 排序.   - Overall: 综合  - Works: 作品数  - Popularity: 人气  - Latest: 最近更新  - PopularityIncrease: 人气上升  - ReadIncrease: 阅读上升
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceGetSpaces = function (paginationPage, paginationSize, paginationHasMore, paginationTotal, app, orderBy, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceGetSpaces(paginationPage, paginationSize, paginationHasMore, paginationTotal, app, orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取空间的所有标签
     * @param {number} teamId
     * @param {'UNKNOW' | 'ResearchReport' | 'Article'} [objectType]  - ResearchReport: 报告  - Article: 文章
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceGetTagsBySpace = function (teamId, objectType, app, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceGetTagsBySpace(teamId, objectType, app, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取用户所在团队的空间列表
     * @param {string} userGuid 用户id
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceGetTeamSpacesByUser = function (userGuid, paginationPage, paginationSize, paginationHasMore, paginationTotal, app, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceGetTeamSpacesByUser(userGuid, paginationPage, paginationSize, paginationHasMore, paginationTotal, app, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 用户是否关注了这些空间
     * @param {SpaceIsFollowedReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceIsFollowed = function (body, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceIsFollowed(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 移除关注者
     * @param {string} guid 关注者的guid
     * @param {'USER' | 'TEAM'} [idKind]  - USER: 个人空间  - TEAM: 团队空间
     * @param {string} [idId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceRemoveFollower = function (guid, idKind, idId, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceRemoveFollower(guid, idKind, idId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [appType] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {'Invalid' | 'Overall' | 'Works' | 'Popularity' | 'Latest' | 'PopularityIncrease' | 'ReadIncrease'} [orderBy] 排序类型.   - Overall: 综合  - Works: 作品数  - Popularity: 人气  - Latest: 最近更新  - PopularityIncrease: 人气上升  - ReadIncrease: 阅读上升
     * @param {'desc' | 'asc'} [sort] 正/倒序.
     * @param {string} [keyword] 搜索关键词.
     * @param {boolean} [notRecordKeyword] 不记录搜索词.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceSearchSpaces = function (appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, keyword, notRecordKeyword, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceSearchSpaces(appType, paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, sort, keyword, notRecordKeyword, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 取消关注
     * @param {SpaceUnFollowReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceUnFollow = function (body, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceUnFollow(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 更新每周精选 - 发现页
     * @param {SpaceUpdateChoicenessesReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceUpdateChoicenesses = function (body, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceUpdateChoicenesses(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 更新空间推荐 - 空间推荐页
     * @param {SpaceUpdateEditorsRecommendSpaceReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceUpdateEditorsRecommendSpace = function (body, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceUpdateEditorsRecommendSpace(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 批量更新用户空间项
     * @param {SpaceUpdateOrCreateItemsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceUpdateOrCreateItems = function (body, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceUpdateOrCreateItems(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 更新空间推荐 - 发现页
     * @param {SpaceUpdateRecommendSpaceReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceUpdateRecommendSpace = function (body, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceUpdateRecommendSpace(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 更新团队空间项的内容
     * @param {SpaceUpdateResearchTeamSpaceRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceUpdateResearchTeamSpace = function (body, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceUpdateResearchTeamSpace(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 更新用户空间项的内容
     * @param {SpaceUpdateResearchUserSpaceRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceUpdateResearchUserSpace = function (body, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceUpdateResearchUserSpace(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取最近浏览
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app] 应用类型.   - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpaceApi
     */
    SpaceApi.prototype.spaceViewHistory = function (app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options) {
        var _this = this;
        return (0, exports.SpaceApiFp)(this.configuration).spaceViewHistory(app, paginationPage, paginationSize, paginationHasMore, paginationTotal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SpaceApi;
}(base_1.BaseAPI));
exports.SpaceApi = SpaceApi;
/**
 * StandardApi - axios parameter creator
 * @export
 */
var StandardApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standardGetParentStandardValueById: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/disable/standard/value/get_parent_by_id";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {Array<number>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standardGetStandardValueById: function (ids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/disable/standard/value/get_by_id";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (ids) {
                        localVarQueryParameter['ids'] = ids;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standardGetStandardValueByLabelValue: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/disable/standard/value/get_by_code";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standardGetStandardValueTTQLocationTree: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/disable/standard/value/get_ttq_location_tree";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.StandardApiAxiosParamCreator = StandardApiAxiosParamCreator;
/**
 * StandardApi - functional programming interface
 * @export
 */
var StandardApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.StandardApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standardGetParentStandardValueById: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.standardGetParentStandardValueById(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<number>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standardGetStandardValueById: function (ids, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.standardGetStandardValueById(ids, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standardGetStandardValueByLabelValue: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.standardGetStandardValueByLabelValue(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standardGetStandardValueTTQLocationTree: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.standardGetStandardValueTTQLocationTree(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.StandardApiFp = StandardApiFp;
/**
 * StandardApi - factory interface
 * @export
 */
var StandardApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.StandardApiFp)(configuration);
    return {
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standardGetParentStandardValueById: function (id, options) {
            return localVarFp.standardGetParentStandardValueById(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Array<number>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standardGetStandardValueById: function (ids, options) {
            return localVarFp.standardGetStandardValueById(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standardGetStandardValueByLabelValue: function (options) {
            return localVarFp.standardGetStandardValueByLabelValue(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standardGetStandardValueTTQLocationTree: function (options) {
            return localVarFp.standardGetStandardValueTTQLocationTree(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.StandardApiFactory = StandardApiFactory;
/**
 * StandardApi - object-oriented interface
 * @export
 * @class StandardApi
 * @extends {BaseAPI}
 */
var StandardApi = /** @class */ (function (_super) {
    __extends(StandardApi, _super);
    function StandardApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StandardApi
     */
    StandardApi.prototype.standardGetParentStandardValueById = function (id, options) {
        var _this = this;
        return (0, exports.StandardApiFp)(this.configuration).standardGetParentStandardValueById(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Array<number>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StandardApi
     */
    StandardApi.prototype.standardGetStandardValueById = function (ids, options) {
        var _this = this;
        return (0, exports.StandardApiFp)(this.configuration).standardGetStandardValueById(ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StandardApi
     */
    StandardApi.prototype.standardGetStandardValueByLabelValue = function (options) {
        var _this = this;
        return (0, exports.StandardApiFp)(this.configuration).standardGetStandardValueByLabelValue(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StandardApi
     */
    StandardApi.prototype.standardGetStandardValueTTQLocationTree = function (options) {
        var _this = this;
        return (0, exports.StandardApiFp)(this.configuration).standardGetStandardValueTTQLocationTree(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return StandardApi;
}(base_1.BaseAPI));
exports.StandardApi = StandardApi;
/**
 * TextSearchApi - axios parameter creator
 * @export
 */
var TextSearchApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 获取热搜词排行
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app 应用类型
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textSearchGetHotWords: function (app, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('textSearchGetHotWords', 'app', app);
                    localVarPath = "/api/textsearch/{app}/hotwords"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 调研云搜索联想
         * @param {string} [keyword] 搜索关键词.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textSearchGetResearchSuggestions: function (keyword, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/textsearch/research/suggestions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (keyword !== undefined) {
                        localVarQueryParameter['keyword'] = keyword;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 调研云搜索全部
         * @param {string} [keyword] 搜索关键词.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textSearchSearchResearchAll: function (keyword, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/textsearch/research/all";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (keyword !== undefined) {
                        localVarQueryParameter['keyword'] = keyword;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序.
         * @param {Array<string>} [tagIds] 标签 Id.
         * @param {string} [keyword] 搜索关键词.
         * @param {string} [scene] 搜索场景.
         * @param {boolean} [notRecordKeyword] 搜索不会记录搜索词.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textSearchSearchTXCPost: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, tagIds, keyword, scene, notRecordKeyword, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/textsearch/txc/post";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationPage !== undefined) {
                        localVarQueryParameter['pagination.page'] = paginationPage;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (tagIds) {
                        localVarQueryParameter['tagIds'] = tagIds;
                    }
                    if (keyword !== undefined) {
                        localVarQueryParameter['keyword'] = keyword;
                    }
                    if (scene !== undefined) {
                        localVarQueryParameter['scene'] = scene;
                    }
                    if (notRecordKeyword !== undefined) {
                        localVarQueryParameter['notRecordKeyword'] = notRecordKeyword;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TextSearchApiAxiosParamCreator = TextSearchApiAxiosParamCreator;
/**
 * TextSearchApi - functional programming interface
 * @export
 */
var TextSearchApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TextSearchApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 获取热搜词排行
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app 应用类型
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textSearchGetHotWords: function (app, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.textSearchGetHotWords(app, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 调研云搜索联想
         * @param {string} [keyword] 搜索关键词.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textSearchGetResearchSuggestions: function (keyword, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.textSearchGetResearchSuggestions(keyword, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 调研云搜索全部
         * @param {string} [keyword] 搜索关键词.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textSearchSearchResearchAll: function (keyword, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.textSearchSearchResearchAll(keyword, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序.
         * @param {Array<string>} [tagIds] 标签 Id.
         * @param {string} [keyword] 搜索关键词.
         * @param {string} [scene] 搜索场景.
         * @param {boolean} [notRecordKeyword] 搜索不会记录搜索词.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textSearchSearchTXCPost: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, tagIds, keyword, scene, notRecordKeyword, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.textSearchSearchTXCPost(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, tagIds, keyword, scene, notRecordKeyword, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TextSearchApiFp = TextSearchApiFp;
/**
 * TextSearchApi - factory interface
 * @export
 */
var TextSearchApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TextSearchApiFp)(configuration);
    return {
        /**
         *
         * @summary 获取热搜词排行
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app 应用类型
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textSearchGetHotWords: function (app, options) {
            return localVarFp.textSearchGetHotWords(app, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 调研云搜索联想
         * @param {string} [keyword] 搜索关键词.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textSearchGetResearchSuggestions: function (keyword, options) {
            return localVarFp.textSearchGetResearchSuggestions(keyword, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 调研云搜索全部
         * @param {string} [keyword] 搜索关键词.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textSearchSearchResearchAll: function (keyword, options) {
            return localVarFp.textSearchSearchResearchAll(keyword, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [paginationPage] 页码.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {string} [orderBy] 排序.
         * @param {Array<string>} [tagIds] 标签 Id.
         * @param {string} [keyword] 搜索关键词.
         * @param {string} [scene] 搜索场景.
         * @param {boolean} [notRecordKeyword] 搜索不会记录搜索词.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textSearchSearchTXCPost: function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, tagIds, keyword, scene, notRecordKeyword, options) {
            return localVarFp.textSearchSearchTXCPost(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, tagIds, keyword, scene, notRecordKeyword, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TextSearchApiFactory = TextSearchApiFactory;
/**
 * TextSearchApi - object-oriented interface
 * @export
 * @class TextSearchApi
 * @extends {BaseAPI}
 */
var TextSearchApi = /** @class */ (function (_super) {
    __extends(TextSearchApi, _super);
    function TextSearchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 获取热搜词排行
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app 应用类型
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextSearchApi
     */
    TextSearchApi.prototype.textSearchGetHotWords = function (app, options) {
        var _this = this;
        return (0, exports.TextSearchApiFp)(this.configuration).textSearchGetHotWords(app, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 调研云搜索联想
     * @param {string} [keyword] 搜索关键词.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextSearchApi
     */
    TextSearchApi.prototype.textSearchGetResearchSuggestions = function (keyword, options) {
        var _this = this;
        return (0, exports.TextSearchApiFp)(this.configuration).textSearchGetResearchSuggestions(keyword, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 调研云搜索全部
     * @param {string} [keyword] 搜索关键词.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextSearchApi
     */
    TextSearchApi.prototype.textSearchSearchResearchAll = function (keyword, options) {
        var _this = this;
        return (0, exports.TextSearchApiFp)(this.configuration).textSearchSearchResearchAll(keyword, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [paginationPage] 页码.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {string} [orderBy] 排序.
     * @param {Array<string>} [tagIds] 标签 Id.
     * @param {string} [keyword] 搜索关键词.
     * @param {string} [scene] 搜索场景.
     * @param {boolean} [notRecordKeyword] 搜索不会记录搜索词.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextSearchApi
     */
    TextSearchApi.prototype.textSearchSearchTXCPost = function (paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, tagIds, keyword, scene, notRecordKeyword, options) {
        var _this = this;
        return (0, exports.TextSearchApiFp)(this.configuration).textSearchSearchTXCPost(paginationPage, paginationSize, paginationHasMore, paginationTotal, orderBy, tagIds, keyword, scene, notRecordKeyword, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TextSearchApi;
}(base_1.BaseAPI));
exports.TextSearchApi = TextSearchApi;
/**
 * TidalBIApi - axios parameter creator
 * @export
 */
var TidalBIApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {TidalbiCreateMetricParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBICreateMetric: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBICreateMetric', 'body', body);
                    localVarPath = "/api/tidalbi/metric";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {TidalbiTopic} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBICreateTopic: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBICreateTopic', 'body', body);
                    localVarPath = "/api/tidalbi/topic";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {TidalbiTopicModel} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBICreateTopicModel: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBICreateTopicModel', 'body', body);
                    localVarPath = "/api/tidalbi/topic-model";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {TidalbiGenerateSupersetChartParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGenerateChart: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBIGenerateChart', 'id', id);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBIGenerateChart', 'body', body);
                    localVarPath = "/api/tidalbi/metric/{id}/gen-chart"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetMetricDetail: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBIGetMetricDetail', 'id', id);
                    localVarPath = "/api/tidalbi/metric/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {TidalbiMetricRowsByDateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetMetricRowsByDate: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBIGetMetricRowsByDate', 'body', body);
                    localVarPath = "/disable/tidalbi/data/get-data-metric";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {TidalbiMetricRowsByKeysIn6MonthsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetMetricRowsByKeyIn6Months: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBIGetMetricRowsByKeyIn6Months', 'body', body);
                    localVarPath = "/api/tidalbi/bi-data/6m";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetMySupersetDatasetList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/tidalbi/superset/dataset";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetProjectList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/tidalbi/project";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetProjectTopics: function (projectId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/tidalbi/topic";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (projectId !== undefined) {
                        localVarQueryParameter['project_id'] = projectId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetSearchMetricFilter: function (projectId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/tidalbi/search-metric-filter";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (projectId !== undefined) {
                        localVarQueryParameter['project_id'] = projectId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {TidalbiSingleMetricRowRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetSingleMetricRow: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBIGetSingleMetricRow', 'body', body);
                    localVarPath = "/disable/tidalbi/data/get-metric";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetSupersetDatasetDetail: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBIGetSupersetDatasetDetail', 'id', id);
                    localVarPath = "/api/tidalbi/superset/dataset/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetTopicModelDetail: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBIGetTopicModelDetail', 'id', id);
                    localVarPath = "/api/tidalbi/topic-model/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} [projectId]
         * @param {number} [topicId]
         * @param {number} [page]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetTopicModelList: function (projectId, topicId, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/tidalbi/topic-model";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (projectId !== undefined) {
                        localVarQueryParameter['project_id'] = projectId;
                    }
                    if (topicId !== undefined) {
                        localVarQueryParameter['topic_id'] = topicId;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {TidalbiSearchMetricParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBISearchMetricList: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBISearchMetricList', 'body', body);
                    localVarPath = "/api/tidalbi/search-metric";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {TidalbiMetricRow} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBISetMetric: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBISetMetric', 'body', body);
                    localVarPath = "/disable/tidalbi/data/set-metric";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {TidalbiMetric} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIUpdateMetricBasicInfo: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBIUpdateMetricBasicInfo', 'id', id);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBIUpdateMetricBasicInfo', 'body', body);
                    localVarPath = "/api/tidalbi/metric/{id}/basic-info"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {TidalbiMetric} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIUpdateMetricDevelopmentInfo: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBIUpdateMetricDevelopmentInfo', 'id', id);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBIUpdateMetricDevelopmentInfo', 'body', body);
                    localVarPath = "/api/tidalbi/metric/{id}/development-info"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {TidalbiMetric} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIUpdateMetricExtraInfo: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBIUpdateMetricExtraInfo', 'id', id);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('tidalBIUpdateMetricExtraInfo', 'body', body);
                    localVarPath = "/api/tidalbi/metric/{id}/extra-info"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TidalBIApiAxiosParamCreator = TidalBIApiAxiosParamCreator;
/**
 * TidalBIApi - functional programming interface
 * @export
 */
var TidalBIApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TidalBIApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {TidalbiCreateMetricParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBICreateMetric: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBICreateMetric(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {TidalbiTopic} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBICreateTopic: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBICreateTopic(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {TidalbiTopicModel} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBICreateTopicModel: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBICreateTopicModel(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {TidalbiGenerateSupersetChartParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGenerateChart: function (id, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBIGenerateChart(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetMetricDetail: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBIGetMetricDetail(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {TidalbiMetricRowsByDateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetMetricRowsByDate: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBIGetMetricRowsByDate(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {TidalbiMetricRowsByKeysIn6MonthsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetMetricRowsByKeyIn6Months: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBIGetMetricRowsByKeyIn6Months(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetMySupersetDatasetList: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBIGetMySupersetDatasetList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetProjectList: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBIGetProjectList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetProjectTopics: function (projectId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBIGetProjectTopics(projectId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetSearchMetricFilter: function (projectId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBIGetSearchMetricFilter(projectId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {TidalbiSingleMetricRowRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetSingleMetricRow: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBIGetSingleMetricRow(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetSupersetDatasetDetail: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBIGetSupersetDatasetDetail(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetTopicModelDetail: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBIGetTopicModelDetail(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [projectId]
         * @param {number} [topicId]
         * @param {number} [page]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetTopicModelList: function (projectId, topicId, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBIGetTopicModelList(projectId, topicId, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {TidalbiSearchMetricParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBISearchMetricList: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBISearchMetricList(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {TidalbiMetricRow} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBISetMetric: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBISetMetric(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {TidalbiMetric} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIUpdateMetricBasicInfo: function (id, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBIUpdateMetricBasicInfo(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {TidalbiMetric} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIUpdateMetricDevelopmentInfo: function (id, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBIUpdateMetricDevelopmentInfo(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {TidalbiMetric} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIUpdateMetricExtraInfo: function (id, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBIUpdateMetricExtraInfo(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TidalBIApiFp = TidalBIApiFp;
/**
 * TidalBIApi - factory interface
 * @export
 */
var TidalBIApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TidalBIApiFp)(configuration);
    return {
        /**
         *
         * @param {TidalbiCreateMetricParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBICreateMetric: function (body, options) {
            return localVarFp.tidalBICreateMetric(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {TidalbiTopic} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBICreateTopic: function (body, options) {
            return localVarFp.tidalBICreateTopic(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {TidalbiTopicModel} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBICreateTopicModel: function (body, options) {
            return localVarFp.tidalBICreateTopicModel(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {TidalbiGenerateSupersetChartParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGenerateChart: function (id, body, options) {
            return localVarFp.tidalBIGenerateChart(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetMetricDetail: function (id, options) {
            return localVarFp.tidalBIGetMetricDetail(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {TidalbiMetricRowsByDateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetMetricRowsByDate: function (body, options) {
            return localVarFp.tidalBIGetMetricRowsByDate(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {TidalbiMetricRowsByKeysIn6MonthsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetMetricRowsByKeyIn6Months: function (body, options) {
            return localVarFp.tidalBIGetMetricRowsByKeyIn6Months(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetMySupersetDatasetList: function (options) {
            return localVarFp.tidalBIGetMySupersetDatasetList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetProjectList: function (options) {
            return localVarFp.tidalBIGetProjectList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetProjectTopics: function (projectId, options) {
            return localVarFp.tidalBIGetProjectTopics(projectId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetSearchMetricFilter: function (projectId, options) {
            return localVarFp.tidalBIGetSearchMetricFilter(projectId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {TidalbiSingleMetricRowRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetSingleMetricRow: function (body, options) {
            return localVarFp.tidalBIGetSingleMetricRow(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetSupersetDatasetDetail: function (id, options) {
            return localVarFp.tidalBIGetSupersetDatasetDetail(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetTopicModelDetail: function (id, options) {
            return localVarFp.tidalBIGetTopicModelDetail(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [projectId]
         * @param {number} [topicId]
         * @param {number} [page]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIGetTopicModelList: function (projectId, topicId, page, size, options) {
            return localVarFp.tidalBIGetTopicModelList(projectId, topicId, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {TidalbiSearchMetricParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBISearchMetricList: function (body, options) {
            return localVarFp.tidalBISearchMetricList(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {TidalbiMetricRow} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBISetMetric: function (body, options) {
            return localVarFp.tidalBISetMetric(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {TidalbiMetric} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIUpdateMetricBasicInfo: function (id, body, options) {
            return localVarFp.tidalBIUpdateMetricBasicInfo(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {TidalbiMetric} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIUpdateMetricDevelopmentInfo: function (id, body, options) {
            return localVarFp.tidalBIUpdateMetricDevelopmentInfo(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {TidalbiMetric} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBIUpdateMetricExtraInfo: function (id, body, options) {
            return localVarFp.tidalBIUpdateMetricExtraInfo(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TidalBIApiFactory = TidalBIApiFactory;
/**
 * TidalBIApi - object-oriented interface
 * @export
 * @class TidalBIApi
 * @extends {BaseAPI}
 */
var TidalBIApi = /** @class */ (function (_super) {
    __extends(TidalBIApi, _super);
    function TidalBIApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {TidalbiCreateMetricParams} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBICreateMetric = function (body, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBICreateMetric(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {TidalbiTopic} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBICreateTopic = function (body, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBICreateTopic(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {TidalbiTopicModel} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBICreateTopicModel = function (body, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBICreateTopicModel(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {TidalbiGenerateSupersetChartParams} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBIGenerateChart = function (id, body, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBIGenerateChart(id, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBIGetMetricDetail = function (id, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBIGetMetricDetail(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {TidalbiMetricRowsByDateRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBIGetMetricRowsByDate = function (body, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBIGetMetricRowsByDate(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {TidalbiMetricRowsByKeysIn6MonthsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBIGetMetricRowsByKeyIn6Months = function (body, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBIGetMetricRowsByKeyIn6Months(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBIGetMySupersetDatasetList = function (options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBIGetMySupersetDatasetList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBIGetProjectList = function (options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBIGetProjectList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [projectId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBIGetProjectTopics = function (projectId, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBIGetProjectTopics(projectId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [projectId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBIGetSearchMetricFilter = function (projectId, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBIGetSearchMetricFilter(projectId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {TidalbiSingleMetricRowRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBIGetSingleMetricRow = function (body, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBIGetSingleMetricRow(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBIGetSupersetDatasetDetail = function (id, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBIGetSupersetDatasetDetail(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBIGetTopicModelDetail = function (id, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBIGetTopicModelDetail(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [projectId]
     * @param {number} [topicId]
     * @param {number} [page]
     * @param {number} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBIGetTopicModelList = function (projectId, topicId, page, size, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBIGetTopicModelList(projectId, topicId, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {TidalbiSearchMetricParams} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBISearchMetricList = function (body, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBISearchMetricList(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {TidalbiMetricRow} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBISetMetric = function (body, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBISetMetric(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {TidalbiMetric} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBIUpdateMetricBasicInfo = function (id, body, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBIUpdateMetricBasicInfo(id, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {TidalbiMetric} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBIUpdateMetricDevelopmentInfo = function (id, body, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBIUpdateMetricDevelopmentInfo(id, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {TidalbiMetric} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBIApi
     */
    TidalBIApi.prototype.tidalBIUpdateMetricExtraInfo = function (id, body, options) {
        var _this = this;
        return (0, exports.TidalBIApiFp)(this.configuration).tidalBIUpdateMetricExtraInfo(id, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TidalBIApi;
}(base_1.BaseAPI));
exports.TidalBIApi = TidalBIApi;
/**
 * TidalBaseApi - axios parameter creator
 * @export
 */
var TidalBaseApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBaseGetProjects: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/disable/tidalbase/project";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TidalBaseApiAxiosParamCreator = TidalBaseApiAxiosParamCreator;
/**
 * TidalBaseApi - functional programming interface
 * @export
 */
var TidalBaseApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TidalBaseApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBaseGetProjects: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tidalBaseGetProjects(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TidalBaseApiFp = TidalBaseApiFp;
/**
 * TidalBaseApi - factory interface
 * @export
 */
var TidalBaseApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TidalBaseApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tidalBaseGetProjects: function (options) {
            return localVarFp.tidalBaseGetProjects(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TidalBaseApiFactory = TidalBaseApiFactory;
/**
 * TidalBaseApi - object-oriented interface
 * @export
 * @class TidalBaseApi
 * @extends {BaseAPI}
 */
var TidalBaseApi = /** @class */ (function (_super) {
    __extends(TidalBaseApi, _super);
    function TidalBaseApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TidalBaseApi
     */
    TidalBaseApi.prototype.tidalBaseGetProjects = function (options) {
        var _this = this;
        return (0, exports.TidalBaseApiFp)(this.configuration).tidalBaseGetProjects(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TidalBaseApi;
}(base_1.BaseAPI));
exports.TidalBaseApi = TidalBaseApi;
/**
 * TtqApi - axios parameter creator
 * @export
 */
var TtqApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary assets
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqAssetsConfirm: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('ttqAssetsConfirm', 'id', id);
                    localVarPath = "/api/ttqassets/assets/confirm/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AssetsGetAssetsPaginationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqAssetsPagination: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqAssetsPagination', 'body', body);
                    localVarPath = "/api/ttqassets/assets/list";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {ScoreCreateScoreUserRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqCreateScoreUser: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqCreateScoreUser', 'body', body);
                    localVarPath = "/api/ttqscore/score-user/create";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqGetAdmins: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ttqadmin/get-admins";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {GroupGetGroupsByIdParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqGetGroupById: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqGetGroupById', 'body', body);
                    localVarPath = "/disable/ttqgroup/get-groups";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary rpc StopGroup(ttq.group.GroupIdParams) returns (ttq.CommonResponse) {    option (google.api.http) = {      post: \"/disable/ttqgroup/stop-group\",      body: \"*\"    };  }  rpc BanGroup(ttq.group.GroupIdParams) returns (ttq.CommonResponse) {    option (google.api.http) = {      post: \"/disable/ttqgroup/ban-group\",      body: \"*\"    };  }
         * @param {GroupGroupIdParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqGetGroupDetail: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqGetGroupDetail', 'body', body);
                    localVarPath = "/disable/ttqgroup/group-detail";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqGetPermissions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ttqadmin/get-permissions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqGetWeixinMenu: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ttqweixin/get-menu";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 准备废弃，转用PerformAction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqHasPermission: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/disable/ttqadmin/has-permission";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AssetsImportAssetsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqImportAssets: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqImportAssets', 'body', body);
                    localVarPath = "/api/ttqassets/assets/import";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary admin
         * @param {AdminPerformActionRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqPerformAction: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqPerformAction', 'body', body);
                    localVarPath = "/disable/ttqadmin/perform-action";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AssetsGetRepayAssetsPaginationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqRepayAssetsPagination: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqRepayAssetsPagination', 'body', body);
                    localVarPath = "/api/ttqassets/assets/repay-list";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AssetsScoreApplyApprovalRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreApplyApproval: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqScoreApplyApproval', 'body', body);
                    localVarPath = "/api/ttqassets/score-apply/approval";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AssetsScoreApplyCreateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreApplyCreate: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqScoreApplyCreate', 'body', body);
                    localVarPath = "/api/ttqassets/score-apply/create";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreApplyDetail: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('ttqScoreApplyDetail', 'id', id);
                    localVarPath = "/api/ttqassets/score-apply/detail/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AssetsGetScoreApplyPaginationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreApplyList: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqScoreApplyList', 'body', body);
                    localVarPath = "/api/ttqassets/score-apply/list";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {ScoreGetScoreGiftPaginationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreGiftPagination: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqScoreGiftPagination', 'body', body);
                    localVarPath = "/api/ttqscore/score-gift/list";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary score
         * @param {ScoreGetScoreUserPaginationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreUserPagination: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqScoreUserPagination', 'body', body);
                    localVarPath = "/api/ttqscore/score-user/list";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {GroupSearchGroupListParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqSearchGroupList: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqSearchGroupList', 'body', body);
                    localVarPath = "/disable/ttqgroup/search-groups";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary weixin
         * @param {WeixinWeixinMenu} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqSetWeixinMenu: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqSetWeixinMenu', 'body', body);
                    localVarPath = "/api/ttqweixin/set-menu";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary group
         * @param {GroupStartQcloudGroupParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqStartQcloudGroup: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqStartQcloudGroup', 'body', body);
                    localVarPath = "/disable/ttqgroup/start-qcloud-group";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AdminAdmin} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqUpdateAdmin: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqUpdateAdmin', 'body', body);
                    localVarPath = "/api/ttqadmin/update-admin";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {ScoreUpdateScoreUserRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqUpdateScoreUser: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('ttqUpdateScoreUser', 'body', body);
                    localVarPath = "/api/ttqscore/score-user/update";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TtqApiAxiosParamCreator = TtqApiAxiosParamCreator;
/**
 * TtqApi - functional programming interface
 * @export
 */
var TtqApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TtqApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary assets
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqAssetsConfirm: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqAssetsConfirm(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {AssetsGetAssetsPaginationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqAssetsPagination: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqAssetsPagination(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ScoreCreateScoreUserRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqCreateScoreUser: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqCreateScoreUser(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqGetAdmins: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqGetAdmins(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {GroupGetGroupsByIdParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqGetGroupById: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqGetGroupById(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary rpc StopGroup(ttq.group.GroupIdParams) returns (ttq.CommonResponse) {    option (google.api.http) = {      post: \"/disable/ttqgroup/stop-group\",      body: \"*\"    };  }  rpc BanGroup(ttq.group.GroupIdParams) returns (ttq.CommonResponse) {    option (google.api.http) = {      post: \"/disable/ttqgroup/ban-group\",      body: \"*\"    };  }
         * @param {GroupGroupIdParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqGetGroupDetail: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqGetGroupDetail(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqGetPermissions: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqGetPermissions(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqGetWeixinMenu: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqGetWeixinMenu(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 准备废弃，转用PerformAction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqHasPermission: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqHasPermission(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {AssetsImportAssetsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqImportAssets: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqImportAssets(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary admin
         * @param {AdminPerformActionRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqPerformAction: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqPerformAction(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {AssetsGetRepayAssetsPaginationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqRepayAssetsPagination: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqRepayAssetsPagination(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {AssetsScoreApplyApprovalRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreApplyApproval: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqScoreApplyApproval(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {AssetsScoreApplyCreateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreApplyCreate: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqScoreApplyCreate(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreApplyDetail: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqScoreApplyDetail(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {AssetsGetScoreApplyPaginationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreApplyList: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqScoreApplyList(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ScoreGetScoreGiftPaginationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreGiftPagination: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqScoreGiftPagination(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary score
         * @param {ScoreGetScoreUserPaginationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreUserPagination: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqScoreUserPagination(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {GroupSearchGroupListParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqSearchGroupList: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqSearchGroupList(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary weixin
         * @param {WeixinWeixinMenu} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqSetWeixinMenu: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqSetWeixinMenu(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary group
         * @param {GroupStartQcloudGroupParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqStartQcloudGroup: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqStartQcloudGroup(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {AdminAdmin} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqUpdateAdmin: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqUpdateAdmin(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ScoreUpdateScoreUserRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqUpdateScoreUser: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ttqUpdateScoreUser(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TtqApiFp = TtqApiFp;
/**
 * TtqApi - factory interface
 * @export
 */
var TtqApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TtqApiFp)(configuration);
    return {
        /**
         *
         * @summary assets
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqAssetsConfirm: function (id, options) {
            return localVarFp.ttqAssetsConfirm(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AssetsGetAssetsPaginationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqAssetsPagination: function (body, options) {
            return localVarFp.ttqAssetsPagination(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ScoreCreateScoreUserRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqCreateScoreUser: function (body, options) {
            return localVarFp.ttqCreateScoreUser(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqGetAdmins: function (options) {
            return localVarFp.ttqGetAdmins(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {GroupGetGroupsByIdParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqGetGroupById: function (body, options) {
            return localVarFp.ttqGetGroupById(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary rpc StopGroup(ttq.group.GroupIdParams) returns (ttq.CommonResponse) {    option (google.api.http) = {      post: \"/disable/ttqgroup/stop-group\",      body: \"*\"    };  }  rpc BanGroup(ttq.group.GroupIdParams) returns (ttq.CommonResponse) {    option (google.api.http) = {      post: \"/disable/ttqgroup/ban-group\",      body: \"*\"    };  }
         * @param {GroupGroupIdParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqGetGroupDetail: function (body, options) {
            return localVarFp.ttqGetGroupDetail(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqGetPermissions: function (options) {
            return localVarFp.ttqGetPermissions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqGetWeixinMenu: function (options) {
            return localVarFp.ttqGetWeixinMenu(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 准备废弃，转用PerformAction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqHasPermission: function (options) {
            return localVarFp.ttqHasPermission(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AssetsImportAssetsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqImportAssets: function (body, options) {
            return localVarFp.ttqImportAssets(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary admin
         * @param {AdminPerformActionRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqPerformAction: function (body, options) {
            return localVarFp.ttqPerformAction(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AssetsGetRepayAssetsPaginationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqRepayAssetsPagination: function (body, options) {
            return localVarFp.ttqRepayAssetsPagination(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AssetsScoreApplyApprovalRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreApplyApproval: function (body, options) {
            return localVarFp.ttqScoreApplyApproval(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AssetsScoreApplyCreateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreApplyCreate: function (body, options) {
            return localVarFp.ttqScoreApplyCreate(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreApplyDetail: function (id, options) {
            return localVarFp.ttqScoreApplyDetail(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AssetsGetScoreApplyPaginationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreApplyList: function (body, options) {
            return localVarFp.ttqScoreApplyList(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ScoreGetScoreGiftPaginationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreGiftPagination: function (body, options) {
            return localVarFp.ttqScoreGiftPagination(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary score
         * @param {ScoreGetScoreUserPaginationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqScoreUserPagination: function (body, options) {
            return localVarFp.ttqScoreUserPagination(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {GroupSearchGroupListParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqSearchGroupList: function (body, options) {
            return localVarFp.ttqSearchGroupList(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary weixin
         * @param {WeixinWeixinMenu} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqSetWeixinMenu: function (body, options) {
            return localVarFp.ttqSetWeixinMenu(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary group
         * @param {GroupStartQcloudGroupParams} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqStartQcloudGroup: function (body, options) {
            return localVarFp.ttqStartQcloudGroup(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AdminAdmin} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqUpdateAdmin: function (body, options) {
            return localVarFp.ttqUpdateAdmin(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ScoreUpdateScoreUserRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ttqUpdateScoreUser: function (body, options) {
            return localVarFp.ttqUpdateScoreUser(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TtqApiFactory = TtqApiFactory;
/**
 * TtqApi - object-oriented interface
 * @export
 * @class TtqApi
 * @extends {BaseAPI}
 */
var TtqApi = /** @class */ (function (_super) {
    __extends(TtqApi, _super);
    function TtqApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary assets
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqAssetsConfirm = function (id, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqAssetsConfirm(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AssetsGetAssetsPaginationRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqAssetsPagination = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqAssetsPagination(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ScoreCreateScoreUserRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqCreateScoreUser = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqCreateScoreUser(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqGetAdmins = function (options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqGetAdmins(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {GroupGetGroupsByIdParams} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqGetGroupById = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqGetGroupById(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary rpc StopGroup(ttq.group.GroupIdParams) returns (ttq.CommonResponse) {    option (google.api.http) = {      post: \"/disable/ttqgroup/stop-group\",      body: \"*\"    };  }  rpc BanGroup(ttq.group.GroupIdParams) returns (ttq.CommonResponse) {    option (google.api.http) = {      post: \"/disable/ttqgroup/ban-group\",      body: \"*\"    };  }
     * @param {GroupGroupIdParams} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqGetGroupDetail = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqGetGroupDetail(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqGetPermissions = function (options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqGetPermissions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqGetWeixinMenu = function (options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqGetWeixinMenu(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 准备废弃，转用PerformAction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqHasPermission = function (options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqHasPermission(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AssetsImportAssetsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqImportAssets = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqImportAssets(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary admin
     * @param {AdminPerformActionRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqPerformAction = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqPerformAction(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AssetsGetRepayAssetsPaginationRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqRepayAssetsPagination = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqRepayAssetsPagination(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AssetsScoreApplyApprovalRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqScoreApplyApproval = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqScoreApplyApproval(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AssetsScoreApplyCreateRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqScoreApplyCreate = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqScoreApplyCreate(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqScoreApplyDetail = function (id, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqScoreApplyDetail(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AssetsGetScoreApplyPaginationRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqScoreApplyList = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqScoreApplyList(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ScoreGetScoreGiftPaginationRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqScoreGiftPagination = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqScoreGiftPagination(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary score
     * @param {ScoreGetScoreUserPaginationRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqScoreUserPagination = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqScoreUserPagination(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {GroupSearchGroupListParams} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqSearchGroupList = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqSearchGroupList(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary weixin
     * @param {WeixinWeixinMenu} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqSetWeixinMenu = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqSetWeixinMenu(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary group
     * @param {GroupStartQcloudGroupParams} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqStartQcloudGroup = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqStartQcloudGroup(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AdminAdmin} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqUpdateAdmin = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqUpdateAdmin(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ScoreUpdateScoreUserRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TtqApi
     */
    TtqApi.prototype.ttqUpdateScoreUser = function (body, options) {
        var _this = this;
        return (0, exports.TtqApiFp)(this.configuration).ttqUpdateScoreUser(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TtqApi;
}(base_1.BaseAPI));
exports.TtqApi = TtqApi;
/**
 * UploadApi - axios parameter creator
 * @export
 */
var UploadApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 替换图片地址
         * @param {string} app
         * @param {ReplaceImageUrlReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadReplaceImageUrl: function (app, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('uploadReplaceImageUrl', 'app', app);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('uploadReplaceImageUrl', 'body', body);
                    localVarPath = "/api/upload/{app}/image/replace"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} appName
         * @param {UploadImageRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUploadImage: function (appName, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appName' is not null or undefined
                    (0, common_1.assertParamExists)('uploadUploadImage', 'appName', appName);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('uploadUploadImage', 'body', body);
                    localVarPath = "/api/upload/{appName}/image"
                        .replace("{".concat("appName", "}"), encodeURIComponent(String(appName)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.UploadApiAxiosParamCreator = UploadApiAxiosParamCreator;
/**
 * UploadApi - functional programming interface
 * @export
 */
var UploadApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UploadApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 替换图片地址
         * @param {string} app
         * @param {ReplaceImageUrlReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadReplaceImageUrl: function (app, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadReplaceImageUrl(app, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} appName
         * @param {UploadImageRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUploadImage: function (appName, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadUploadImage(appName, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.UploadApiFp = UploadApiFp;
/**
 * UploadApi - factory interface
 * @export
 */
var UploadApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UploadApiFp)(configuration);
    return {
        /**
         *
         * @summary 替换图片地址
         * @param {string} app
         * @param {ReplaceImageUrlReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadReplaceImageUrl: function (app, body, options) {
            return localVarFp.uploadReplaceImageUrl(app, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} appName
         * @param {UploadImageRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUploadImage: function (appName, body, options) {
            return localVarFp.uploadUploadImage(appName, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UploadApiFactory = UploadApiFactory;
/**
 * UploadApi - object-oriented interface
 * @export
 * @class UploadApi
 * @extends {BaseAPI}
 */
var UploadApi = /** @class */ (function (_super) {
    __extends(UploadApi, _super);
    function UploadApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 替换图片地址
     * @param {string} app
     * @param {ReplaceImageUrlReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    UploadApi.prototype.uploadReplaceImageUrl = function (app, body, options) {
        var _this = this;
        return (0, exports.UploadApiFp)(this.configuration).uploadReplaceImageUrl(app, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} appName
     * @param {UploadImageRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    UploadApi.prototype.uploadUploadImage = function (appName, body, options) {
        var _this = this;
        return (0, exports.UploadApiFp)(this.configuration).uploadUploadImage(appName, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UploadApi;
}(base_1.BaseAPI));
exports.UploadApi = UploadApi;
/**
 * UrdesignerApi - axios parameter creator
 * @export
 */
var UrdesignerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 录入方案
         * @param {UrdesignerCreateDesignReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urdesignerCreateDesign: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('urdesignerCreateDesign', 'body', body);
                    localVarPath = "/api/urdesigner/research/designs/create";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 创建研究目标
         * @param {UrdesignerCreateGoalReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urdesignerCreateGoal: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('urdesignerCreateGoal', 'body', body);
                    localVarPath = "/api/urdesigner/research/goals/create";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 研究方案
         * @param {number} goalId 研究目的id
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urdesignerListResearchDesign: function (goalId, paginationId, paginationSize, paginationHasMore, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'goalId' is not null or undefined
                    (0, common_1.assertParamExists)('urdesignerListResearchDesign', 'goalId', goalId);
                    localVarPath = "/api/urdesigner/research/goals/{goalId}/designs"
                        .replace("{".concat("goalId", "}"), encodeURIComponent(String(goalId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationId !== undefined) {
                        localVarQueryParameter['pagination.id'] = paginationId;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 研究目的列表
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urdesignerListResearchGoal: function (paginationId, paginationSize, paginationHasMore, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/urdesigner/research/goals";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationId !== undefined) {
                        localVarQueryParameter['pagination.id'] = paginationId;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.hasMore'] = paginationHasMore;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 搜索研究目的
         * @param {UrdesignerSearchResearchGoalReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urdesignerSearchResearchGoal: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('urdesignerSearchResearchGoal', 'body', body);
                    localVarPath = "/api/urdesigner/research/goals/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.UrdesignerApiAxiosParamCreator = UrdesignerApiAxiosParamCreator;
/**
 * UrdesignerApi - functional programming interface
 * @export
 */
var UrdesignerApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UrdesignerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 录入方案
         * @param {UrdesignerCreateDesignReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urdesignerCreateDesign: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.urdesignerCreateDesign(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 创建研究目标
         * @param {UrdesignerCreateGoalReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urdesignerCreateGoal: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.urdesignerCreateGoal(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 研究方案
         * @param {number} goalId 研究目的id
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urdesignerListResearchDesign: function (goalId, paginationId, paginationSize, paginationHasMore, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.urdesignerListResearchDesign(goalId, paginationId, paginationSize, paginationHasMore, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 研究目的列表
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urdesignerListResearchGoal: function (paginationId, paginationSize, paginationHasMore, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.urdesignerListResearchGoal(paginationId, paginationSize, paginationHasMore, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 搜索研究目的
         * @param {UrdesignerSearchResearchGoalReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urdesignerSearchResearchGoal: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.urdesignerSearchResearchGoal(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.UrdesignerApiFp = UrdesignerApiFp;
/**
 * UrdesignerApi - factory interface
 * @export
 */
var UrdesignerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UrdesignerApiFp)(configuration);
    return {
        /**
         *
         * @summary 录入方案
         * @param {UrdesignerCreateDesignReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urdesignerCreateDesign: function (body, options) {
            return localVarFp.urdesignerCreateDesign(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 创建研究目标
         * @param {UrdesignerCreateGoalReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urdesignerCreateGoal: function (body, options) {
            return localVarFp.urdesignerCreateGoal(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 研究方案
         * @param {number} goalId 研究目的id
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urdesignerListResearchDesign: function (goalId, paginationId, paginationSize, paginationHasMore, options) {
            return localVarFp.urdesignerListResearchDesign(goalId, paginationId, paginationSize, paginationHasMore, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 研究目的列表
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urdesignerListResearchGoal: function (paginationId, paginationSize, paginationHasMore, options) {
            return localVarFp.urdesignerListResearchGoal(paginationId, paginationSize, paginationHasMore, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 搜索研究目的
         * @param {UrdesignerSearchResearchGoalReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urdesignerSearchResearchGoal: function (body, options) {
            return localVarFp.urdesignerSearchResearchGoal(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UrdesignerApiFactory = UrdesignerApiFactory;
/**
 * UrdesignerApi - object-oriented interface
 * @export
 * @class UrdesignerApi
 * @extends {BaseAPI}
 */
var UrdesignerApi = /** @class */ (function (_super) {
    __extends(UrdesignerApi, _super);
    function UrdesignerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 录入方案
     * @param {UrdesignerCreateDesignReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UrdesignerApi
     */
    UrdesignerApi.prototype.urdesignerCreateDesign = function (body, options) {
        var _this = this;
        return (0, exports.UrdesignerApiFp)(this.configuration).urdesignerCreateDesign(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 创建研究目标
     * @param {UrdesignerCreateGoalReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UrdesignerApi
     */
    UrdesignerApi.prototype.urdesignerCreateGoal = function (body, options) {
        var _this = this;
        return (0, exports.UrdesignerApiFp)(this.configuration).urdesignerCreateGoal(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 研究方案
     * @param {number} goalId 研究目的id
     * @param {number} [paginationId] id 标识符.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UrdesignerApi
     */
    UrdesignerApi.prototype.urdesignerListResearchDesign = function (goalId, paginationId, paginationSize, paginationHasMore, options) {
        var _this = this;
        return (0, exports.UrdesignerApiFp)(this.configuration).urdesignerListResearchDesign(goalId, paginationId, paginationSize, paginationHasMore, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 研究目的列表
     * @param {number} [paginationId] id 标识符.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UrdesignerApi
     */
    UrdesignerApi.prototype.urdesignerListResearchGoal = function (paginationId, paginationSize, paginationHasMore, options) {
        var _this = this;
        return (0, exports.UrdesignerApiFp)(this.configuration).urdesignerListResearchGoal(paginationId, paginationSize, paginationHasMore, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 搜索研究目的
     * @param {UrdesignerSearchResearchGoalReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UrdesignerApi
     */
    UrdesignerApi.prototype.urdesignerSearchResearchGoal = function (body, options) {
        var _this = this;
        return (0, exports.UrdesignerApiFp)(this.configuration).urdesignerSearchResearchGoal(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UrdesignerApi;
}(base_1.BaseAPI));
exports.UrdesignerApi = UrdesignerApi;
/**
 * UserApi - axios parameter creator
 * @export
 */
var UserApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 授权
         * @param {string} appid 应用appid
         * @param {UserPrecodeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthorize: function (appid, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userAuthorize', 'appid', appid);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userAuthorize', 'body', body);
                    localVarPath = "/api/user/{appid}/user/precode/authrization"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 通过手机号获取用户
         * @param {UserBatchGetPhoneUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userBatchGetPhoneUser: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userBatchGetPhoneUser', 'body', body);
                    localVarPath = "/disable/api/user/batch/get-by-phone";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 批量获取统一用户的手机号信息
         * @param {UserBatchGetUserPhoneReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userBatchGetUserPhone: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userBatchGetUserPhone', 'body', body);
                    localVarPath = "/disable/api/user/batch/phone";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Oauth2 回调地址
         * @param {string} appid
         * @param {string} ua
         * @param {string} [state]
         * @param {string} [code]
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userCallback: function (appid, ua, state, code, redirectUrl, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userCallback', 'appid', appid);
                    // verify required parameter 'ua' is not null or undefined
                    (0, common_1.assertParamExists)('userCallback', 'ua', ua);
                    localVarPath = "/api/user/{appid}/oauth/{ua}/callback"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)))
                        .replace("{".concat("ua", "}"), encodeURIComponent(String(ua)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (state !== undefined) {
                        localVarQueryParameter['state'] = state;
                    }
                    if (code !== undefined) {
                        localVarQueryParameter['code'] = code;
                    }
                    if (redirectUrl !== undefined) {
                        localVarQueryParameter['redirectUrl'] = redirectUrl;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 更换手机号
         * @param {UserChangePhoneReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userChangePhone: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userChangePhone', 'body', body);
                    localVarPath = "/api/user/phone/modification";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 设计云 token 登录
         * @param {string} appid
         * @param {UserDesignCloudLoginReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDesignCloudLogin: function (appid, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userDesignCloudLogin', 'appid', appid);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userDesignCloudLogin', 'body', body);
                    localVarPath = "/api/user/{appid}/designcloud/login"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取登录地址
         * @param {string} appid 应用id
         * @param {string} [redirectUrl] 回跳地址.
         * @param {string} [ua] 登录端标识.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetLoginUrl: function (appid, redirectUrl, ua, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userGetLoginUrl', 'appid', appid);
                    localVarPath = "/api/user/{appid}/user/login/url"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (redirectUrl !== undefined) {
                        localVarQueryParameter['redirectUrl'] = redirectUrl;
                    }
                    if (ua !== undefined) {
                        localVarQueryParameter['ua'] = ua;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取小程序api的access token
         * @param {UserGetMPAccessTokenReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetMPAccessToken: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userGetMPAccessToken', 'body', body);
                    localVarPath = "/disable/api/user/mp/accesstoken";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取预授权码
         * @param {string} appid 应用的appid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetPrecode: function (appid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userGetPrecode', 'appid', appid);
                    localVarPath = "/api/user/{appid}/user/precode"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 通过预授权码获取登录状态
         * @param {string} appid 应用appid
         * @param {string} [precode] 预授权码.
         * @param {string} [domain] cookie设置域名.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetState: function (appid, precode, domain, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userGetState', 'appid', appid);
                    localVarPath = "/api/user/{appid}/user/state"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (precode !== undefined) {
                        localVarQueryParameter['precode'] = precode;
                    }
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取用户的订阅状态
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetSubscribeStatus: function (app, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('userGetSubscribeStatus', 'app', app);
                    localVarPath = "/api/user/{app}/subscribe-status"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取已登录用户的临时票据
         * @param {string} appid 应用appid
         * @param {string} [redirectUrl] 跳转地址，如果存在跳转地址，则最终跳转到一个跳转地址，不存在，默认跳转至一个后端页面.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetTempTicket: function (appid, redirectUrl, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userGetTempTicket', 'appid', appid);
                    localVarPath = "/api/user/{appid}/user/tempTicket"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (redirectUrl !== undefined) {
                        localVarQueryParameter['redirectUrl'] = redirectUrl;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 账号绑定的第三方账号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetThirdPartyAccounts: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/user/accounts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary deprecated: 获取用户信息
         * @param {string} appid 应用的appid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUser: function (appid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userGetUser', 'appid', appid);
                    localVarPath = "/api/user/{appid}/info"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取指定用户的信息
         * @param {UserGetUserInfoReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUserInfo: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userGetUserInfo', 'body', body);
                    localVarPath = "/api/user/info";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取授权票据
         * @param {string} appid 应用appid
         * @param {string} [precode] 预授权码.
         * @param {string} [domain] cookie设置域名.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUserTicket: function (appid, precode, domain, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userGetUserTicket', 'appid', appid);
                    localVarPath = "/api/user/{appid}/user/ticket"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (precode !== undefined) {
                        localVarQueryParameter['precode'] = precode;
                    }
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取用户信息
         * @param {string} appid 应用的appid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUserV2: function (appid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userGetUserV2', 'appid', appid);
                    localVarPath = "/api/user/v2/{appid}/info"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取公众号关注二维码, 带guid
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetWeChatQRCode: function (app, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('userGetWeChatQRCode', 'app', app);
                    localVarPath = "/api/user/{app}/wechat/qrcode"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取用户公众号通知渠道信息
         * @param {UserGetWechatPublicNotificationChannelReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetWechatPublicNotificationChannel: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userGetWechatPublicNotificationChannel', 'body', body);
                    localVarPath = "/disable/api/user/wechat/channel";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 锁定授权码
         * @param {string} appid 应用appid
         * @param {UserPrecodeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLockPrecode: function (appid, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userLockPrecode', 'appid', appid);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userLockPrecode', 'body', body);
                    localVarPath = "/api/user/{appid}/user/precode/lock"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 问卷临时票据登录
         * @param {string} [token]
         * @param {string} [redirectUrl]
         * @param {string} [appid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLoginByWJTicket: function (token, redirectUrl, appid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/user/wj/login/accesstoken";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (token !== undefined) {
                        localVarQueryParameter['token'] = token;
                    }
                    if (redirectUrl !== undefined) {
                        localVarQueryParameter['redirectUrl'] = redirectUrl;
                    }
                    if (appid !== undefined) {
                        localVarQueryParameter['appid'] = appid;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 通过小程序登录授权码登录
         * @param {string} appid 业务appid，不同业务调用这个接口值不一样
         * @param {UserRegisterUserByMiniProgramReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLoginWJUserByMiniProgram: function (appid, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userLoginWJUserByMiniProgram', 'appid', appid);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userLoginWJUserByMiniProgram', 'body', body);
                    localVarPath = "/api/user/{appid}/miniprogram/user/login"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary deprecated: 退出登录
         * @param {string} appid
         * @param {string} [domain]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLogout: function (appid, domain, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userLogout', 'appid', appid);
                    localVarPath = "/api/user/{appid}/logout"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 退出登录
         * @param {string} appid
         * @param {string} [domain]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLogoutV2: function (appid, domain, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userLogoutV2', 'appid', appid);
                    localVarPath = "/api/user/{appid}/logout"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 小程序分享二维码
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app 业务类型
         * @param {UserMiniprogramQRCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMiniprogramQRCode: function (app, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('userMiniprogramQRCode', 'app', app);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userMiniprogramQRCode', 'body', body);
                    localVarPath = "/api/user/{app}/mp/qrcode"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary mock用户
         * @param {string} [guid]
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMockUser: function (guid, app, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/user/user/mock/7a793ec5624";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (guid !== undefined) {
                        localVarQueryParameter['guid'] = guid;
                    }
                    if (app !== undefined) {
                        localVarQueryParameter['app'] = app;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 修改用户信息
         * @param {UserModifyUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userModifyUser: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userModifyUser', 'body', body);
                    localVarPath = "/api/user/info";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 登录重定向
         * @param {string} appid
         * @param {string} ua
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRedirect: function (appid, ua, redirectUrl, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userRedirect', 'appid', appid);
                    // verify required parameter 'ua' is not null or undefined
                    (0, common_1.assertParamExists)('userRedirect', 'ua', ua);
                    localVarPath = "/api/user/{appid}/login/{ua}/redirect"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)))
                        .replace("{".concat("ua", "}"), encodeURIComponent(String(ua)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (redirectUrl !== undefined) {
                        localVarQueryParameter['redirectUrl'] = redirectUrl;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 根据手机号绑定情况来重定向到对应地址
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {string} [bindingUrl] 需要绑定手机号的跳转地址.
         * @param {string} [bussinessUrl] 业务地址，手机号绑定成功后的地址.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRedirectAgainstPhoneBinding: function (app, bindingUrl, bussinessUrl, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('userRedirectAgainstPhoneBinding', 'app', app);
                    localVarPath = "/api/user/{app}/user/phone/binding/redirect"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (bindingUrl !== undefined) {
                        localVarQueryParameter['bindingUrl'] = bindingUrl;
                    }
                    if (bussinessUrl !== undefined) {
                        localVarQueryParameter['bussinessUrl'] = bussinessUrl;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 小程序用户登录与注册
         * @param {UserRegisterMPUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterMPUser: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userRegisterMPUser', 'body', body);
                    localVarPath = "/api/user/mp/login";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 统一账号短信验证码码登录
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app 业务id 调研云：ucloud 其余业务找borisyang注册
         * @param {UserRegisterMicroUnifiedUserBySmsCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterMicroUnifiedUserBySmsCode: function (app, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'app' is not null or undefined
                    (0, common_1.assertParamExists)('userRegisterMicroUnifiedUserBySmsCode', 'app', app);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userRegisterMicroUnifiedUserBySmsCode', 'body', body);
                    localVarPath = "/api/user/{app}/sms/unify/user/register"
                        .replace("{".concat("app", "}"), encodeURIComponent(String(app)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 注册第三方产品用户
         * @param {string} pid 产品标识
         * @param {UserRegisterProductUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterProductUser: function (pid, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pid' is not null or undefined
                    (0, common_1.assertParamExists)('userRegisterProductUser', 'pid', pid);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userRegisterProductUser', 'body', body);
                    localVarPath = "/api/user/{pid}/regster"
                        .replace("{".concat("pid", "}"), encodeURIComponent(String(pid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 通过小程序手机号授权码注册问卷用户
         * @param {string} appid 业务appid，不同业务调用这个接口值不一样
         * @param {UserRegisterWJUserByMiniProgramPhoneCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterWJUserByMiniProgramPhoneCode: function (appid, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userRegisterWJUserByMiniProgramPhoneCode', 'appid', appid);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userRegisterWJUserByMiniProgramPhoneCode', 'body', body);
                    localVarPath = "/api/user/{appid}/miniprogram/user/register"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 短信验证码登录
         * @param {string} appid 业务id 调研云：ucloud 其余业务找borisyang注册
         * @param {UserRegisterWJUserBySmsCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterWJUserBySmsCode: function (appid, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userRegisterWJUserBySmsCode', 'appid', appid);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userRegisterWJUserBySmsCode', 'body', body);
                    localVarPath = "/api/user/{appid}/sms/user/register"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 小程序端短信验证码登录,小程序会返回cookie
         * @param {string} appid 业务id 调研云：ucloud 其余业务找borisyang注册
         * @param {UserRegisterWJUserBySmsCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterWJUserBySmsCodeForMP: function (appid, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userRegisterWJUserBySmsCodeForMP', 'appid', appid);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('userRegisterWJUserBySmsCodeForMP', 'body', body);
                    localVarPath = "/api/user/{appid}/sms/mp/user/register"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 第三方网站授权跳转
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid 业务id
         * @param {string} [ticket] 临时票据.
         * @param {string} [redirectUrl] 跳转链接.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userThirdPartyAuthorizeV2: function (appid, ticket, redirectUrl, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'appid' is not null or undefined
                    (0, common_1.assertParamExists)('userThirdPartyAuthorizeV2', 'appid', appid);
                    localVarPath = "/api/user/{appid}/user/authorize-v2"
                        .replace("{".concat("appid", "}"), encodeURIComponent(String(appid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (ticket !== undefined) {
                        localVarQueryParameter['ticket'] = ticket;
                    }
                    if (redirectUrl !== undefined) {
                        localVarQueryParameter['redirectUrl'] = redirectUrl;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 解绑第三方账号
         * @param {string} [openid] 要解绑转换的openid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUnbindAccount: function (openid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/user/accounts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (openid !== undefined) {
                        localVarQueryParameter['openid'] = openid;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.UserApiAxiosParamCreator = UserApiAxiosParamCreator;
/**
 * UserApi - functional programming interface
 * @export
 */
var UserApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UserApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 授权
         * @param {string} appid 应用appid
         * @param {UserPrecodeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthorize: function (appid, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userAuthorize(appid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 通过手机号获取用户
         * @param {UserBatchGetPhoneUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userBatchGetPhoneUser: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userBatchGetPhoneUser(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 批量获取统一用户的手机号信息
         * @param {UserBatchGetUserPhoneReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userBatchGetUserPhone: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userBatchGetUserPhone(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Oauth2 回调地址
         * @param {string} appid
         * @param {string} ua
         * @param {string} [state]
         * @param {string} [code]
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userCallback: function (appid, ua, state, code, redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userCallback(appid, ua, state, code, redirectUrl, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 更换手机号
         * @param {UserChangePhoneReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userChangePhone: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userChangePhone(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 设计云 token 登录
         * @param {string} appid
         * @param {UserDesignCloudLoginReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDesignCloudLogin: function (appid, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userDesignCloudLogin(appid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取登录地址
         * @param {string} appid 应用id
         * @param {string} [redirectUrl] 回跳地址.
         * @param {string} [ua] 登录端标识.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetLoginUrl: function (appid, redirectUrl, ua, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userGetLoginUrl(appid, redirectUrl, ua, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取小程序api的access token
         * @param {UserGetMPAccessTokenReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetMPAccessToken: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userGetMPAccessToken(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取预授权码
         * @param {string} appid 应用的appid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetPrecode: function (appid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userGetPrecode(appid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 通过预授权码获取登录状态
         * @param {string} appid 应用appid
         * @param {string} [precode] 预授权码.
         * @param {string} [domain] cookie设置域名.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetState: function (appid, precode, domain, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userGetState(appid, precode, domain, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取用户的订阅状态
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetSubscribeStatus: function (app, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userGetSubscribeStatus(app, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取已登录用户的临时票据
         * @param {string} appid 应用appid
         * @param {string} [redirectUrl] 跳转地址，如果存在跳转地址，则最终跳转到一个跳转地址，不存在，默认跳转至一个后端页面.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetTempTicket: function (appid, redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userGetTempTicket(appid, redirectUrl, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 账号绑定的第三方账号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetThirdPartyAccounts: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userGetThirdPartyAccounts(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary deprecated: 获取用户信息
         * @param {string} appid 应用的appid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUser: function (appid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userGetUser(appid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取指定用户的信息
         * @param {UserGetUserInfoReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUserInfo: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userGetUserInfo(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取授权票据
         * @param {string} appid 应用appid
         * @param {string} [precode] 预授权码.
         * @param {string} [domain] cookie设置域名.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUserTicket: function (appid, precode, domain, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userGetUserTicket(appid, precode, domain, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取用户信息
         * @param {string} appid 应用的appid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUserV2: function (appid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userGetUserV2(appid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取公众号关注二维码, 带guid
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetWeChatQRCode: function (app, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userGetWeChatQRCode(app, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取用户公众号通知渠道信息
         * @param {UserGetWechatPublicNotificationChannelReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetWechatPublicNotificationChannel: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userGetWechatPublicNotificationChannel(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 锁定授权码
         * @param {string} appid 应用appid
         * @param {UserPrecodeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLockPrecode: function (appid, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userLockPrecode(appid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 问卷临时票据登录
         * @param {string} [token]
         * @param {string} [redirectUrl]
         * @param {string} [appid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLoginByWJTicket: function (token, redirectUrl, appid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userLoginByWJTicket(token, redirectUrl, appid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 通过小程序登录授权码登录
         * @param {string} appid 业务appid，不同业务调用这个接口值不一样
         * @param {UserRegisterUserByMiniProgramReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLoginWJUserByMiniProgram: function (appid, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userLoginWJUserByMiniProgram(appid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary deprecated: 退出登录
         * @param {string} appid
         * @param {string} [domain]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLogout: function (appid, domain, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userLogout(appid, domain, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 退出登录
         * @param {string} appid
         * @param {string} [domain]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLogoutV2: function (appid, domain, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userLogoutV2(appid, domain, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 小程序分享二维码
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app 业务类型
         * @param {UserMiniprogramQRCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMiniprogramQRCode: function (app, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userMiniprogramQRCode(app, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary mock用户
         * @param {string} [guid]
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMockUser: function (guid, app, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userMockUser(guid, app, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 修改用户信息
         * @param {UserModifyUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userModifyUser: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userModifyUser(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 登录重定向
         * @param {string} appid
         * @param {string} ua
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRedirect: function (appid, ua, redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userRedirect(appid, ua, redirectUrl, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 根据手机号绑定情况来重定向到对应地址
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {string} [bindingUrl] 需要绑定手机号的跳转地址.
         * @param {string} [bussinessUrl] 业务地址，手机号绑定成功后的地址.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRedirectAgainstPhoneBinding: function (app, bindingUrl, bussinessUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userRedirectAgainstPhoneBinding(app, bindingUrl, bussinessUrl, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 小程序用户登录与注册
         * @param {UserRegisterMPUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterMPUser: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userRegisterMPUser(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 统一账号短信验证码码登录
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app 业务id 调研云：ucloud 其余业务找borisyang注册
         * @param {UserRegisterMicroUnifiedUserBySmsCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterMicroUnifiedUserBySmsCode: function (app, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userRegisterMicroUnifiedUserBySmsCode(app, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 注册第三方产品用户
         * @param {string} pid 产品标识
         * @param {UserRegisterProductUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterProductUser: function (pid, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userRegisterProductUser(pid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 通过小程序手机号授权码注册问卷用户
         * @param {string} appid 业务appid，不同业务调用这个接口值不一样
         * @param {UserRegisterWJUserByMiniProgramPhoneCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterWJUserByMiniProgramPhoneCode: function (appid, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userRegisterWJUserByMiniProgramPhoneCode(appid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 短信验证码登录
         * @param {string} appid 业务id 调研云：ucloud 其余业务找borisyang注册
         * @param {UserRegisterWJUserBySmsCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterWJUserBySmsCode: function (appid, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userRegisterWJUserBySmsCode(appid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 小程序端短信验证码登录,小程序会返回cookie
         * @param {string} appid 业务id 调研云：ucloud 其余业务找borisyang注册
         * @param {UserRegisterWJUserBySmsCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterWJUserBySmsCodeForMP: function (appid, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userRegisterWJUserBySmsCodeForMP(appid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 第三方网站授权跳转
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid 业务id
         * @param {string} [ticket] 临时票据.
         * @param {string} [redirectUrl] 跳转链接.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userThirdPartyAuthorizeV2: function (appid, ticket, redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userThirdPartyAuthorizeV2(appid, ticket, redirectUrl, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 解绑第三方账号
         * @param {string} [openid] 要解绑转换的openid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUnbindAccount: function (openid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userUnbindAccount(openid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.UserApiFp = UserApiFp;
/**
 * UserApi - factory interface
 * @export
 */
var UserApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UserApiFp)(configuration);
    return {
        /**
         *
         * @summary 授权
         * @param {string} appid 应用appid
         * @param {UserPrecodeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthorize: function (appid, body, options) {
            return localVarFp.userAuthorize(appid, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 通过手机号获取用户
         * @param {UserBatchGetPhoneUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userBatchGetPhoneUser: function (body, options) {
            return localVarFp.userBatchGetPhoneUser(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 批量获取统一用户的手机号信息
         * @param {UserBatchGetUserPhoneReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userBatchGetUserPhone: function (body, options) {
            return localVarFp.userBatchGetUserPhone(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Oauth2 回调地址
         * @param {string} appid
         * @param {string} ua
         * @param {string} [state]
         * @param {string} [code]
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userCallback: function (appid, ua, state, code, redirectUrl, options) {
            return localVarFp.userCallback(appid, ua, state, code, redirectUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 更换手机号
         * @param {UserChangePhoneReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userChangePhone: function (body, options) {
            return localVarFp.userChangePhone(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 设计云 token 登录
         * @param {string} appid
         * @param {UserDesignCloudLoginReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDesignCloudLogin: function (appid, body, options) {
            return localVarFp.userDesignCloudLogin(appid, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取登录地址
         * @param {string} appid 应用id
         * @param {string} [redirectUrl] 回跳地址.
         * @param {string} [ua] 登录端标识.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetLoginUrl: function (appid, redirectUrl, ua, options) {
            return localVarFp.userGetLoginUrl(appid, redirectUrl, ua, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取小程序api的access token
         * @param {UserGetMPAccessTokenReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetMPAccessToken: function (body, options) {
            return localVarFp.userGetMPAccessToken(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取预授权码
         * @param {string} appid 应用的appid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetPrecode: function (appid, options) {
            return localVarFp.userGetPrecode(appid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 通过预授权码获取登录状态
         * @param {string} appid 应用appid
         * @param {string} [precode] 预授权码.
         * @param {string} [domain] cookie设置域名.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetState: function (appid, precode, domain, options) {
            return localVarFp.userGetState(appid, precode, domain, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取用户的订阅状态
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetSubscribeStatus: function (app, options) {
            return localVarFp.userGetSubscribeStatus(app, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取已登录用户的临时票据
         * @param {string} appid 应用appid
         * @param {string} [redirectUrl] 跳转地址，如果存在跳转地址，则最终跳转到一个跳转地址，不存在，默认跳转至一个后端页面.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetTempTicket: function (appid, redirectUrl, options) {
            return localVarFp.userGetTempTicket(appid, redirectUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 账号绑定的第三方账号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetThirdPartyAccounts: function (options) {
            return localVarFp.userGetThirdPartyAccounts(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary deprecated: 获取用户信息
         * @param {string} appid 应用的appid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUser: function (appid, options) {
            return localVarFp.userGetUser(appid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取指定用户的信息
         * @param {UserGetUserInfoReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUserInfo: function (body, options) {
            return localVarFp.userGetUserInfo(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取授权票据
         * @param {string} appid 应用appid
         * @param {string} [precode] 预授权码.
         * @param {string} [domain] cookie设置域名.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUserTicket: function (appid, precode, domain, options) {
            return localVarFp.userGetUserTicket(appid, precode, domain, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取用户信息
         * @param {string} appid 应用的appid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUserV2: function (appid, options) {
            return localVarFp.userGetUserV2(appid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取公众号关注二维码, 带guid
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetWeChatQRCode: function (app, options) {
            return localVarFp.userGetWeChatQRCode(app, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取用户公众号通知渠道信息
         * @param {UserGetWechatPublicNotificationChannelReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetWechatPublicNotificationChannel: function (body, options) {
            return localVarFp.userGetWechatPublicNotificationChannel(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 锁定授权码
         * @param {string} appid 应用appid
         * @param {UserPrecodeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLockPrecode: function (appid, body, options) {
            return localVarFp.userLockPrecode(appid, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 问卷临时票据登录
         * @param {string} [token]
         * @param {string} [redirectUrl]
         * @param {string} [appid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLoginByWJTicket: function (token, redirectUrl, appid, options) {
            return localVarFp.userLoginByWJTicket(token, redirectUrl, appid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 通过小程序登录授权码登录
         * @param {string} appid 业务appid，不同业务调用这个接口值不一样
         * @param {UserRegisterUserByMiniProgramReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLoginWJUserByMiniProgram: function (appid, body, options) {
            return localVarFp.userLoginWJUserByMiniProgram(appid, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary deprecated: 退出登录
         * @param {string} appid
         * @param {string} [domain]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLogout: function (appid, domain, options) {
            return localVarFp.userLogout(appid, domain, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 退出登录
         * @param {string} appid
         * @param {string} [domain]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLogoutV2: function (appid, domain, options) {
            return localVarFp.userLogoutV2(appid, domain, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 小程序分享二维码
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app 业务类型
         * @param {UserMiniprogramQRCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMiniprogramQRCode: function (app, body, options) {
            return localVarFp.userMiniprogramQRCode(app, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary mock用户
         * @param {string} [guid]
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMockUser: function (guid, app, options) {
            return localVarFp.userMockUser(guid, app, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 修改用户信息
         * @param {UserModifyUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userModifyUser: function (body, options) {
            return localVarFp.userModifyUser(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 登录重定向
         * @param {string} appid
         * @param {string} ua
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRedirect: function (appid, ua, redirectUrl, options) {
            return localVarFp.userRedirect(appid, ua, redirectUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 根据手机号绑定情况来重定向到对应地址
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
         * @param {string} [bindingUrl] 需要绑定手机号的跳转地址.
         * @param {string} [bussinessUrl] 业务地址，手机号绑定成功后的地址.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRedirectAgainstPhoneBinding: function (app, bindingUrl, bussinessUrl, options) {
            return localVarFp.userRedirectAgainstPhoneBinding(app, bindingUrl, bussinessUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 小程序用户登录与注册
         * @param {UserRegisterMPUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterMPUser: function (body, options) {
            return localVarFp.userRegisterMPUser(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 统一账号短信验证码码登录
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app 业务id 调研云：ucloud 其余业务找borisyang注册
         * @param {UserRegisterMicroUnifiedUserBySmsCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterMicroUnifiedUserBySmsCode: function (app, body, options) {
            return localVarFp.userRegisterMicroUnifiedUserBySmsCode(app, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 注册第三方产品用户
         * @param {string} pid 产品标识
         * @param {UserRegisterProductUserReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterProductUser: function (pid, body, options) {
            return localVarFp.userRegisterProductUser(pid, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 通过小程序手机号授权码注册问卷用户
         * @param {string} appid 业务appid，不同业务调用这个接口值不一样
         * @param {UserRegisterWJUserByMiniProgramPhoneCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterWJUserByMiniProgramPhoneCode: function (appid, body, options) {
            return localVarFp.userRegisterWJUserByMiniProgramPhoneCode(appid, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 短信验证码登录
         * @param {string} appid 业务id 调研云：ucloud 其余业务找borisyang注册
         * @param {UserRegisterWJUserBySmsCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterWJUserBySmsCode: function (appid, body, options) {
            return localVarFp.userRegisterWJUserBySmsCode(appid, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 小程序端短信验证码登录,小程序会返回cookie
         * @param {string} appid 业务id 调研云：ucloud 其余业务找borisyang注册
         * @param {UserRegisterWJUserBySmsCodeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterWJUserBySmsCodeForMP: function (appid, body, options) {
            return localVarFp.userRegisterWJUserBySmsCodeForMP(appid, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 第三方网站授权跳转
         * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid 业务id
         * @param {string} [ticket] 临时票据.
         * @param {string} [redirectUrl] 跳转链接.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userThirdPartyAuthorizeV2: function (appid, ticket, redirectUrl, options) {
            return localVarFp.userThirdPartyAuthorizeV2(appid, ticket, redirectUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 解绑第三方账号
         * @param {string} [openid] 要解绑转换的openid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUnbindAccount: function (openid, options) {
            return localVarFp.userUnbindAccount(openid, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UserApiFactory = UserApiFactory;
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
var UserApi = /** @class */ (function (_super) {
    __extends(UserApi, _super);
    function UserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 授权
     * @param {string} appid 应用appid
     * @param {UserPrecodeRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userAuthorize = function (appid, body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userAuthorize(appid, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 通过手机号获取用户
     * @param {UserBatchGetPhoneUserReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userBatchGetPhoneUser = function (body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userBatchGetPhoneUser(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 批量获取统一用户的手机号信息
     * @param {UserBatchGetUserPhoneReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userBatchGetUserPhone = function (body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userBatchGetUserPhone(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Oauth2 回调地址
     * @param {string} appid
     * @param {string} ua
     * @param {string} [state]
     * @param {string} [code]
     * @param {string} [redirectUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userCallback = function (appid, ua, state, code, redirectUrl, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userCallback(appid, ua, state, code, redirectUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 更换手机号
     * @param {UserChangePhoneReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userChangePhone = function (body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userChangePhone(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 设计云 token 登录
     * @param {string} appid
     * @param {UserDesignCloudLoginReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userDesignCloudLogin = function (appid, body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userDesignCloudLogin(appid, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取登录地址
     * @param {string} appid 应用id
     * @param {string} [redirectUrl] 回跳地址.
     * @param {string} [ua] 登录端标识.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userGetLoginUrl = function (appid, redirectUrl, ua, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userGetLoginUrl(appid, redirectUrl, ua, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取小程序api的access token
     * @param {UserGetMPAccessTokenReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userGetMPAccessToken = function (body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userGetMPAccessToken(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取预授权码
     * @param {string} appid 应用的appid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userGetPrecode = function (appid, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userGetPrecode(appid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 通过预授权码获取登录状态
     * @param {string} appid 应用appid
     * @param {string} [precode] 预授权码.
     * @param {string} [domain] cookie设置域名.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userGetState = function (appid, precode, domain, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userGetState(appid, precode, domain, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取用户的订阅状态
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userGetSubscribeStatus = function (app, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userGetSubscribeStatus(app, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取已登录用户的临时票据
     * @param {string} appid 应用appid
     * @param {string} [redirectUrl] 跳转地址，如果存在跳转地址，则最终跳转到一个跳转地址，不存在，默认跳转至一个后端页面.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userGetTempTicket = function (appid, redirectUrl, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userGetTempTicket(appid, redirectUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 账号绑定的第三方账号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userGetThirdPartyAccounts = function (options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userGetThirdPartyAccounts(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary deprecated: 获取用户信息
     * @param {string} appid 应用的appid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userGetUser = function (appid, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userGetUser(appid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取指定用户的信息
     * @param {UserGetUserInfoReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userGetUserInfo = function (body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userGetUserInfo(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取授权票据
     * @param {string} appid 应用appid
     * @param {string} [precode] 预授权码.
     * @param {string} [domain] cookie设置域名.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userGetUserTicket = function (appid, precode, domain, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userGetUserTicket(appid, precode, domain, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取用户信息
     * @param {string} appid 应用的appid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userGetUserV2 = function (appid, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userGetUserV2(appid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取公众号关注二维码, 带guid
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userGetWeChatQRCode = function (app, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userGetWeChatQRCode(app, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取用户公众号通知渠道信息
     * @param {UserGetWechatPublicNotificationChannelReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userGetWechatPublicNotificationChannel = function (body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userGetWechatPublicNotificationChannel(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 锁定授权码
     * @param {string} appid 应用appid
     * @param {UserPrecodeRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userLockPrecode = function (appid, body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userLockPrecode(appid, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 问卷临时票据登录
     * @param {string} [token]
     * @param {string} [redirectUrl]
     * @param {string} [appid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userLoginByWJTicket = function (token, redirectUrl, appid, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userLoginByWJTicket(token, redirectUrl, appid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 通过小程序登录授权码登录
     * @param {string} appid 业务appid，不同业务调用这个接口值不一样
     * @param {UserRegisterUserByMiniProgramReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userLoginWJUserByMiniProgram = function (appid, body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userLoginWJUserByMiniProgram(appid, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary deprecated: 退出登录
     * @param {string} appid
     * @param {string} [domain]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userLogout = function (appid, domain, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userLogout(appid, domain, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 退出登录
     * @param {string} appid
     * @param {string} [domain]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userLogoutV2 = function (appid, domain, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userLogoutV2(appid, domain, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 小程序分享二维码
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app 业务类型
     * @param {UserMiniprogramQRCodeReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userMiniprogramQRCode = function (app, body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userMiniprogramQRCode(app, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary mock用户
     * @param {string} [guid]
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} [app]  - RESEARCH: 调研云  - TXC: 兔小巢  - AILOGO: ailogo  - WJ: 问卷  - TECHFORGOOD: 技术公益测试使用  - TECHFORGOOD_PORTAL: 技术公益官网 已废弃  - TECHFORGOOD_ADMIN: 技术公益管理后台 已废弃  - TECHFORGOODPORTAL: 技术公益官网  - TECHFORGOODADMIN: 技术公益管理后台  - TECHFORGOODPORTALTEST: 供应商无法访问测试环境，所以新增了2个测试的类型 技术公益官网测试  - TECHFORGOODADMINTEST: 技术公益管理后台测试  - TECHFORGOODPX: 技术公益赛事评选  - TECHFORGOODPXTEST: 技术公益赛事评选测试  - TIDAL: 数据平台
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userMockUser = function (guid, app, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userMockUser(guid, app, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 修改用户信息
     * @param {UserModifyUserReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userModifyUser = function (body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userModifyUser(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 登录重定向
     * @param {string} appid
     * @param {string} ua
     * @param {string} [redirectUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userRedirect = function (appid, ua, redirectUrl, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userRedirect(appid, ua, redirectUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 根据手机号绑定情况来重定向到对应地址
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app
     * @param {string} [bindingUrl] 需要绑定手机号的跳转地址.
     * @param {string} [bussinessUrl] 业务地址，手机号绑定成功后的地址.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userRedirectAgainstPhoneBinding = function (app, bindingUrl, bussinessUrl, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userRedirectAgainstPhoneBinding(app, bindingUrl, bussinessUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 小程序用户登录与注册
     * @param {UserRegisterMPUserReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userRegisterMPUser = function (body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userRegisterMPUser(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 统一账号短信验证码码登录
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} app 业务id 调研云：ucloud 其余业务找borisyang注册
     * @param {UserRegisterMicroUnifiedUserBySmsCodeReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userRegisterMicroUnifiedUserBySmsCode = function (app, body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userRegisterMicroUnifiedUserBySmsCode(app, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 注册第三方产品用户
     * @param {string} pid 产品标识
     * @param {UserRegisterProductUserReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userRegisterProductUser = function (pid, body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userRegisterProductUser(pid, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 通过小程序手机号授权码注册问卷用户
     * @param {string} appid 业务appid，不同业务调用这个接口值不一样
     * @param {UserRegisterWJUserByMiniProgramPhoneCodeReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userRegisterWJUserByMiniProgramPhoneCode = function (appid, body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userRegisterWJUserByMiniProgramPhoneCode(appid, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 短信验证码登录
     * @param {string} appid 业务id 调研云：ucloud 其余业务找borisyang注册
     * @param {UserRegisterWJUserBySmsCodeReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userRegisterWJUserBySmsCode = function (appid, body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userRegisterWJUserBySmsCode(appid, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 小程序端短信验证码登录,小程序会返回cookie
     * @param {string} appid 业务id 调研云：ucloud 其余业务找borisyang注册
     * @param {UserRegisterWJUserBySmsCodeReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userRegisterWJUserBySmsCodeForMP = function (appid, body, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userRegisterWJUserBySmsCodeForMP(appid, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 第三方网站授权跳转
     * @param {'APPLICATION_INVALID' | 'RESEARCH' | 'TXC' | 'AILOGO' | 'WJ' | 'TECHFORGOOD' | 'TECHFORGOOD_PORTAL' | 'TECHFORGOOD_ADMIN' | 'TECHFORGOODPORTAL' | 'TECHFORGOODADMIN' | 'TECHFORGOODPORTALTEST' | 'TECHFORGOODADMINTEST' | 'TECHFORGOODPX' | 'TECHFORGOODPXTEST' | 'TIDAL'} appid 业务id
     * @param {string} [ticket] 临时票据.
     * @param {string} [redirectUrl] 跳转链接.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userThirdPartyAuthorizeV2 = function (appid, ticket, redirectUrl, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userThirdPartyAuthorizeV2(appid, ticket, redirectUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 解绑第三方账号
     * @param {string} [openid] 要解绑转换的openid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userUnbindAccount = function (openid, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userUnbindAccount(openid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UserApi;
}(base_1.BaseAPI));
exports.UserApi = UserApi;
/**
 * UseractionApi - axios parameter creator
 * @export
 */
var UseractionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 批量获取实体的互动信息，多个实体，互动数、是否操作
         * @param {UseractionActionInfosReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionActionInfos: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('useractionActionInfos', 'body', body);
                    localVarPath = "/api/useraction/action-infos";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 收藏行为--添加收藏
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {UseractionAddCollectReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionAddCollect: function (entityType, entityId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionAddCollect', 'entityType', entityType);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('useractionAddCollect', 'entityId', entityId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('useractionAddCollect', 'body', body);
                    localVarPath = "/api/useraction/collect/{entity.type}/{entity.id}"
                        .replace("{".concat("entity.type", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("entity.id", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 点赞行为--添加点赞
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {UseractionAddLikeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionAddLike: function (entityType, entityId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionAddLike', 'entityType', entityType);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('useractionAddLike', 'entityId', entityId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('useractionAddLike', 'body', body);
                    localVarPath = "/api/useraction/like/{entity.type}/{entity.id}"
                        .replace("{".concat("entity.type", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("entity.id", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 分享行为--添加分享
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {UseractionAddShareReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionAddShare: function (entityType, entityId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionAddShare', 'entityType', entityType);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('useractionAddShare', 'entityId', entityId);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('useractionAddShare', 'body', body);
                    localVarPath = "/api/useraction/share/{entity.type}/{entity.id}"
                        .replace("{".concat("entity.type", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("entity.id", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 批量获取行为信息，多个互动、多个实体
         * @param {UseractionBatchActionInfoReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchActionInfo: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('useractionBatchActionInfo', 'body', body);
                    localVarPath = "/api/useraction/batch-info";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 收藏行为--批量取消收藏
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchCancelCollect: function (entitiesType, entitiesIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entitiesType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionBatchCancelCollect', 'entitiesType', entitiesType);
                    localVarPath = "/api/useraction/batch-collect/{entities.type}"
                        .replace("{".concat("entities.type", "}"), encodeURIComponent(String(entitiesType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (entitiesIds) {
                        localVarQueryParameter['entities.ids'] = entitiesIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 收藏行为--批量获取收藏信息
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchCollectedInfo: function (entitiesType, entitiesIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entitiesType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionBatchCollectedInfo', 'entitiesType', entitiesType);
                    localVarPath = "/api/useraction/batch-collected-info/{entities.type}"
                        .replace("{".concat("entities.type", "}"), encodeURIComponent(String(entitiesType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (entitiesIds) {
                        localVarQueryParameter['entities.ids'] = entitiesIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 收藏行为--批量获取收藏次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchGetCollectedCount: function (entitiesType, entitiesIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entitiesType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionBatchGetCollectedCount', 'entitiesType', entitiesType);
                    localVarPath = "/api/useraction/batch-collected-count/{entities.type}"
                        .replace("{".concat("entities.type", "}"), encodeURIComponent(String(entitiesType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (entitiesIds) {
                        localVarQueryParameter['entities.ids'] = entitiesIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 评论行为--批量获取评论次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchGetCommentedCount: function (entitiesType, entitiesIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entitiesType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionBatchGetCommentedCount', 'entitiesType', entitiesType);
                    localVarPath = "/api/useraction/batch-commented-count/{entities.type}"
                        .replace("{".concat("entities.type", "}"), encodeURIComponent(String(entitiesType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (entitiesIds) {
                        localVarQueryParameter['entities.ids'] = entitiesIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 点赞行为--批量获取点赞次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchGetLikedCount: function (entitiesType, entitiesIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entitiesType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionBatchGetLikedCount', 'entitiesType', entitiesType);
                    localVarPath = "/api/useraction/batch-liked-count/{entities.type}"
                        .replace("{".concat("entities.type", "}"), encodeURIComponent(String(entitiesType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (entitiesIds) {
                        localVarQueryParameter['entities.ids'] = entitiesIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 分享行为--批量获取分享次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchGetSharedCount: function (entitiesType, entitiesIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entitiesType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionBatchGetSharedCount', 'entitiesType', entitiesType);
                    localVarPath = "/api/useraction/batch-shared-count/{entities.type}"
                        .replace("{".concat("entities.type", "}"), encodeURIComponent(String(entitiesType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (entitiesIds) {
                        localVarQueryParameter['entities.ids'] = entitiesIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 点赞行为--批量获取点赞信息
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchLikedInfo: function (entitiesType, entitiesIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entitiesType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionBatchLikedInfo', 'entitiesType', entitiesType);
                    localVarPath = "/api/useraction/batch-liked-info/{entities.type}"
                        .replace("{".concat("entities.type", "}"), encodeURIComponent(String(entitiesType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (entitiesIds) {
                        localVarQueryParameter['entities.ids'] = entitiesIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 收藏行为--取消收藏
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionCancelCollect: function (entityType, entityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionCancelCollect', 'entityType', entityType);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('useractionCancelCollect', 'entityId', entityId);
                    localVarPath = "/api/useraction/collect/{entity.type}/{entity.id}"
                        .replace("{".concat("entity.type", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("entity.id", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 点赞行为--取消点赞
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionCancelLike: function (entityType, entityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionCancelLike', 'entityType', entityType);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('useractionCancelLike', 'entityId', entityId);
                    localVarPath = "/api/useraction/like/{entity.type}/{entity.id}"
                        .replace("{".concat("entity.type", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("entity.id", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 收藏行为--收藏信息
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionCollectedInfo: function (entityType, entityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionCollectedInfo', 'entityType', entityType);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('useractionCollectedInfo', 'entityId', entityId);
                    localVarPath = "/api/useraction/collected-info/{entity.type}/{entity.id}"
                        .replace("{".concat("entity.type", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("entity.id", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 收藏行为--获取收藏次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetCollectedCount: function (entityType, entityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionGetCollectedCount', 'entityType', entityType);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('useractionGetCollectedCount', 'entityId', entityId);
                    localVarPath = "/api/useraction/collected-count/{entity.type}/{entity.id}"
                        .replace("{".concat("entity.type", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("entity.id", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 收藏行为--某个用户收藏的实体列表
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {number} [paginationCursorLast] uint32 top &#x3D; 1; last 向后翻页.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetCollectedEntityList: function (entityType, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionGetCollectedEntityList', 'entityType', entityType);
                    localVarPath = "/api/useraction/collected-entity-list/{entity_type}"
                        .replace("{".concat("entity_type", "}"), encodeURIComponent(String(entityType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationId !== undefined) {
                        localVarQueryParameter['pagination.id'] = paginationId;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.has_more'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (paginationCursorLast !== undefined) {
                        localVarQueryParameter['pagination.cursor.last'] = paginationCursorLast;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 评论行为--获取评论次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetCommentedCount: function (entityType, entityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionGetCommentedCount', 'entityType', entityType);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('useractionGetCommentedCount', 'entityId', entityId);
                    localVarPath = "/api/useraction/commented-count/{entity.type}/{entity.id}"
                        .replace("{".concat("entity.type", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("entity.id", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 点赞行为--获取点赞次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetLikedCount: function (entityType, entityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionGetLikedCount', 'entityType', entityType);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('useractionGetLikedCount', 'entityId', entityId);
                    localVarPath = "/api/useraction/liked-count/{entity.type}/{entity.id}"
                        .replace("{".concat("entity.type", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("entity.id", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 点赞行为--某个用户点赞的实体列表
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {number} [paginationCursorLast] uint32 top &#x3D; 1; last 向后翻页.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetLikedEntityList: function (entityType, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionGetLikedEntityList', 'entityType', entityType);
                    localVarPath = "/api/useraction/liked-entity-list/{entity_type}"
                        .replace("{".concat("entity_type", "}"), encodeURIComponent(String(entityType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationId !== undefined) {
                        localVarQueryParameter['pagination.id'] = paginationId;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.has_more'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (paginationCursorLast !== undefined) {
                        localVarQueryParameter['pagination.cursor.last'] = paginationCursorLast;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 点赞行为--对某个实体点赞的用户列表
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {number} [paginationCursorLast] uint32 top &#x3D; 1; last 向后翻页.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetLikedUserList: function (entityType, entityId, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionGetLikedUserList', 'entityType', entityType);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('useractionGetLikedUserList', 'entityId', entityId);
                    localVarPath = "/api/useraction/liked-user-list/{entity.type}/{entity.id}"
                        .replace("{".concat("entity.type", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("entity.id", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationId !== undefined) {
                        localVarQueryParameter['pagination.id'] = paginationId;
                    }
                    if (paginationSize !== undefined) {
                        localVarQueryParameter['pagination.size'] = paginationSize;
                    }
                    if (paginationHasMore !== undefined) {
                        localVarQueryParameter['pagination.has_more'] = paginationHasMore;
                    }
                    if (paginationTotal !== undefined) {
                        localVarQueryParameter['pagination.total'] = paginationTotal;
                    }
                    if (paginationCursorLast !== undefined) {
                        localVarQueryParameter['pagination.cursor.last'] = paginationCursorLast;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 分享行为--获取分享次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetSharedCount: function (entityType, entityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionGetSharedCount', 'entityType', entityType);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('useractionGetSharedCount', 'entityId', entityId);
                    localVarPath = "/api/useraction/shared-count/{entity.type}/{entity.id}"
                        .replace("{".concat("entity.type", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("entity.id", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 点赞行为--获取点赞信息
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionLikedInfo: function (entityType, entityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'entityType' is not null or undefined
                    (0, common_1.assertParamExists)('useractionLikedInfo', 'entityType', entityType);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('useractionLikedInfo', 'entityId', entityId);
                    localVarPath = "/api/useraction/liked-info/{entity.type}/{entity.id}"
                        .replace("{".concat("entity.type", "}"), encodeURIComponent(String(entityType)))
                        .replace("{".concat("entity.id", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.UseractionApiAxiosParamCreator = UseractionApiAxiosParamCreator;
/**
 * UseractionApi - functional programming interface
 * @export
 */
var UseractionApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UseractionApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 批量获取实体的互动信息，多个实体，互动数、是否操作
         * @param {UseractionActionInfosReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionActionInfos: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionActionInfos(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 收藏行为--添加收藏
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {UseractionAddCollectReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionAddCollect: function (entityType, entityId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionAddCollect(entityType, entityId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 点赞行为--添加点赞
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {UseractionAddLikeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionAddLike: function (entityType, entityId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionAddLike(entityType, entityId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 分享行为--添加分享
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {UseractionAddShareReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionAddShare: function (entityType, entityId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionAddShare(entityType, entityId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 批量获取行为信息，多个互动、多个实体
         * @param {UseractionBatchActionInfoReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchActionInfo: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionBatchActionInfo(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 收藏行为--批量取消收藏
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchCancelCollect: function (entitiesType, entitiesIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionBatchCancelCollect(entitiesType, entitiesIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 收藏行为--批量获取收藏信息
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchCollectedInfo: function (entitiesType, entitiesIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionBatchCollectedInfo(entitiesType, entitiesIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 收藏行为--批量获取收藏次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchGetCollectedCount: function (entitiesType, entitiesIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionBatchGetCollectedCount(entitiesType, entitiesIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 评论行为--批量获取评论次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchGetCommentedCount: function (entitiesType, entitiesIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionBatchGetCommentedCount(entitiesType, entitiesIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 点赞行为--批量获取点赞次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchGetLikedCount: function (entitiesType, entitiesIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionBatchGetLikedCount(entitiesType, entitiesIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 分享行为--批量获取分享次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchGetSharedCount: function (entitiesType, entitiesIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionBatchGetSharedCount(entitiesType, entitiesIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 点赞行为--批量获取点赞信息
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchLikedInfo: function (entitiesType, entitiesIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionBatchLikedInfo(entitiesType, entitiesIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 收藏行为--取消收藏
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionCancelCollect: function (entityType, entityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionCancelCollect(entityType, entityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 点赞行为--取消点赞
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionCancelLike: function (entityType, entityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionCancelLike(entityType, entityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 收藏行为--收藏信息
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionCollectedInfo: function (entityType, entityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionCollectedInfo(entityType, entityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 收藏行为--获取收藏次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetCollectedCount: function (entityType, entityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionGetCollectedCount(entityType, entityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 收藏行为--某个用户收藏的实体列表
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {number} [paginationCursorLast] uint32 top &#x3D; 1; last 向后翻页.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetCollectedEntityList: function (entityType, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionGetCollectedEntityList(entityType, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 评论行为--获取评论次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetCommentedCount: function (entityType, entityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionGetCommentedCount(entityType, entityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 点赞行为--获取点赞次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetLikedCount: function (entityType, entityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionGetLikedCount(entityType, entityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 点赞行为--某个用户点赞的实体列表
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {number} [paginationCursorLast] uint32 top &#x3D; 1; last 向后翻页.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetLikedEntityList: function (entityType, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionGetLikedEntityList(entityType, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 点赞行为--对某个实体点赞的用户列表
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {number} [paginationCursorLast] uint32 top &#x3D; 1; last 向后翻页.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetLikedUserList: function (entityType, entityId, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionGetLikedUserList(entityType, entityId, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 分享行为--获取分享次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetSharedCount: function (entityType, entityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionGetSharedCount(entityType, entityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 点赞行为--获取点赞信息
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionLikedInfo: function (entityType, entityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.useractionLikedInfo(entityType, entityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.UseractionApiFp = UseractionApiFp;
/**
 * UseractionApi - factory interface
 * @export
 */
var UseractionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UseractionApiFp)(configuration);
    return {
        /**
         *
         * @summary 批量获取实体的互动信息，多个实体，互动数、是否操作
         * @param {UseractionActionInfosReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionActionInfos: function (body, options) {
            return localVarFp.useractionActionInfos(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 收藏行为--添加收藏
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {UseractionAddCollectReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionAddCollect: function (entityType, entityId, body, options) {
            return localVarFp.useractionAddCollect(entityType, entityId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 点赞行为--添加点赞
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {UseractionAddLikeReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionAddLike: function (entityType, entityId, body, options) {
            return localVarFp.useractionAddLike(entityType, entityId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 分享行为--添加分享
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {UseractionAddShareReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionAddShare: function (entityType, entityId, body, options) {
            return localVarFp.useractionAddShare(entityType, entityId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 批量获取行为信息，多个互动、多个实体
         * @param {UseractionBatchActionInfoReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchActionInfo: function (body, options) {
            return localVarFp.useractionBatchActionInfo(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 收藏行为--批量取消收藏
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchCancelCollect: function (entitiesType, entitiesIds, options) {
            return localVarFp.useractionBatchCancelCollect(entitiesType, entitiesIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 收藏行为--批量获取收藏信息
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchCollectedInfo: function (entitiesType, entitiesIds, options) {
            return localVarFp.useractionBatchCollectedInfo(entitiesType, entitiesIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 收藏行为--批量获取收藏次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchGetCollectedCount: function (entitiesType, entitiesIds, options) {
            return localVarFp.useractionBatchGetCollectedCount(entitiesType, entitiesIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 评论行为--批量获取评论次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchGetCommentedCount: function (entitiesType, entitiesIds, options) {
            return localVarFp.useractionBatchGetCommentedCount(entitiesType, entitiesIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 点赞行为--批量获取点赞次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchGetLikedCount: function (entitiesType, entitiesIds, options) {
            return localVarFp.useractionBatchGetLikedCount(entitiesType, entitiesIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 分享行为--批量获取分享次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchGetSharedCount: function (entitiesType, entitiesIds, options) {
            return localVarFp.useractionBatchGetSharedCount(entitiesType, entitiesIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 点赞行为--批量获取点赞信息
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
         * @param {Array<string>} [entitiesIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionBatchLikedInfo: function (entitiesType, entitiesIds, options) {
            return localVarFp.useractionBatchLikedInfo(entitiesType, entitiesIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 收藏行为--取消收藏
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionCancelCollect: function (entityType, entityId, options) {
            return localVarFp.useractionCancelCollect(entityType, entityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 点赞行为--取消点赞
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionCancelLike: function (entityType, entityId, options) {
            return localVarFp.useractionCancelLike(entityType, entityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 收藏行为--收藏信息
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionCollectedInfo: function (entityType, entityId, options) {
            return localVarFp.useractionCollectedInfo(entityType, entityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 收藏行为--获取收藏次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetCollectedCount: function (entityType, entityId, options) {
            return localVarFp.useractionGetCollectedCount(entityType, entityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 收藏行为--某个用户收藏的实体列表
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {number} [paginationCursorLast] uint32 top &#x3D; 1; last 向后翻页.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetCollectedEntityList: function (entityType, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options) {
            return localVarFp.useractionGetCollectedEntityList(entityType, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 评论行为--获取评论次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetCommentedCount: function (entityType, entityId, options) {
            return localVarFp.useractionGetCommentedCount(entityType, entityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 点赞行为--获取点赞次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetLikedCount: function (entityType, entityId, options) {
            return localVarFp.useractionGetLikedCount(entityType, entityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 点赞行为--某个用户点赞的实体列表
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {number} [paginationCursorLast] uint32 top &#x3D; 1; last 向后翻页.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetLikedEntityList: function (entityType, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options) {
            return localVarFp.useractionGetLikedEntityList(entityType, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 点赞行为--对某个实体点赞的用户列表
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {number} [paginationId] id 标识符.
         * @param {number} [paginationSize] 页数量.
         * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
         * @param {number} [paginationTotal] 总数.
         * @param {number} [paginationCursorLast] uint32 top &#x3D; 1; last 向后翻页.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetLikedUserList: function (entityType, entityId, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options) {
            return localVarFp.useractionGetLikedUserList(entityType, entityId, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 分享行为--获取分享次数
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionGetSharedCount: function (entityType, entityId, options) {
            return localVarFp.useractionGetSharedCount(entityType, entityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 点赞行为--获取点赞信息
         * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useractionLikedInfo: function (entityType, entityId, options) {
            return localVarFp.useractionLikedInfo(entityType, entityId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UseractionApiFactory = UseractionApiFactory;
/**
 * UseractionApi - object-oriented interface
 * @export
 * @class UseractionApi
 * @extends {BaseAPI}
 */
var UseractionApi = /** @class */ (function (_super) {
    __extends(UseractionApi, _super);
    function UseractionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 批量获取实体的互动信息，多个实体，互动数、是否操作
     * @param {UseractionActionInfosReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionActionInfos = function (body, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionActionInfos(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 收藏行为--添加收藏
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} entityId
     * @param {UseractionAddCollectReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionAddCollect = function (entityType, entityId, body, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionAddCollect(entityType, entityId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 点赞行为--添加点赞
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} entityId
     * @param {UseractionAddLikeReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionAddLike = function (entityType, entityId, body, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionAddLike(entityType, entityId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 分享行为--添加分享
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} entityId
     * @param {UseractionAddShareReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionAddShare = function (entityType, entityId, body, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionAddShare(entityType, entityId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 批量获取行为信息，多个互动、多个实体
     * @param {UseractionBatchActionInfoReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionBatchActionInfo = function (body, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionBatchActionInfo(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 收藏行为--批量取消收藏
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
     * @param {Array<string>} [entitiesIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionBatchCancelCollect = function (entitiesType, entitiesIds, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionBatchCancelCollect(entitiesType, entitiesIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 收藏行为--批量获取收藏信息
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
     * @param {Array<string>} [entitiesIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionBatchCollectedInfo = function (entitiesType, entitiesIds, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionBatchCollectedInfo(entitiesType, entitiesIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 收藏行为--批量获取收藏次数
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
     * @param {Array<string>} [entitiesIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionBatchGetCollectedCount = function (entitiesType, entitiesIds, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionBatchGetCollectedCount(entitiesType, entitiesIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 评论行为--批量获取评论次数
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
     * @param {Array<string>} [entitiesIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionBatchGetCommentedCount = function (entitiesType, entitiesIds, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionBatchGetCommentedCount(entitiesType, entitiesIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 点赞行为--批量获取点赞次数
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
     * @param {Array<string>} [entitiesIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionBatchGetLikedCount = function (entitiesType, entitiesIds, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionBatchGetLikedCount(entitiesType, entitiesIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 分享行为--批量获取分享次数
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
     * @param {Array<string>} [entitiesIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionBatchGetSharedCount = function (entitiesType, entitiesIds, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionBatchGetSharedCount(entitiesType, entitiesIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 点赞行为--批量获取点赞信息
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entitiesType
     * @param {Array<string>} [entitiesIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionBatchLikedInfo = function (entitiesType, entitiesIds, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionBatchLikedInfo(entitiesType, entitiesIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 收藏行为--取消收藏
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionCancelCollect = function (entityType, entityId, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionCancelCollect(entityType, entityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 点赞行为--取消点赞
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionCancelLike = function (entityType, entityId, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionCancelLike(entityType, entityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 收藏行为--收藏信息
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionCollectedInfo = function (entityType, entityId, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionCollectedInfo(entityType, entityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 收藏行为--获取收藏次数
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionGetCollectedCount = function (entityType, entityId, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionGetCollectedCount(entityType, entityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 收藏行为--某个用户收藏的实体列表
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {number} [paginationId] id 标识符.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {number} [paginationCursorLast] uint32 top &#x3D; 1; last 向后翻页.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionGetCollectedEntityList = function (entityType, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionGetCollectedEntityList(entityType, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 评论行为--获取评论次数
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionGetCommentedCount = function (entityType, entityId, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionGetCommentedCount(entityType, entityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 点赞行为--获取点赞次数
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionGetLikedCount = function (entityType, entityId, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionGetLikedCount(entityType, entityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 点赞行为--某个用户点赞的实体列表
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {number} [paginationId] id 标识符.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {number} [paginationCursorLast] uint32 top &#x3D; 1; last 向后翻页.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionGetLikedEntityList = function (entityType, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionGetLikedEntityList(entityType, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 点赞行为--对某个实体点赞的用户列表
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} entityId
     * @param {number} [paginationId] id 标识符.
     * @param {number} [paginationSize] 页数量.
     * @param {boolean} [paginationHasMore] 是否下一页有数据,该参数不用传递，仅在返回值有效.
     * @param {number} [paginationTotal] 总数.
     * @param {number} [paginationCursorLast] uint32 top &#x3D; 1; last 向后翻页.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionGetLikedUserList = function (entityType, entityId, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionGetLikedUserList(entityType, entityId, paginationId, paginationSize, paginationHasMore, paginationTotal, paginationCursorLast, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 分享行为--获取分享次数
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionGetSharedCount = function (entityType, entityId, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionGetSharedCount(entityType, entityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 点赞行为--获取点赞信息
     * @param {'UNDEFINED' | 'ResearchReport' | 'Comment' | 'Article' | 'RegisteredNPS' | 'Research' | 'TXCTopic'} entityType
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UseractionApi
     */
    UseractionApi.prototype.useractionLikedInfo = function (entityType, entityId, options) {
        var _this = this;
        return (0, exports.UseractionApiFp)(this.configuration).useractionLikedInfo(entityType, entityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UseractionApi;
}(base_1.BaseAPI));
exports.UseractionApi = UseractionApi;
/**
 * WJApi - axios parameter creator
 * @export
 */
var WJApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 修改问卷用户头像和昵称
         * @param {string} id 用户id
         * @param {WjChangeUserInfoReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wJChangeUserInfo: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('wJChangeUserInfo', 'id', id);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('wJChangeUserInfo', 'body', body);
                    localVarPath = "/api/wj/user/{id}/info"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wJGetUser: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('wJGetUser', 'body', body);
                    localVarPath = "/disable/api/wj";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {WjRegisterUserByPhoneReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wJRegisterUserByPhone: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('wJRegisterUserByPhone', 'body', body);
                    localVarPath = "/disable/api/wj/user/register";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 解绑指定类型的账号
         * @param {'TENCENT_MEETING' | 'WECHAT' | 'QQ' | 'RTX'} provider 解绑的账号类型
         * @param {WjUnbindProviderReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wJUnbindProvider: function (provider, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'provider' is not null or undefined
                    (0, common_1.assertParamExists)('wJUnbindProvider', 'provider', provider);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('wJUnbindProvider', 'body', body);
                    localVarPath = "/api/wj/user/{provider}/unbind"
                        .replace("{".concat("provider", "}"), encodeURIComponent(String(provider)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.WJApiAxiosParamCreator = WJApiAxiosParamCreator;
/**
 * WJApi - functional programming interface
 * @export
 */
var WJApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.WJApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 修改问卷用户头像和昵称
         * @param {string} id 用户id
         * @param {WjChangeUserInfoReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wJChangeUserInfo: function (id, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.wJChangeUserInfo(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wJGetUser: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.wJGetUser(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {WjRegisterUserByPhoneReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wJRegisterUserByPhone: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.wJRegisterUserByPhone(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 解绑指定类型的账号
         * @param {'TENCENT_MEETING' | 'WECHAT' | 'QQ' | 'RTX'} provider 解绑的账号类型
         * @param {WjUnbindProviderReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wJUnbindProvider: function (provider, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.wJUnbindProvider(provider, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.WJApiFp = WJApiFp;
/**
 * WJApi - factory interface
 * @export
 */
var WJApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.WJApiFp)(configuration);
    return {
        /**
         *
         * @summary 修改问卷用户头像和昵称
         * @param {string} id 用户id
         * @param {WjChangeUserInfoReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wJChangeUserInfo: function (id, body, options) {
            return localVarFp.wJChangeUserInfo(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wJGetUser: function (body, options) {
            return localVarFp.wJGetUser(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {WjRegisterUserByPhoneReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wJRegisterUserByPhone: function (body, options) {
            return localVarFp.wJRegisterUserByPhone(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 解绑指定类型的账号
         * @param {'TENCENT_MEETING' | 'WECHAT' | 'QQ' | 'RTX'} provider 解绑的账号类型
         * @param {WjUnbindProviderReq} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wJUnbindProvider: function (provider, body, options) {
            return localVarFp.wJUnbindProvider(provider, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.WJApiFactory = WJApiFactory;
/**
 * WJApi - object-oriented interface
 * @export
 * @class WJApi
 * @extends {BaseAPI}
 */
var WJApi = /** @class */ (function (_super) {
    __extends(WJApi, _super);
    function WJApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 修改问卷用户头像和昵称
     * @param {string} id 用户id
     * @param {WjChangeUserInfoReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WJApi
     */
    WJApi.prototype.wJChangeUserInfo = function (id, body, options) {
        var _this = this;
        return (0, exports.WJApiFp)(this.configuration).wJChangeUserInfo(id, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WJApi
     */
    WJApi.prototype.wJGetUser = function (body, options) {
        var _this = this;
        return (0, exports.WJApiFp)(this.configuration).wJGetUser(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {WjRegisterUserByPhoneReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WJApi
     */
    WJApi.prototype.wJRegisterUserByPhone = function (body, options) {
        var _this = this;
        return (0, exports.WJApiFp)(this.configuration).wJRegisterUserByPhone(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 解绑指定类型的账号
     * @param {'TENCENT_MEETING' | 'WECHAT' | 'QQ' | 'RTX'} provider 解绑的账号类型
     * @param {WjUnbindProviderReq} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WJApi
     */
    WJApi.prototype.wJUnbindProvider = function (provider, body, options) {
        var _this = this;
        return (0, exports.WJApiFp)(this.configuration).wJUnbindProvider(provider, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WJApi;
}(base_1.BaseAPI));
exports.WJApi = WJApi;
/**
 * ZhishuproxyApi - axios parameter creator
 * @export
 */
var ZhishuproxyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {ZhishuproxyZhishuproxyRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zhishuproxySendRequest: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('zhishuproxySendRequest', 'body', body);
                    localVarPath = "/api/zhishuproxy/sendRequest";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ZhishuproxyApiAxiosParamCreator = ZhishuproxyApiAxiosParamCreator;
/**
 * ZhishuproxyApi - functional programming interface
 * @export
 */
var ZhishuproxyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ZhishuproxyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ZhishuproxyZhishuproxyRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zhishuproxySendRequest: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.zhishuproxySendRequest(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ZhishuproxyApiFp = ZhishuproxyApiFp;
/**
 * ZhishuproxyApi - factory interface
 * @export
 */
var ZhishuproxyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ZhishuproxyApiFp)(configuration);
    return {
        /**
         *
         * @param {ZhishuproxyZhishuproxyRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zhishuproxySendRequest: function (body, options) {
            return localVarFp.zhishuproxySendRequest(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ZhishuproxyApiFactory = ZhishuproxyApiFactory;
/**
 * ZhishuproxyApi - object-oriented interface
 * @export
 * @class ZhishuproxyApi
 * @extends {BaseAPI}
 */
var ZhishuproxyApi = /** @class */ (function (_super) {
    __extends(ZhishuproxyApi, _super);
    function ZhishuproxyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {ZhishuproxyZhishuproxyRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZhishuproxyApi
     */
    ZhishuproxyApi.prototype.zhishuproxySendRequest = function (body, options) {
        var _this = this;
        return (0, exports.ZhishuproxyApiFp)(this.configuration).zhishuproxySendRequest(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ZhishuproxyApi;
}(base_1.BaseAPI));
exports.ZhishuproxyApi = ZhishuproxyApi;
